(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._tooltip_5svgn_1{width:260px}._popover_5svgn_5{background:var(--dixa-color-neutral-000);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-shadow:var(--dixa-effect-box-shadow-300);box-sizing:border-box;z-index:100}._bar_1n5dj_1{overflow:hidden}._section_1n5dj_5{position:relative}._sectionHidden_1n5dj_8{display:none!important}._sectionInheritRadius_1n5dj_11{border-radius:inherit}._valueOutside_1n5dj_15{position:absolute;left:calc(100% + var(--dixa-size-spacer-100));z-index:1}._container_1t2a7_1{overflow:hidden}._root_6kwn9_1{display:grid;column-gap:var(--dixa-size-spacer-200);row-gap:var(--dixa-size-spacer-300);white-space:nowrap}._root_6kwn9_1:not(._rootBounded_6kwn9_7):not(._rootFluid_6kwn9_7){grid-template-columns:repeat(auto-fit,minmax(min(100% / 2 - var(--dixa-size-spacer-200) * (2 - 1) / 2,max(96px,100% / 6 - var(--dixa-size-spacer-200) * (6 - 1) / 6)),1fr))}._rootFluid_6kwn9_7,._rootBounded_6kwn9_7{grid-template-columns:repeat(auto-fit,minmax(96px,1fr))}._rootBounded_6kwn9_7{max-width:calc(6 * 96px + var(--dixa-size-spacer-200) * (6 - 1))}._wrapper_1w7q6_1{display:inline-flex;align-self:flex-start}._text_1w7q6_6{font-size:var(--dixa-typography-size-600)}._colorIndicator_luubh_1{width:6px;height:6px;border-radius:50%;flex-shrink:0}._root_5qjlc_1{display:flex;flex-direction:column;gap:var(--dixa-size-spacer-300);padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);box-shadow:var(--dixa-effect-box-shadow-300);background-color:light-dark(var(--dixa-color-neutral-900),var(--dixa-color-neutral-200));color:light-dark(var(--dixa-color-neutral-000),var(--dixa-typography-color-primary))}._legendItem_j1yv3_34{flex-shrink:0;overflow:hidden;white-space:nowrap;cursor:pointer;opacity:1}._legendItemInactive_j1yv3_41{opacity:.4}._legendIcon_j1yv3_45{flex-shrink:0;width:12px;border-radius:var(--dixa-size-border-radius-50);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-sizing:border-box}._legendIconBar_j1yv3_52{height:12px}._legendIconLine_j1yv3_55{height:4px}._trigger_1mrk9_1{width:100%;height:100%}._cell_hfkay_1{display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;cursor:default;opacity:1;transition:opacity .2s ease-in-out}._cell_hfkay_1:hover ._cellText_hfkay_11{color:var(--dixa-typography-color-primary)}._cellDimmed_hfkay_14{opacity:var(--dixa-effect-opacity-200)}._cellContent_hfkay_18{display:flex;align-items:center;justify-content:center;width:100%;height:100%}._cellText_hfkay_11{transition:color .2s ease-in-out}._grid_1qk2p_1{display:grid;grid-auto-rows:minmax(var(--dixa-size-spacer-500),1fr);flex-grow:1}._row_1qk2p_7{display:grid;grid-auto-columns:1fr;grid-auto-flow:column;align-items:center;text-align:center}._legend_1myv8_34{position:relative}._trigger_1myv8_38{position:absolute;top:-50%;right:0}._popover_1myv8_44{width:256px;max-height:298px;padding:var(--dixa-size-spacer-300);z-index:100;box-sizing:border-box;background:var(--dixa-color-neutral-000);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-shadow:var(--dixa-effect-box-shadow-300);margin:0 var(--dixa-size-spacer-200);overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._breakdown_1myv8_63{display:flex;flex-direction:column;gap:var(--dixa-size-spacer-250);list-style:none;margin:0;padding:0}._breakdown_1myv8_63 li{display:grid;grid-template-columns:1fr auto;gap:var(--dixa-size-spacer-200)}._breakdown_1myv8_63 li>:first-child{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}._tooltip_h4i5v_1{max-width:300px}._trigger_h4i5v_5{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0}._tableWrapper_1xmkm_1{overflow:auto}._tableWrapperEmpty_1xmkm_4{flex-grow:1}._thCell_1xmkm_8{white-space:nowrap}._tdCell_1xmkm_12{position:relative;max-width:240px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}._tooltip_1xmkm_20{max-width:300px}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import * as D from "react";
import Yi, { useCallback as J, createContext as Ni, useMemo as Q, createElement as z, useContext as gl, forwardRef as ye, Children as ct, isValidElement as Zt, cloneElement as or, Fragment as ml, useEffect as ie, useRef as oe, useState as ee, useLayoutEffect as Xi, useReducer as Zf, memo as we } from "react";
import { IconButton as Ji, ButtonList as Rr, FlexBox as X, Text as G, Tooltip as Ot, Box as Zi, ButtonGroup as bl, Button as yl, EmptyState as _l, Divider as Qf, Table as Re, HelpIcon as ed, Pagination as td } from "@dixa/lib-shared-habla";
import * as rd from "react-dom";
import nd, { flushSync as xl } from "react-dom";
import $e from "classnames";
import { usePrevious as wl, useInterval as ad, useList as id, useUpdateEffect as At, useMap as od } from "react-use";
import { LabelList as sd, Cell as cd, ResponsiveContainer as ud, XAxis as ld, YAxis as fd, CartesianGrid as dd, ReferenceLine as hd, Label as vd, Legend as pd, Tooltip as gd, LineChart as md, BarChart as bd, Line as yd, Bar as _d } from "recharts";
import ke from "moment-timezone";
import { TagChips as xd } from "lib-shared-tagging";
var Nt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ee(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function wd(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var Ft = { exports: {} }, mt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mo;
function Rd() {
  if (Mo) return mt;
  Mo = 1;
  var e = Yi, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, c, u) {
    var f, l = {}, h = null, d = null;
    u !== void 0 && (h = "" + u), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (d = c.ref);
    for (f in c) n.call(c, f) && !i.hasOwnProperty(f) && (l[f] = c[f]);
    if (s && s.defaultProps) for (f in c = s.defaultProps, c) l[f] === void 0 && (l[f] = c[f]);
    return { $$typeof: t, type: s, key: h, ref: d, props: l, _owner: a.current };
  }
  return mt.Fragment = r, mt.jsx = o, mt.jsxs = o, mt;
}
var bt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Do;
function Cd() {
  return Do || (Do = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Yi, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), l = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), d = Symbol.for("react.offscreen"), g = Symbol.iterator, v = "@@iterator";
    function m(p) {
      if (p === null || typeof p != "object")
        return null;
      var A = g && p[g] || p[v];
      return typeof A == "function" ? A : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(p) {
      {
        for (var A = arguments.length, q = new Array(A > 1 ? A - 1 : 0), L = 1; L < A; L++)
          q[L - 1] = arguments[L];
        S("error", p, q);
      }
    }
    function S(p, A, q) {
      {
        var L = b.ReactDebugCurrentFrame, U = L.getStackAddendum();
        U !== "" && (A += "%s", q = q.concat([U]));
        var W = q.map(function(B) {
          return String(B);
        });
        W.unshift("Warning: " + A), Function.prototype.apply.call(console[p], console, W);
      }
    }
    var R = !1, P = !1, O = !1, T = !1, w = !1, x;
    x = Symbol.for("react.module.reference");
    function E(p) {
      return !!(typeof p == "string" || typeof p == "function" || p === n || p === i || w || p === a || p === u || p === f || T || p === d || R || P || O || typeof p == "object" && p !== null && (p.$$typeof === h || p.$$typeof === l || p.$$typeof === o || p.$$typeof === s || p.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      p.$$typeof === x || p.getModuleId !== void 0));
    }
    function C(p, A, q) {
      var L = p.displayName;
      if (L)
        return L;
      var U = A.displayName || A.name || "";
      return U !== "" ? q + "(" + U + ")" : q;
    }
    function j(p) {
      return p.displayName || "Context";
    }
    function $(p) {
      if (p == null)
        return null;
      if (typeof p.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof p == "function")
        return p.displayName || p.name || null;
      if (typeof p == "string")
        return p;
      switch (p) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case u:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof p == "object")
        switch (p.$$typeof) {
          case s:
            var A = p;
            return j(A) + ".Consumer";
          case o:
            var q = p;
            return j(q._context) + ".Provider";
          case c:
            return C(p, p.render, "ForwardRef");
          case l:
            var L = p.displayName || null;
            return L !== null ? L : $(p.type) || "Memo";
          case h: {
            var U = p, W = U._payload, B = U._init;
            try {
              return $(B(W));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var I = Object.assign, F = 0, M, V, N, H, Y, se, he;
    function ae() {
    }
    ae.__reactDisabledLog = !0;
    function ce() {
      {
        if (F === 0) {
          M = console.log, V = console.info, N = console.warn, H = console.error, Y = console.group, se = console.groupCollapsed, he = console.groupEnd;
          var p = {
            configurable: !0,
            enumerable: !0,
            value: ae,
            writable: !0
          };
          Object.defineProperties(console, {
            info: p,
            log: p,
            warn: p,
            error: p,
            group: p,
            groupCollapsed: p,
            groupEnd: p
          });
        }
        F++;
      }
    }
    function ue() {
      {
        if (F--, F === 0) {
          var p = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: I({}, p, {
              value: M
            }),
            info: I({}, p, {
              value: V
            }),
            warn: I({}, p, {
              value: N
            }),
            error: I({}, p, {
              value: H
            }),
            group: I({}, p, {
              value: Y
            }),
            groupCollapsed: I({}, p, {
              value: se
            }),
            groupEnd: I({}, p, {
              value: he
            })
          });
        }
        F < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var K = b.ReactCurrentDispatcher, le;
    function ne(p, A, q) {
      {
        if (le === void 0)
          try {
            throw Error();
          } catch (U) {
            var L = U.stack.trim().match(/\n( *(at )?)/);
            le = L && L[1] || "";
          }
        return `
` + le + p;
      }
    }
    var te = !1, ve;
    {
      var Ae = typeof WeakMap == "function" ? WeakMap : Map;
      ve = new Ae();
    }
    function Ne(p, A) {
      if (!p || te)
        return "";
      {
        var q = ve.get(p);
        if (q !== void 0)
          return q;
      }
      var L;
      te = !0;
      var U = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var W;
      W = K.current, K.current = null, ce();
      try {
        if (A) {
          var B = function() {
            throw Error();
          };
          if (Object.defineProperty(B.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(B, []);
            } catch (ge) {
              L = ge;
            }
            Reflect.construct(p, [], B);
          } else {
            try {
              B.call();
            } catch (ge) {
              L = ge;
            }
            p.call(B.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ge) {
            L = ge;
          }
          p();
        }
      } catch (ge) {
        if (ge && L && typeof ge.stack == "string") {
          for (var k = ge.stack.split(`
`), de = L.stack.split(`
`), Z = k.length - 1, re = de.length - 1; Z >= 1 && re >= 0 && k[Z] !== de[re]; )
            re--;
          for (; Z >= 1 && re >= 0; Z--, re--)
            if (k[Z] !== de[re]) {
              if (Z !== 1 || re !== 1)
                do
                  if (Z--, re--, re < 0 || k[Z] !== de[re]) {
                    var _e = `
` + k[Z].replace(" at new ", " at ");
                    return p.displayName && _e.includes("<anonymous>") && (_e = _e.replace("<anonymous>", p.displayName)), typeof p == "function" && ve.set(p, _e), _e;
                  }
                while (Z >= 1 && re >= 0);
              break;
            }
        }
      } finally {
        te = !1, K.current = W, ue(), Error.prepareStackTrace = U;
      }
      var nt = p ? p.displayName || p.name : "", ze = nt ? ne(nt) : "";
      return typeof p == "function" && ve.set(p, ze), ze;
    }
    function pe(p, A, q) {
      return Ne(p, !1);
    }
    function Te(p) {
      var A = p.prototype;
      return !!(A && A.isReactComponent);
    }
    function fe(p, A, q) {
      if (p == null)
        return "";
      if (typeof p == "function")
        return Ne(p, Te(p));
      if (typeof p == "string")
        return ne(p);
      switch (p) {
        case u:
          return ne("Suspense");
        case f:
          return ne("SuspenseList");
      }
      if (typeof p == "object")
        switch (p.$$typeof) {
          case c:
            return pe(p.render);
          case l:
            return fe(p.type, A, q);
          case h: {
            var L = p, U = L._payload, W = L._init;
            try {
              return fe(W(U), A, q);
            } catch {
            }
          }
        }
      return "";
    }
    var Fe = Object.prototype.hasOwnProperty, Mt = {}, Dt = b.ReactDebugCurrentFrame;
    function et(p) {
      if (p) {
        var A = p._owner, q = fe(p.type, p._source, A ? A.type : null);
        Dt.setExtraStackFrame(q);
      } else
        Dt.setExtraStackFrame(null);
    }
    function mr(p, A, q, L, U) {
      {
        var W = Function.call.bind(Fe);
        for (var B in p)
          if (W(p, B)) {
            var k = void 0;
            try {
              if (typeof p[B] != "function") {
                var de = Error((L || "React class") + ": " + q + " type `" + B + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof p[B] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw de.name = "Invariant Violation", de;
              }
              k = p[B](A, B, L, q, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Z) {
              k = Z;
            }
            k && !(k instanceof Error) && (et(U), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", L || "React class", q, B, typeof k), et(null)), k instanceof Error && !(k.message in Mt) && (Mt[k.message] = !0, et(U), y("Failed %s type: %s", q, k.message), et(null));
          }
      }
    }
    var tt = Array.isArray;
    function br(p) {
      return tt(p);
    }
    function qf(p) {
      {
        var A = typeof Symbol == "function" && Symbol.toStringTag, q = A && p[Symbol.toStringTag] || p.constructor.name || "Object";
        return q;
      }
    }
    function jf(p) {
      try {
        return Ro(p), !1;
      } catch {
        return !0;
      }
    }
    function Ro(p) {
      return "" + p;
    }
    function Co(p) {
      if (jf(p))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", qf(p)), Ro(p);
    }
    var So = b.ReactCurrentOwner, If = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Po, Eo;
    function Mf(p) {
      if (Fe.call(p, "ref")) {
        var A = Object.getOwnPropertyDescriptor(p, "ref").get;
        if (A && A.isReactWarning)
          return !1;
      }
      return p.ref !== void 0;
    }
    function Df(p) {
      if (Fe.call(p, "key")) {
        var A = Object.getOwnPropertyDescriptor(p, "key").get;
        if (A && A.isReactWarning)
          return !1;
      }
      return p.key !== void 0;
    }
    function Nf(p, A) {
      typeof p.ref == "string" && So.current;
    }
    function Ff(p, A) {
      {
        var q = function() {
          Po || (Po = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", A));
        };
        q.isReactWarning = !0, Object.defineProperty(p, "key", {
          get: q,
          configurable: !0
        });
      }
    }
    function Lf(p, A) {
      {
        var q = function() {
          Eo || (Eo = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", A));
        };
        q.isReactWarning = !0, Object.defineProperty(p, "ref", {
          get: q,
          configurable: !0
        });
      }
    }
    var kf = function(p, A, q, L, U, W, B) {
      var k = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: p,
        key: A,
        ref: q,
        props: B,
        // Record the component responsible for creating this element.
        _owner: W
      };
      return k._store = {}, Object.defineProperty(k._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(k, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: L
      }), Object.defineProperty(k, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: U
      }), Object.freeze && (Object.freeze(k.props), Object.freeze(k)), k;
    };
    function Bf(p, A, q, L, U) {
      {
        var W, B = {}, k = null, de = null;
        q !== void 0 && (Co(q), k = "" + q), Df(A) && (Co(A.key), k = "" + A.key), Mf(A) && (de = A.ref, Nf(A, U));
        for (W in A)
          Fe.call(A, W) && !If.hasOwnProperty(W) && (B[W] = A[W]);
        if (p && p.defaultProps) {
          var Z = p.defaultProps;
          for (W in Z)
            B[W] === void 0 && (B[W] = Z[W]);
        }
        if (k || de) {
          var re = typeof p == "function" ? p.displayName || p.name || "Unknown" : p;
          k && Ff(B, re), de && Lf(B, re);
        }
        return kf(p, k, de, U, L, So.current, B);
      }
    }
    var yr = b.ReactCurrentOwner, Oo = b.ReactDebugCurrentFrame;
    function rt(p) {
      if (p) {
        var A = p._owner, q = fe(p.type, p._source, A ? A.type : null);
        Oo.setExtraStackFrame(q);
      } else
        Oo.setExtraStackFrame(null);
    }
    var _r;
    _r = !1;
    function xr(p) {
      return typeof p == "object" && p !== null && p.$$typeof === t;
    }
    function Ao() {
      {
        if (yr.current) {
          var p = $(yr.current.type);
          if (p)
            return `

Check the render method of \`` + p + "`.";
        }
        return "";
      }
    }
    function Vf(p) {
      return "";
    }
    var To = {};
    function Hf(p) {
      {
        var A = Ao();
        if (!A) {
          var q = typeof p == "string" ? p : p.displayName || p.name;
          q && (A = `

Check the top-level render call using <` + q + ">.");
        }
        return A;
      }
    }
    function $o(p, A) {
      {
        if (!p._store || p._store.validated || p.key != null)
          return;
        p._store.validated = !0;
        var q = Hf(A);
        if (To[q])
          return;
        To[q] = !0;
        var L = "";
        p && p._owner && p._owner !== yr.current && (L = " It was passed a child from " + $(p._owner.type) + "."), rt(p), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', q, L), rt(null);
      }
    }
    function qo(p, A) {
      {
        if (typeof p != "object")
          return;
        if (br(p))
          for (var q = 0; q < p.length; q++) {
            var L = p[q];
            xr(L) && $o(L, A);
          }
        else if (xr(p))
          p._store && (p._store.validated = !0);
        else if (p) {
          var U = m(p);
          if (typeof U == "function" && U !== p.entries)
            for (var W = U.call(p), B; !(B = W.next()).done; )
              xr(B.value) && $o(B.value, A);
        }
      }
    }
    function Uf(p) {
      {
        var A = p.type;
        if (A == null || typeof A == "string")
          return;
        var q;
        if (typeof A == "function")
          q = A.propTypes;
        else if (typeof A == "object" && (A.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        A.$$typeof === l))
          q = A.propTypes;
        else
          return;
        if (q) {
          var L = $(A);
          mr(q, p.props, "prop", L, p);
        } else if (A.PropTypes !== void 0 && !_r) {
          _r = !0;
          var U = $(A);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", U || "Unknown");
        }
        typeof A.getDefaultProps == "function" && !A.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function zf(p) {
      {
        for (var A = Object.keys(p.props), q = 0; q < A.length; q++) {
          var L = A[q];
          if (L !== "children" && L !== "key") {
            rt(p), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", L), rt(null);
            break;
          }
        }
        p.ref !== null && (rt(p), y("Invalid attribute `ref` supplied to `React.Fragment`."), rt(null));
      }
    }
    var jo = {};
    function Io(p, A, q, L, U, W) {
      {
        var B = E(p);
        if (!B) {
          var k = "";
          (p === void 0 || typeof p == "object" && p !== null && Object.keys(p).length === 0) && (k += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var de = Vf();
          de ? k += de : k += Ao();
          var Z;
          p === null ? Z = "null" : br(p) ? Z = "array" : p !== void 0 && p.$$typeof === t ? (Z = "<" + ($(p.type) || "Unknown") + " />", k = " Did you accidentally export a JSX literal instead of a component?") : Z = typeof p, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Z, k);
        }
        var re = Bf(p, A, q, U, W);
        if (re == null)
          return re;
        if (B) {
          var _e = A.children;
          if (_e !== void 0)
            if (L)
              if (br(_e)) {
                for (var nt = 0; nt < _e.length; nt++)
                  qo(_e[nt], p);
                Object.freeze && Object.freeze(_e);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              qo(_e, p);
        }
        if (Fe.call(A, "key")) {
          var ze = $(p), ge = Object.keys(A).filter(function(Jf) {
            return Jf !== "key";
          }), wr = ge.length > 0 ? "{key: someKey, " + ge.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!jo[ze + wr]) {
            var Xf = ge.length > 0 ? "{" + ge.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, wr, ze, Xf, ze), jo[ze + wr] = !0;
          }
        }
        return p === n ? zf(re) : Uf(re), re;
      }
    }
    function Wf(p, A, q) {
      return Io(p, A, q, !0);
    }
    function Gf(p, A, q) {
      return Io(p, A, q, !1);
    }
    var Kf = Gf, Yf = Wf;
    bt.Fragment = n, bt.jsx = Kf, bt.jsxs = Yf;
  }()), bt;
}
var No;
function Sd() {
  return No || (No = 1, process.env.NODE_ENV === "production" ? Ft.exports = Rd() : Ft.exports = Cd()), Ft.exports;
}
var _ = Sd();
function qe() {
  return qe = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qe.apply(this, arguments);
}
function We(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), r === !1 || !a.defaultPrevented) return t == null ? void 0 : t(a);
  };
}
function Pd(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Rl(...e) {
  return (t) => e.forEach(
    (r) => Pd(r, t)
  );
}
function Ye(...e) {
  return J(Rl(...e), e);
}
function Cl(e, t = []) {
  let r = [];
  function n(i, o) {
    const s = /* @__PURE__ */ Ni(o), c = r.length;
    r = [
      ...r,
      o
    ];
    function u(l) {
      const { scope: h, children: d, ...g } = l, v = (h == null ? void 0 : h[e][c]) || s, m = Q(
        () => g,
        Object.values(g)
      );
      return /* @__PURE__ */ z(v.Provider, {
        value: m
      }, d);
    }
    function f(l, h) {
      const d = (h == null ? void 0 : h[e][c]) || s, g = gl(d);
      if (g) return g;
      if (o !== void 0) return o;
      throw new Error(`\`${l}\` must be used within \`${i}\``);
    }
    return u.displayName = i + "Provider", [
      u,
      f
    ];
  }
  const a = () => {
    const i = r.map((o) => /* @__PURE__ */ Ni(o));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || i;
      return Q(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: c
          }
        }),
        [
          s,
          c
        ]
      );
    };
  };
  return a.scopeName = e, [
    n,
    Ed(a, ...t)
  ];
}
function Ed(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map(
      (a) => ({
        useScope: a(),
        scopeName: a.scopeName
      })
    );
    return function(i) {
      const o = n.reduce((s, { useScope: c, scopeName: u }) => {
        const l = c(i)[`__scope${u}`];
        return {
          ...s,
          ...l
        };
      }, {});
      return Q(
        () => ({
          [`__scope${t.scopeName}`]: o
        }),
        [
          o
        ]
      );
    };
  };
  return r.scopeName = t.scopeName, r;
}
function Fi() {
  return Fi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fi.apply(this, arguments);
}
function Li() {
  return Li = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Li.apply(this, arguments);
}
function Qt() {
  return Qt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Qt.apply(this, arguments);
}
const Qi = /* @__PURE__ */ ye((e, t) => {
  const { children: r, ...n } = e, a = ct.toArray(r), i = a.find(Ad);
  if (i) {
    const o = i.props.children, s = a.map((c) => c === i ? ct.count(o) > 1 ? ct.only(null) : /* @__PURE__ */ Zt(o) ? o.props.children : null : c);
    return /* @__PURE__ */ z(ki, Qt({}, n, {
      ref: t
    }), /* @__PURE__ */ Zt(o) ? /* @__PURE__ */ or(o, void 0, s) : null);
  }
  return /* @__PURE__ */ z(ki, Qt({}, n, {
    ref: t
  }), r);
});
Qi.displayName = "Slot";
const ki = /* @__PURE__ */ ye((e, t) => {
  const { children: r, ...n } = e;
  return /* @__PURE__ */ Zt(r) ? /* @__PURE__ */ or(r, {
    ...Td(n, r.props),
    ref: t ? Rl(t, r.ref) : r.ref
  }) : ct.count(r) > 1 ? ct.only(null) : null;
});
ki.displayName = "SlotClone";
const Od = ({ children: e }) => /* @__PURE__ */ z(ml, null, e);
function Ad(e) {
  return /* @__PURE__ */ Zt(e) && e.type === Od;
}
function Td(e, t) {
  const r = {
    ...t
  };
  for (const n in t) {
    const a = e[n], i = t[n];
    /^on[A-Z]/.test(n) ? a && i ? r[n] = (...s) => {
      i(...s), a(...s);
    } : a && (r[n] = a) : n === "style" ? r[n] = {
      ...a,
      ...i
    } : n === "className" && (r[n] = [
      a,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...r
  };
}
const $d = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ht = $d.reduce((e, t) => {
  const r = /* @__PURE__ */ ye((n, a) => {
    const { asChild: i, ...o } = n, s = i ? Qi : t;
    return ie(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ z(s, Li({}, o, {
      ref: a
    }));
  });
  return r.displayName = `Primitive.${t}`, {
    ...e,
    [t]: r
  };
}, {});
function qd(e, t) {
  e && xl(
    () => e.dispatchEvent(t)
  );
}
function Be(e) {
  const t = oe(e);
  return ie(() => {
    t.current = e;
  }), Q(
    () => (...r) => {
      var n;
      return (n = t.current) === null || n === void 0 ? void 0 : n.call(t, ...r);
    },
    []
  );
}
function jd(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = Be(e);
  ie(() => {
    const n = (a) => {
      a.key === "Escape" && r(a);
    };
    return t.addEventListener("keydown", n), () => t.removeEventListener("keydown", n);
  }, [
    r,
    t
  ]);
}
const Bi = "dismissableLayer.update", Id = "dismissableLayer.pointerDownOutside", Md = "dismissableLayer.focusOutside";
let Fo;
const Dd = /* @__PURE__ */ Ni({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Nd = /* @__PURE__ */ ye((e, t) => {
  var r;
  const { disableOutsidePointerEvents: n = !1, onEscapeKeyDown: a, onPointerDownOutside: i, onFocusOutside: o, onInteractOutside: s, onDismiss: c, ...u } = e, f = gl(Dd), [l, h] = ee(null), d = (r = l == null ? void 0 : l.ownerDocument) !== null && r !== void 0 ? r : globalThis == null ? void 0 : globalThis.document, [, g] = ee({}), v = Ye(
    t,
    (w) => h(w)
  ), m = Array.from(f.layers), [b] = [
    ...f.layersWithOutsidePointerEventsDisabled
  ].slice(-1), y = m.indexOf(b), S = l ? m.indexOf(l) : -1, R = f.layersWithOutsidePointerEventsDisabled.size > 0, P = S >= y, O = Fd((w) => {
    const x = w.target, E = [
      ...f.branches
    ].some(
      (C) => C.contains(x)
    );
    !P || E || (i == null || i(w), s == null || s(w), w.defaultPrevented || c == null || c());
  }, d), T = Ld((w) => {
    const x = w.target;
    [
      ...f.branches
    ].some(
      (C) => C.contains(x)
    ) || (o == null || o(w), s == null || s(w), w.defaultPrevented || c == null || c());
  }, d);
  return jd((w) => {
    S === f.layers.size - 1 && (a == null || a(w), !w.defaultPrevented && c && (w.preventDefault(), c()));
  }, d), ie(() => {
    if (l)
      return n && (f.layersWithOutsidePointerEventsDisabled.size === 0 && (Fo = d.body.style.pointerEvents, d.body.style.pointerEvents = "none"), f.layersWithOutsidePointerEventsDisabled.add(l)), f.layers.add(l), Lo(), () => {
        n && f.layersWithOutsidePointerEventsDisabled.size === 1 && (d.body.style.pointerEvents = Fo);
      };
  }, [
    l,
    d,
    n,
    f
  ]), ie(() => () => {
    l && (f.layers.delete(l), f.layersWithOutsidePointerEventsDisabled.delete(l), Lo());
  }, [
    l,
    f
  ]), ie(() => {
    const w = () => g({});
    return document.addEventListener(Bi, w), () => document.removeEventListener(Bi, w);
  }, []), /* @__PURE__ */ z(ht.div, Fi({}, u, {
    ref: v,
    style: {
      pointerEvents: R ? P ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: We(e.onFocusCapture, T.onFocusCapture),
    onBlurCapture: We(e.onBlurCapture, T.onBlurCapture),
    onPointerDownCapture: We(e.onPointerDownCapture, O.onPointerDownCapture)
  }));
});
function Fd(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = Be(e), n = oe(!1), a = oe(() => {
  });
  return ie(() => {
    const i = (s) => {
      if (s.target && !n.current) {
        let u = function() {
          Sl(Id, r, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = u, t.addEventListener("click", a.current, {
          once: !0
        })) : u();
      } else
        t.removeEventListener("click", a.current);
      n.current = !1;
    }, o = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(o), t.removeEventListener("pointerdown", i), t.removeEventListener("click", a.current);
    };
  }, [
    t,
    r
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function Ld(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = Be(e), n = oe(!1);
  return ie(() => {
    const a = (i) => {
      i.target && !n.current && Sl(Md, r, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [
    t,
    r
  ]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function Lo() {
  const e = new CustomEvent(Bi);
  document.dispatchEvent(e);
}
function Sl(e, t, r, { discrete: n }) {
  const a = r.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: r
  });
  t && a.addEventListener(e, t, {
    once: !0
  }), n ? qd(a, i) : a.dispatchEvent(i);
}
let Cr = 0;
function kd() {
  ie(() => {
    var e, t;
    const r = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = r[0]) !== null && e !== void 0 ? e : ko()), document.body.insertAdjacentElement("beforeend", (t = r[1]) !== null && t !== void 0 ? t : ko()), Cr++, () => {
      Cr === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (n) => n.remove()
      ), Cr--;
    };
  }, []);
}
function ko() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
function Vi() {
  return Vi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Vi.apply(this, arguments);
}
const Sr = "focusScope.autoFocusOnMount", Pr = "focusScope.autoFocusOnUnmount", Bo = {
  bubbles: !1,
  cancelable: !0
}, Bd = /* @__PURE__ */ ye((e, t) => {
  const { loop: r = !1, trapped: n = !1, onMountAutoFocus: a, onUnmountAutoFocus: i, ...o } = e, [s, c] = ee(null), u = Be(a), f = Be(i), l = oe(null), h = Ye(
    t,
    (v) => c(v)
  ), d = oe({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  ie(() => {
    if (n) {
      let v = function(S) {
        if (d.paused || !s) return;
        const R = S.target;
        s.contains(R) ? l.current = R : Le(l.current, {
          select: !0
        });
      }, m = function(S) {
        if (d.paused || !s) return;
        const R = S.relatedTarget;
        R !== null && (s.contains(R) || Le(l.current, {
          select: !0
        }));
      }, b = function(S) {
        if (document.activeElement === document.body)
          for (const P of S) P.removedNodes.length > 0 && Le(s);
      };
      document.addEventListener("focusin", v), document.addEventListener("focusout", m);
      const y = new MutationObserver(b);
      return s && y.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", v), document.removeEventListener("focusout", m), y.disconnect();
      };
    }
  }, [
    n,
    s,
    d.paused
  ]), ie(() => {
    if (s) {
      Ho.add(d);
      const v = document.activeElement;
      if (!s.contains(v)) {
        const b = new CustomEvent(Sr, Bo);
        s.addEventListener(Sr, u), s.dispatchEvent(b), b.defaultPrevented || (Vd(Gd(Pl(s)), {
          select: !0
        }), document.activeElement === v && Le(s));
      }
      return () => {
        s.removeEventListener(Sr, u), setTimeout(() => {
          const b = new CustomEvent(Pr, Bo);
          s.addEventListener(Pr, f), s.dispatchEvent(b), b.defaultPrevented || Le(v ?? document.body, {
            select: !0
          }), s.removeEventListener(Pr, f), Ho.remove(d);
        }, 0);
      };
    }
  }, [
    s,
    u,
    f,
    d
  ]);
  const g = J((v) => {
    if (!r && !n || d.paused) return;
    const m = v.key === "Tab" && !v.altKey && !v.ctrlKey && !v.metaKey, b = document.activeElement;
    if (m && b) {
      const y = v.currentTarget, [S, R] = Hd(y);
      S && R ? !v.shiftKey && b === R ? (v.preventDefault(), r && Le(S, {
        select: !0
      })) : v.shiftKey && b === S && (v.preventDefault(), r && Le(R, {
        select: !0
      })) : b === y && v.preventDefault();
    }
  }, [
    r,
    n,
    d.paused
  ]);
  return /* @__PURE__ */ z(ht.div, Vi({
    tabIndex: -1
  }, o, {
    ref: h,
    onKeyDown: g
  }));
});
function Vd(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const n of e)
    if (Le(n, {
      select: t
    }), document.activeElement !== r) return;
}
function Hd(e) {
  const t = Pl(e), r = Vo(t, e), n = Vo(t.reverse(), e);
  return [
    r,
    n
  ];
}
function Pl(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const a = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || a ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function Vo(e, t) {
  for (const r of e)
    if (!Ud(r, {
      upTo: t
    })) return r;
}
function Ud(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function zd(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Le(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== r && zd(e) && t && e.select();
  }
}
const Ho = Wd();
function Wd() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && (r == null || r.pause()), e = Uo(e, t), e.unshift(t);
    },
    remove(t) {
      var r;
      e = Uo(e, t), (r = e[0]) === null || r === void 0 || r.resume();
    }
  };
}
function Uo(e, t) {
  const r = [
    ...e
  ], n = r.indexOf(t);
  return n !== -1 && r.splice(n, 1), r;
}
function Gd(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const ft = globalThis != null && globalThis.document ? Xi : () => {
}, Kd = D.useId || (() => {
});
let Yd = 0;
function Xd(e) {
  const [t, r] = D.useState(Kd());
  return ft(() => {
    r(
      (n) => n ?? String(Yd++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
function er() {
  return er = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, er.apply(this, arguments);
}
const Jd = ["top", "right", "bottom", "left"], Ve = Math.min, me = Math.max, tr = Math.round, Lt = Math.floor, He = (e) => ({
  x: e,
  y: e
}), Zd = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Qd = {
  start: "end",
  end: "start"
};
function Hi(e, t, r) {
  return me(e, Ve(t, r));
}
function je(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ie(e) {
  return e.split("-")[0];
}
function vt(e) {
  return e.split("-")[1];
}
function eo(e) {
  return e === "x" ? "y" : "x";
}
function to(e) {
  return e === "y" ? "height" : "width";
}
function pt(e) {
  return ["top", "bottom"].includes(Ie(e)) ? "y" : "x";
}
function ro(e) {
  return eo(pt(e));
}
function eh(e, t, r) {
  r === void 0 && (r = !1);
  const n = vt(e), a = ro(e), i = to(a);
  let o = a === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (o = rr(o)), [o, rr(o)];
}
function th(e) {
  const t = rr(e);
  return [Ui(e), t, Ui(t)];
}
function Ui(e) {
  return e.replace(/start|end/g, (t) => Qd[t]);
}
function rh(e, t, r) {
  const n = ["left", "right"], a = ["right", "left"], i = ["top", "bottom"], o = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? a : n : t ? n : a;
    case "left":
    case "right":
      return t ? i : o;
    default:
      return [];
  }
}
function nh(e, t, r, n) {
  const a = vt(e);
  let i = rh(Ie(e), r === "start", n);
  return a && (i = i.map((o) => o + "-" + a), t && (i = i.concat(i.map(Ui)))), i;
}
function rr(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Zd[t]);
}
function ah(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function El(e) {
  return typeof e != "number" ? ah(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function nr(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function zo(e, t, r) {
  let {
    reference: n,
    floating: a
  } = e;
  const i = pt(t), o = ro(t), s = to(o), c = Ie(t), u = i === "y", f = n.x + n.width / 2 - a.width / 2, l = n.y + n.height / 2 - a.height / 2, h = n[s] / 2 - a[s] / 2;
  let d;
  switch (c) {
    case "top":
      d = {
        x: f,
        y: n.y - a.height
      };
      break;
    case "bottom":
      d = {
        x: f,
        y: n.y + n.height
      };
      break;
    case "right":
      d = {
        x: n.x + n.width,
        y: l
      };
      break;
    case "left":
      d = {
        x: n.x - a.width,
        y: l
      };
      break;
    default:
      d = {
        x: n.x,
        y: n.y
      };
  }
  switch (vt(t)) {
    case "start":
      d[o] -= h * (r && u ? -1 : 1);
      break;
    case "end":
      d[o] += h * (r && u ? -1 : 1);
      break;
  }
  return d;
}
const ih = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: a = "absolute",
    middleware: i = [],
    platform: o
  } = r, s = i.filter(Boolean), c = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let u = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: f,
    y: l
  } = zo(u, n, c), h = n, d = {}, g = 0;
  for (let v = 0; v < s.length; v++) {
    const {
      name: m,
      fn: b
    } = s[v], {
      x: y,
      y: S,
      data: R,
      reset: P
    } = await b({
      x: f,
      y: l,
      initialPlacement: n,
      placement: h,
      strategy: a,
      middlewareData: d,
      rects: u,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (f = y ?? f, l = S ?? l, d = {
      ...d,
      [m]: {
        ...d[m],
        ...R
      }
    }, P && g <= 50) {
      g++, typeof P == "object" && (P.placement && (h = P.placement), P.rects && (u = P.rects === !0 ? await o.getElementRects({
        reference: e,
        floating: t,
        strategy: a
      }) : P.rects), {
        x: f,
        y: l
      } = zo(u, h, c)), v = -1;
      continue;
    }
  }
  return {
    x: f,
    y: l,
    placement: h,
    strategy: a,
    middlewareData: d
  };
};
async function St(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: a,
    platform: i,
    rects: o,
    elements: s,
    strategy: c
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: l = "floating",
    altBoundary: h = !1,
    padding: d = 0
  } = je(t, e), g = El(d), m = s[h ? l === "floating" ? "reference" : "floating" : l], b = nr(await i.getClippingRect({
    element: (r = await (i.isElement == null ? void 0 : i.isElement(m))) == null || r ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: f,
    strategy: c
  })), y = l === "floating" ? {
    ...o.floating,
    x: n,
    y: a
  } : o.reference, S = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), R = await (i.isElement == null ? void 0 : i.isElement(S)) ? await (i.getScale == null ? void 0 : i.getScale(S)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, P = nr(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: y,
    offsetParent: S,
    strategy: c
  }) : y);
  return {
    top: (b.top - P.top + g.top) / R.y,
    bottom: (P.bottom - b.bottom + g.bottom) / R.y,
    left: (b.left - P.left + g.left) / R.x,
    right: (P.right - b.right + g.right) / R.x
  };
}
const Wo = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: n,
      placement: a,
      rects: i,
      platform: o,
      elements: s
    } = t, {
      element: c,
      padding: u = 0
    } = je(e, t) || {};
    if (c == null)
      return {};
    const f = El(u), l = {
      x: r,
      y: n
    }, h = ro(a), d = to(h), g = await o.getDimensions(c), v = h === "y", m = v ? "top" : "left", b = v ? "bottom" : "right", y = v ? "clientHeight" : "clientWidth", S = i.reference[d] + i.reference[h] - l[h] - i.floating[d], R = l[h] - i.reference[h], P = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(c));
    let O = P ? P[y] : 0;
    (!O || !await (o.isElement == null ? void 0 : o.isElement(P))) && (O = s.floating[y] || i.floating[d]);
    const T = S / 2 - R / 2, w = O / 2 - g[d] / 2 - 1, x = Ve(f[m], w), E = Ve(f[b], w), C = x, j = O - g[d] - E, $ = O / 2 - g[d] / 2 + T, I = Hi(C, $, j), M = vt(a) != null && $ != I && i.reference[d] / 2 - ($ < C ? x : E) - g[d] / 2 < 0 ? $ < C ? C - $ : j - $ : 0;
    return {
      [h]: l[h] - M,
      data: {
        [h]: I,
        centerOffset: $ - I + M
      }
    };
  }
}), oh = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r;
      const {
        placement: n,
        middlewareData: a,
        rects: i,
        initialPlacement: o,
        platform: s,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: f = !0,
        fallbackPlacements: l,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: d = "none",
        flipAlignment: g = !0,
        ...v
      } = je(e, t), m = Ie(n), b = Ie(o) === o, y = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), S = l || (b || !g ? [rr(o)] : th(o));
      !l && d !== "none" && S.push(...nh(o, g, d, y));
      const R = [o, ...S], P = await St(t, v), O = [];
      let T = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (u && O.push(P[m]), f) {
        const C = eh(n, i, y);
        O.push(P[C[0]], P[C[1]]);
      }
      if (T = [...T, {
        placement: n,
        overflows: O
      }], !O.every((C) => C <= 0)) {
        var w, x;
        const C = (((w = a.flip) == null ? void 0 : w.index) || 0) + 1, j = R[C];
        if (j)
          return {
            data: {
              index: C,
              overflows: T
            },
            reset: {
              placement: j
            }
          };
        let $ = (x = T.filter((I) => I.overflows[0] <= 0).sort((I, F) => I.overflows[1] - F.overflows[1])[0]) == null ? void 0 : x.placement;
        if (!$)
          switch (h) {
            case "bestFit": {
              var E;
              const I = (E = T.map((F) => [F.placement, F.overflows.filter((M) => M > 0).reduce((M, V) => M + V, 0)]).sort((F, M) => F[1] - M[1])[0]) == null ? void 0 : E[0];
              I && ($ = I);
              break;
            }
            case "initialPlacement":
              $ = o;
              break;
          }
        if (n !== $)
          return {
            reset: {
              placement: $
            }
          };
      }
      return {};
    }
  };
};
function Go(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Ko(e) {
  return Jd.some((t) => e[t] >= 0);
}
const sh = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: r
      } = t, {
        strategy: n = "referenceHidden",
        ...a
      } = je(e, t);
      switch (n) {
        case "referenceHidden": {
          const i = await St(t, {
            ...a,
            elementContext: "reference"
          }), o = Go(i, r.reference);
          return {
            data: {
              referenceHiddenOffsets: o,
              referenceHidden: Ko(o)
            }
          };
        }
        case "escaped": {
          const i = await St(t, {
            ...a,
            altBoundary: !0
          }), o = Go(i, r.floating);
          return {
            data: {
              escapedOffsets: o,
              escaped: Ko(o)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function ch(e, t) {
  const {
    placement: r,
    platform: n,
    elements: a
  } = e, i = await (n.isRTL == null ? void 0 : n.isRTL(a.floating)), o = Ie(r), s = vt(r), c = pt(r) === "y", u = ["left", "top"].includes(o) ? -1 : 1, f = i && c ? -1 : 1, l = je(t, e);
  let {
    mainAxis: h,
    crossAxis: d,
    alignmentAxis: g
  } = typeof l == "number" ? {
    mainAxis: l,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...l
  };
  return s && typeof g == "number" && (d = s === "end" ? g * -1 : g), c ? {
    x: d * f,
    y: h * u
  } : {
    x: h * u,
    y: d * f
  };
}
const uh = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n
      } = t, a = await ch(t, e);
      return {
        x: r + a.x,
        y: n + a.y,
        data: a
      };
    }
  };
}, lh = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: a
      } = t, {
        mainAxis: i = !0,
        crossAxis: o = !1,
        limiter: s = {
          fn: (m) => {
            let {
              x: b,
              y
            } = m;
            return {
              x: b,
              y
            };
          }
        },
        ...c
      } = je(e, t), u = {
        x: r,
        y: n
      }, f = await St(t, c), l = pt(Ie(a)), h = eo(l);
      let d = u[h], g = u[l];
      if (i) {
        const m = h === "y" ? "top" : "left", b = h === "y" ? "bottom" : "right", y = d + f[m], S = d - f[b];
        d = Hi(y, d, S);
      }
      if (o) {
        const m = l === "y" ? "top" : "left", b = l === "y" ? "bottom" : "right", y = g + f[m], S = g - f[b];
        g = Hi(y, g, S);
      }
      const v = s.fn({
        ...t,
        [h]: d,
        [l]: g
      });
      return {
        ...v,
        data: {
          x: v.x - r,
          y: v.y - n
        }
      };
    }
  };
}, fh = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: r,
        y: n,
        placement: a,
        rects: i,
        middlewareData: o
      } = t, {
        offset: s = 0,
        mainAxis: c = !0,
        crossAxis: u = !0
      } = je(e, t), f = {
        x: r,
        y: n
      }, l = pt(a), h = eo(l);
      let d = f[h], g = f[l];
      const v = je(s, t), m = typeof v == "number" ? {
        mainAxis: v,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...v
      };
      if (c) {
        const S = h === "y" ? "height" : "width", R = i.reference[h] - i.floating[S] + m.mainAxis, P = i.reference[h] + i.reference[S] - m.mainAxis;
        d < R ? d = R : d > P && (d = P);
      }
      if (u) {
        var b, y;
        const S = h === "y" ? "width" : "height", R = ["top", "left"].includes(Ie(a)), P = i.reference[l] - i.floating[S] + (R && ((b = o.offset) == null ? void 0 : b[l]) || 0) + (R ? 0 : m.crossAxis), O = i.reference[l] + i.reference[S] + (R ? 0 : ((y = o.offset) == null ? void 0 : y[l]) || 0) - (R ? m.crossAxis : 0);
        g < P ? g = P : g > O && (g = O);
      }
      return {
        [h]: d,
        [l]: g
      };
    }
  };
}, dh = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: r,
        rects: n,
        platform: a,
        elements: i
      } = t, {
        apply: o = () => {
        },
        ...s
      } = je(e, t), c = await St(t, s), u = Ie(r), f = vt(r), l = pt(r) === "y", {
        width: h,
        height: d
      } = n.floating;
      let g, v;
      u === "top" || u === "bottom" ? (g = u, v = f === (await (a.isRTL == null ? void 0 : a.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (v = u, g = f === "end" ? "top" : "bottom");
      const m = d - c[g], b = h - c[v], y = !t.middlewareData.shift;
      let S = m, R = b;
      if (l) {
        const O = h - c.left - c.right;
        R = f || y ? Ve(b, O) : O;
      } else {
        const O = d - c.top - c.bottom;
        S = f || y ? Ve(m, O) : O;
      }
      if (y && !f) {
        const O = me(c.left, 0), T = me(c.right, 0), w = me(c.top, 0), x = me(c.bottom, 0);
        l ? R = h - 2 * (O !== 0 || T !== 0 ? O + T : me(c.left, c.right)) : S = d - 2 * (w !== 0 || x !== 0 ? w + x : me(c.top, c.bottom));
      }
      await o({
        ...t,
        availableWidth: R,
        availableHeight: S
      });
      const P = await a.getDimensions(i.floating);
      return h !== P.width || d !== P.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Ue(e) {
  return Ol(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function be(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function De(e) {
  var t;
  return (t = (Ol(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Ol(e) {
  return e instanceof Node || e instanceof be(e).Node;
}
function Me(e) {
  return e instanceof Element || e instanceof be(e).Element;
}
function Pe(e) {
  return e instanceof HTMLElement || e instanceof be(e).HTMLElement;
}
function Yo(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof be(e).ShadowRoot;
}
function Tt(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: n,
    display: a
  } = xe(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !["inline", "contents"].includes(a);
}
function hh(e) {
  return ["table", "td", "th"].includes(Ue(e));
}
function no(e) {
  const t = ao(), r = xe(e);
  return r.transform !== "none" || r.perspective !== "none" || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((n) => (r.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (r.contain || "").includes(n));
}
function vh(e) {
  let t = dt(e);
  for (; Pe(t) && !sr(t); ) {
    if (no(t))
      return t;
    t = dt(t);
  }
  return null;
}
function ao() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function sr(e) {
  return ["html", "body", "#document"].includes(Ue(e));
}
function xe(e) {
  return be(e).getComputedStyle(e);
}
function cr(e) {
  return Me(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function dt(e) {
  if (Ue(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Yo(e) && e.host || // Fallback.
    De(e)
  );
  return Yo(t) ? t.host : t;
}
function Al(e) {
  const t = dt(e);
  return sr(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Pe(t) && Tt(t) ? t : Al(t);
}
function ar(e, t) {
  var r;
  t === void 0 && (t = []);
  const n = Al(e), a = n === ((r = e.ownerDocument) == null ? void 0 : r.body), i = be(n);
  return a ? t.concat(i, i.visualViewport || [], Tt(n) ? n : []) : t.concat(n, ar(n));
}
function Tl(e) {
  const t = xe(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const a = Pe(e), i = a ? e.offsetWidth : r, o = a ? e.offsetHeight : n, s = tr(r) !== i || tr(n) !== o;
  return s && (r = i, n = o), {
    width: r,
    height: n,
    $: s
  };
}
function io(e) {
  return Me(e) ? e : e.contextElement;
}
function ut(e) {
  const t = io(e);
  if (!Pe(t))
    return He(1);
  const r = t.getBoundingClientRect(), {
    width: n,
    height: a,
    $: i
  } = Tl(t);
  let o = (i ? tr(r.width) : r.width) / n, s = (i ? tr(r.height) : r.height) / a;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const ph = /* @__PURE__ */ He(0);
function $l(e) {
  const t = be(e);
  return !ao() || !t.visualViewport ? ph : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function gh(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== be(e) ? !1 : t;
}
function Ke(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const a = e.getBoundingClientRect(), i = io(e);
  let o = He(1);
  t && (n ? Me(n) && (o = ut(n)) : o = ut(e));
  const s = gh(i, r, n) ? $l(i) : He(0);
  let c = (a.left + s.x) / o.x, u = (a.top + s.y) / o.y, f = a.width / o.x, l = a.height / o.y;
  if (i) {
    const h = be(i), d = n && Me(n) ? be(n) : n;
    let g = h.frameElement;
    for (; g && n && d !== h; ) {
      const v = ut(g), m = g.getBoundingClientRect(), b = xe(g), y = m.left + (g.clientLeft + parseFloat(b.paddingLeft)) * v.x, S = m.top + (g.clientTop + parseFloat(b.paddingTop)) * v.y;
      c *= v.x, u *= v.y, f *= v.x, l *= v.y, c += y, u += S, g = be(g).frameElement;
    }
  }
  return nr({
    width: f,
    height: l,
    x: c,
    y: u
  });
}
function mh(e) {
  let {
    rect: t,
    offsetParent: r,
    strategy: n
  } = e;
  const a = Pe(r), i = De(r);
  if (r === i)
    return t;
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = He(1);
  const c = He(0);
  if ((a || !a && n !== "fixed") && ((Ue(r) !== "body" || Tt(i)) && (o = cr(r)), Pe(r))) {
    const u = Ke(r);
    s = ut(r), c.x = u.x + r.clientLeft, c.y = u.y + r.clientTop;
  }
  return {
    width: t.width * s.x,
    height: t.height * s.y,
    x: t.x * s.x - o.scrollLeft * s.x + c.x,
    y: t.y * s.y - o.scrollTop * s.y + c.y
  };
}
function bh(e) {
  return Array.from(e.getClientRects());
}
function ql(e) {
  return Ke(De(e)).left + cr(e).scrollLeft;
}
function yh(e) {
  const t = De(e), r = cr(e), n = e.ownerDocument.body, a = me(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), i = me(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let o = -r.scrollLeft + ql(e);
  const s = -r.scrollTop;
  return xe(n).direction === "rtl" && (o += me(t.clientWidth, n.clientWidth) - a), {
    width: a,
    height: i,
    x: o,
    y: s
  };
}
function _h(e, t) {
  const r = be(e), n = De(e), a = r.visualViewport;
  let i = n.clientWidth, o = n.clientHeight, s = 0, c = 0;
  if (a) {
    i = a.width, o = a.height;
    const u = ao();
    (!u || u && t === "fixed") && (s = a.offsetLeft, c = a.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s,
    y: c
  };
}
function xh(e, t) {
  const r = Ke(e, !0, t === "fixed"), n = r.top + e.clientTop, a = r.left + e.clientLeft, i = Pe(e) ? ut(e) : He(1), o = e.clientWidth * i.x, s = e.clientHeight * i.y, c = a * i.x, u = n * i.y;
  return {
    width: o,
    height: s,
    x: c,
    y: u
  };
}
function Xo(e, t, r) {
  let n;
  if (t === "viewport")
    n = _h(e, r);
  else if (t === "document")
    n = yh(De(e));
  else if (Me(t))
    n = xh(t, r);
  else {
    const a = $l(e);
    n = {
      ...t,
      x: t.x - a.x,
      y: t.y - a.y
    };
  }
  return nr(n);
}
function jl(e, t) {
  const r = dt(e);
  return r === t || !Me(r) || sr(r) ? !1 : xe(r).position === "fixed" || jl(r, t);
}
function wh(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let n = ar(e).filter((s) => Me(s) && Ue(s) !== "body"), a = null;
  const i = xe(e).position === "fixed";
  let o = i ? dt(e) : e;
  for (; Me(o) && !sr(o); ) {
    const s = xe(o), c = no(o);
    !c && s.position === "fixed" && (a = null), (i ? !c && !a : !c && s.position === "static" && !!a && ["absolute", "fixed"].includes(a.position) || Tt(o) && !c && jl(e, o)) ? n = n.filter((f) => f !== o) : a = s, o = dt(o);
  }
  return t.set(e, n), n;
}
function Rh(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: n,
    strategy: a
  } = e;
  const o = [...r === "clippingAncestors" ? wh(t, this._c) : [].concat(r), n], s = o[0], c = o.reduce((u, f) => {
    const l = Xo(t, f, a);
    return u.top = me(l.top, u.top), u.right = Ve(l.right, u.right), u.bottom = Ve(l.bottom, u.bottom), u.left = me(l.left, u.left), u;
  }, Xo(t, s, a));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function Ch(e) {
  return Tl(e);
}
function Sh(e, t, r) {
  const n = Pe(t), a = De(t), i = r === "fixed", o = Ke(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = He(0);
  if (n || !n && !i)
    if ((Ue(t) !== "body" || Tt(a)) && (s = cr(t)), n) {
      const u = Ke(t, !0, i, t);
      c.x = u.x + t.clientLeft, c.y = u.y + t.clientTop;
    } else a && (c.x = ql(a));
  return {
    x: o.left + s.scrollLeft - c.x,
    y: o.top + s.scrollTop - c.y,
    width: o.width,
    height: o.height
  };
}
function Jo(e, t) {
  return !Pe(e) || xe(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function Il(e, t) {
  const r = be(e);
  if (!Pe(e))
    return r;
  let n = Jo(e, t);
  for (; n && hh(n) && xe(n).position === "static"; )
    n = Jo(n, t);
  return n && (Ue(n) === "html" || Ue(n) === "body" && xe(n).position === "static" && !no(n)) ? r : n || vh(e) || r;
}
const Ph = async function(e) {
  let {
    reference: t,
    floating: r,
    strategy: n
  } = e;
  const a = this.getOffsetParent || Il, i = this.getDimensions;
  return {
    reference: Sh(t, await a(r), n),
    floating: {
      x: 0,
      y: 0,
      ...await i(r)
    }
  };
};
function Eh(e) {
  return xe(e).direction === "rtl";
}
const Oh = {
  convertOffsetParentRelativeRectToViewportRelativeRect: mh,
  getDocumentElement: De,
  getClippingRect: Rh,
  getOffsetParent: Il,
  getElementRects: Ph,
  getClientRects: bh,
  getDimensions: Ch,
  getScale: ut,
  isElement: Me,
  isRTL: Eh
};
function Ah(e, t) {
  let r = null, n;
  const a = De(e);
  function i() {
    clearTimeout(n), r && r.disconnect(), r = null;
  }
  function o(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), i();
    const {
      left: u,
      top: f,
      width: l,
      height: h
    } = e.getBoundingClientRect();
    if (s || t(), !l || !h)
      return;
    const d = Lt(f), g = Lt(a.clientWidth - (u + l)), v = Lt(a.clientHeight - (f + h)), m = Lt(u), y = {
      rootMargin: -d + "px " + -g + "px " + -v + "px " + -m + "px",
      threshold: me(0, Ve(1, c)) || 1
    };
    let S = !0;
    function R(P) {
      const O = P[0].intersectionRatio;
      if (O !== c) {
        if (!S)
          return o();
        O ? o(!1, O) : n = setTimeout(() => {
          o(!1, 1e-7);
        }, 100);
      }
      S = !1;
    }
    try {
      r = new IntersectionObserver(R, {
        ...y,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(R, y);
    }
    r.observe(e);
  }
  return o(!0), i;
}
function Th(e, t, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: i = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = n, u = io(e), f = a || i ? [...u ? ar(u) : [], ...ar(t)] : [];
  f.forEach((b) => {
    a && b.addEventListener("scroll", r, {
      passive: !0
    }), i && b.addEventListener("resize", r);
  });
  const l = u && s ? Ah(u, r) : null;
  let h = -1, d = null;
  o && (d = new ResizeObserver((b) => {
    let [y] = b;
    y && y.target === u && d && (d.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      d && d.observe(t);
    })), r();
  }), u && !c && d.observe(u), d.observe(t));
  let g, v = c ? Ke(e) : null;
  c && m();
  function m() {
    const b = Ke(e);
    v && (b.x !== v.x || b.y !== v.y || b.width !== v.width || b.height !== v.height) && r(), v = b, g = requestAnimationFrame(m);
  }
  return r(), () => {
    f.forEach((b) => {
      a && b.removeEventListener("scroll", r), i && b.removeEventListener("resize", r);
    }), l && l(), d && d.disconnect(), d = null, c && cancelAnimationFrame(g);
  };
}
const $h = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), a = {
    platform: Oh,
    ...r
  }, i = {
    ...a.platform,
    _c: n
  };
  return ih(e, t, {
    ...a,
    platform: i
  });
}, qh = (e) => {
  function t(r) {
    return {}.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(r) {
      const {
        element: n,
        padding: a
      } = typeof e == "function" ? e(r) : e;
      return n && t(n) ? n.current != null ? Wo({
        element: n.current,
        padding: a
      }).fn(r) : {} : n ? Wo({
        element: n,
        padding: a
      }).fn(r) : {};
    }
  };
};
var Gt = typeof document < "u" ? Xi : ie;
function ir(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let r, n, a;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r != t.length) return !1;
      for (n = r; n-- !== 0; )
        if (!ir(e[n], t[n]))
          return !1;
      return !0;
    }
    if (a = Object.keys(e), r = a.length, r !== Object.keys(t).length)
      return !1;
    for (n = r; n-- !== 0; )
      if (!{}.hasOwnProperty.call(t, a[n]))
        return !1;
    for (n = r; n-- !== 0; ) {
      const i = a[n];
      if (!(i === "_owner" && e.$$typeof) && !ir(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Ml(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Zo(e, t) {
  const r = Ml(e);
  return Math.round(t * r) / r;
}
function Qo(e) {
  const t = D.useRef(e);
  return Gt(() => {
    t.current = e;
  }), t;
}
function jh(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: r = "absolute",
    middleware: n = [],
    platform: a,
    elements: {
      reference: i,
      floating: o
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: u
  } = e, [f, l] = D.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, d] = D.useState(n);
  ir(h, n) || d(n);
  const [g, v] = D.useState(null), [m, b] = D.useState(null), y = D.useCallback((M) => {
    M != O.current && (O.current = M, v(M));
  }, [v]), S = D.useCallback((M) => {
    M !== T.current && (T.current = M, b(M));
  }, [b]), R = i || g, P = o || m, O = D.useRef(null), T = D.useRef(null), w = D.useRef(f), x = Qo(c), E = Qo(a), C = D.useCallback(() => {
    if (!O.current || !T.current)
      return;
    const M = {
      placement: t,
      strategy: r,
      middleware: h
    };
    E.current && (M.platform = E.current), $h(O.current, T.current, M).then((V) => {
      const N = {
        ...V,
        isPositioned: !0
      };
      j.current && !ir(w.current, N) && (w.current = N, rd.flushSync(() => {
        l(N);
      }));
    });
  }, [h, t, r, E]);
  Gt(() => {
    u === !1 && w.current.isPositioned && (w.current.isPositioned = !1, l((M) => ({
      ...M,
      isPositioned: !1
    })));
  }, [u]);
  const j = D.useRef(!1);
  Gt(() => (j.current = !0, () => {
    j.current = !1;
  }), []), Gt(() => {
    if (R && (O.current = R), P && (T.current = P), R && P) {
      if (x.current)
        return x.current(R, P, C);
      C();
    }
  }, [R, P, C, x]);
  const $ = D.useMemo(() => ({
    reference: O,
    floating: T,
    setReference: y,
    setFloating: S
  }), [y, S]), I = D.useMemo(() => ({
    reference: R,
    floating: P
  }), [R, P]), F = D.useMemo(() => {
    const M = {
      position: r,
      left: 0,
      top: 0
    };
    if (!I.floating)
      return M;
    const V = Zo(I.floating, f.x), N = Zo(I.floating, f.y);
    return s ? {
      ...M,
      transform: "translate(" + V + "px, " + N + "px)",
      ...Ml(I.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: V,
      top: N
    };
  }, [r, s, I.floating, f.x, f.y]);
  return D.useMemo(() => ({
    ...f,
    update: C,
    refs: $,
    elements: I,
    floatingStyles: F
  }), [f, C, $, I, F]);
}
function Ih(e) {
  const [t, r] = ee(void 0);
  return ft(() => {
    if (e) {
      r({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const n = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length) return;
        const i = a[0];
        let o, s;
        if ("borderBoxSize" in i) {
          const c = i.borderBoxSize, u = Array.isArray(c) ? c[0] : c;
          o = u.inlineSize, s = u.blockSize;
        } else
          o = e.offsetWidth, s = e.offsetHeight;
        r({
          width: o,
          height: s
        });
      });
      return n.observe(e, {
        box: "border-box"
      }), () => n.unobserve(e);
    } else
      r(void 0);
  }, [
    e
  ]), t;
}
const Dl = "Popper", [Nl, Fl] = Cl(Dl), [Mh, Ll] = Nl(Dl), Dh = (e) => {
  const { __scopePopper: t, children: r } = e, [n, a] = ee(null);
  return /* @__PURE__ */ z(Mh, {
    scope: t,
    anchor: n,
    onAnchorChange: a
  }, r);
}, Nh = "PopperAnchor", Fh = /* @__PURE__ */ ye((e, t) => {
  const { __scopePopper: r, virtualRef: n, ...a } = e, i = Ll(Nh, r), o = oe(null), s = Ye(t, o);
  return ie(() => {
    i.onAnchorChange((n == null ? void 0 : n.current) || o.current);
  }), n ? null : /* @__PURE__ */ z(ht.div, er({}, a, {
    ref: s
  }));
}), kl = "PopperContent", [Lh, ry] = Nl(kl), kh = /* @__PURE__ */ ye((e, t) => {
  var r, n, a, i, o, s, c, u;
  const { __scopePopper: f, side: l = "bottom", sideOffset: h = 0, align: d = "center", alignOffset: g = 0, arrowPadding: v = 0, avoidCollisions: m = !0, collisionBoundary: b = [], collisionPadding: y = 0, sticky: S = "partial", hideWhenDetached: R = !1, updatePositionStrategy: P = "optimized", onPlaced: O, ...T } = e, w = Ll(kl, f), [x, E] = ee(null), C = Ye(
    t,
    (fe) => E(fe)
  ), [j, $] = ee(null), I = Ih(j), F = (r = I == null ? void 0 : I.width) !== null && r !== void 0 ? r : 0, M = (n = I == null ? void 0 : I.height) !== null && n !== void 0 ? n : 0, V = l + (d !== "center" ? "-" + d : ""), N = typeof y == "number" ? y : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...y
  }, H = Array.isArray(b) ? b : [
    b
  ], Y = H.length > 0, se = {
    padding: N,
    boundary: H.filter(Bh),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: Y
  }, { refs: he, floatingStyles: ae, placement: ce, isPositioned: ue, middlewareData: K } = jh({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: V,
    whileElementsMounted: (...fe) => Th(...fe, {
      animationFrame: P === "always"
    }),
    elements: {
      reference: w.anchor
    },
    middleware: [
      uh({
        mainAxis: h + M,
        alignmentAxis: g
      }),
      m && lh({
        mainAxis: !0,
        crossAxis: !1,
        limiter: S === "partial" ? fh() : void 0,
        ...se
      }),
      m && oh({
        ...se
      }),
      dh({
        ...se,
        apply: ({ elements: fe, rects: Fe, availableWidth: Mt, availableHeight: Dt }) => {
          const { width: et, height: mr } = Fe.reference, tt = fe.floating.style;
          tt.setProperty("--radix-popper-available-width", `${Mt}px`), tt.setProperty("--radix-popper-available-height", `${Dt}px`), tt.setProperty("--radix-popper-anchor-width", `${et}px`), tt.setProperty("--radix-popper-anchor-height", `${mr}px`);
        }
      }),
      j && qh({
        element: j,
        padding: v
      }),
      Vh({
        arrowWidth: F,
        arrowHeight: M
      }),
      R && sh({
        strategy: "referenceHidden",
        ...se
      })
    ]
  }), [le, ne] = Bl(ce), te = Be(O);
  ft(() => {
    ue && (te == null || te());
  }, [
    ue,
    te
  ]);
  const ve = (a = K.arrow) === null || a === void 0 ? void 0 : a.x, Ae = (i = K.arrow) === null || i === void 0 ? void 0 : i.y, Ne = ((o = K.arrow) === null || o === void 0 ? void 0 : o.centerOffset) !== 0, [pe, Te] = ee();
  return ft(() => {
    x && Te(window.getComputedStyle(x).zIndex);
  }, [
    x
  ]), /* @__PURE__ */ z("div", {
    ref: he.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...ae,
      transform: ue ? ae.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: pe,
      "--radix-popper-transform-origin": [
        (s = K.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (c = K.transformOrigin) === null || c === void 0 ? void 0 : c.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ z(Lh, {
    scope: f,
    placedSide: le,
    onArrowChange: $,
    arrowX: ve,
    arrowY: Ae,
    shouldHideArrow: Ne
  }, /* @__PURE__ */ z(ht.div, er({
    "data-side": le,
    "data-align": ne
  }, T, {
    ref: C,
    style: {
      ...T.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: ue ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (u = K.hide) !== null && u !== void 0 && u.referenceHidden ? 0 : void 0
    }
  }))));
});
function Bh(e) {
  return e !== null;
}
const Vh = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var r, n, a, i, o;
    const { placement: s, rects: c, middlewareData: u } = t, l = ((r = u.arrow) === null || r === void 0 ? void 0 : r.centerOffset) !== 0, h = l ? 0 : e.arrowWidth, d = l ? 0 : e.arrowHeight, [g, v] = Bl(s), m = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[v], b = ((n = (a = u.arrow) === null || a === void 0 ? void 0 : a.x) !== null && n !== void 0 ? n : 0) + h / 2, y = ((i = (o = u.arrow) === null || o === void 0 ? void 0 : o.y) !== null && i !== void 0 ? i : 0) + d / 2;
    let S = "", R = "";
    return g === "bottom" ? (S = l ? m : `${b}px`, R = `${-d}px`) : g === "top" ? (S = l ? m : `${b}px`, R = `${c.floating.height + d}px`) : g === "right" ? (S = `${-d}px`, R = l ? m : `${y}px`) : g === "left" && (S = `${c.floating.width + d}px`, R = l ? m : `${y}px`), {
      data: {
        x: S,
        y: R
      }
    };
  }
});
function Bl(e) {
  const [t, r = "center"] = e.split("-");
  return [
    t,
    r
  ];
}
const Hh = Dh, Uh = Fh, zh = kh;
function zi() {
  return zi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zi.apply(this, arguments);
}
const Wh = /* @__PURE__ */ ye((e, t) => {
  var r;
  const { container: n = globalThis == null || (r = globalThis.document) === null || r === void 0 ? void 0 : r.body, ...a } = e;
  return n ? /* @__PURE__ */ nd.createPortal(/* @__PURE__ */ z(ht.div, zi({}, a, {
    ref: t
  })), n) : null;
});
function Gh(e, t) {
  return Zf((r, n) => {
    const a = t[r][n];
    return a ?? r;
  }, e);
}
const oo = (e) => {
  const { present: t, children: r } = e, n = Kh(t), a = typeof r == "function" ? r({
    present: n.isPresent
  }) : ct.only(r), i = Ye(n.ref, a.ref);
  return typeof r == "function" || n.isPresent ? /* @__PURE__ */ or(a, {
    ref: i
  }) : null;
};
oo.displayName = "Presence";
function Kh(e) {
  const [t, r] = ee(), n = oe({}), a = oe(e), i = oe("none"), o = e ? "mounted" : "unmounted", [s, c] = Gh(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return ie(() => {
    const u = kt(n.current);
    i.current = s === "mounted" ? u : "none";
  }, [
    s
  ]), ft(() => {
    const u = n.current, f = a.current;
    if (f !== e) {
      const h = i.current, d = kt(u);
      e ? c("MOUNT") : d === "none" || (u == null ? void 0 : u.display) === "none" ? c("UNMOUNT") : c(f && h !== d ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [
    e,
    c
  ]), ft(() => {
    if (t) {
      const u = (l) => {
        const d = kt(n.current).includes(l.animationName);
        l.target === t && d && xl(
          () => c("ANIMATION_END")
        );
      }, f = (l) => {
        l.target === t && (i.current = kt(n.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: J((u) => {
      u && (n.current = getComputedStyle(u)), r(u);
    }, [])
  };
}
function kt(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Yh({ prop: e, defaultProp: t, onChange: r = () => {
} }) {
  const [n, a] = Xh({
    defaultProp: t,
    onChange: r
  }), i = e !== void 0, o = i ? e : n, s = Be(r), c = J((u) => {
    if (i) {
      const l = typeof u == "function" ? u(e) : u;
      l !== e && s(l);
    } else a(u);
  }, [
    i,
    e,
    a,
    s
  ]);
  return [
    o,
    c
  ];
}
function Xh({ defaultProp: e, onChange: t }) {
  const r = ee(e), [n] = r, a = oe(n), i = Be(t);
  return ie(() => {
    a.current !== n && (i(n), a.current = n);
  }, [
    n,
    a,
    i
  ]), r;
}
var Jh = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, at = /* @__PURE__ */ new WeakMap(), Bt = /* @__PURE__ */ new WeakMap(), Vt = {}, Er = 0, Vl = function(e) {
  return e && (e.host || Vl(e.parentNode));
}, Zh = function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var n = Vl(r);
    return n && e.contains(n) ? n : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, Qh = function(e, t, r, n) {
  var a = Zh(t, Array.isArray(e) ? e : [e]);
  Vt[r] || (Vt[r] = /* @__PURE__ */ new WeakMap());
  var i = Vt[r], o = [], s = /* @__PURE__ */ new Set(), c = new Set(a), u = function(l) {
    !l || s.has(l) || (s.add(l), u(l.parentNode));
  };
  a.forEach(u);
  var f = function(l) {
    !l || c.has(l) || Array.prototype.forEach.call(l.children, function(h) {
      if (s.has(h))
        f(h);
      else {
        var d = h.getAttribute(n), g = d !== null && d !== "false", v = (at.get(h) || 0) + 1, m = (i.get(h) || 0) + 1;
        at.set(h, v), i.set(h, m), o.push(h), v === 1 && g && Bt.set(h, !0), m === 1 && h.setAttribute(r, "true"), g || h.setAttribute(n, "true");
      }
    });
  };
  return f(t), s.clear(), Er++, function() {
    o.forEach(function(l) {
      var h = at.get(l) - 1, d = i.get(l) - 1;
      at.set(l, h), i.set(l, d), h || (Bt.has(l) || l.removeAttribute(n), Bt.delete(l)), d || l.removeAttribute(r);
    }), Er--, Er || (at = /* @__PURE__ */ new WeakMap(), at = /* @__PURE__ */ new WeakMap(), Bt = /* @__PURE__ */ new WeakMap(), Vt = {});
  };
}, ev = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), a = Jh(e);
  return a ? (n.push.apply(n, Array.from(a.querySelectorAll("[aria-live]"))), Qh(n, a, r, "aria-hidden")) : function() {
    return null;
  };
}, Se = function() {
  return Se = Object.assign || function(t) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, Se.apply(this, arguments);
};
function Hl(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
}
function tv(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, i; n < a; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var Kt = "right-scroll-bar-position", Yt = "width-before-scroll-bar", rv = "with-scroll-bars-hidden", nv = "--removed-body-scroll-bar-size";
function av(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function iv(e, t) {
  var r = ee(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(n) {
          var a = r.value;
          a !== n && (r.value = n, r.callback(n, a));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
function ov(e, t) {
  return iv(null, function(r) {
    return e.forEach(function(n) {
      return av(n, r);
    });
  });
}
function sv(e) {
  return e;
}
function cv(e, t) {
  t === void 0 && (t = sv);
  var r = [], n = !1, a = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(i) {
      var o = t(i, n);
      return r.push(o), function() {
        r = r.filter(function(s) {
          return s !== o;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (n = !0; r.length; ) {
        var o = r;
        r = [], o.forEach(i);
      }
      r = {
        push: function(s) {
          return i(s);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(i) {
      n = !0;
      var o = [];
      if (r.length) {
        var s = r;
        r = [], s.forEach(i), o = r;
      }
      var c = function() {
        var f = o;
        o = [], f.forEach(i);
      }, u = function() {
        return Promise.resolve().then(c);
      };
      u(), r = {
        push: function(f) {
          o.push(f), u();
        },
        filter: function(f) {
          return o = o.filter(f), r;
        }
      };
    }
  };
  return a;
}
function uv(e) {
  e === void 0 && (e = {});
  var t = cv(null);
  return t.options = Se({ async: !0, ssr: !1 }, e), t;
}
var Ul = function(e) {
  var t = e.sideCar, r = Hl(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return D.createElement(n, Se({}, r));
};
Ul.isSideCarExport = !0;
function lv(e, t) {
  return e.useMedium(t), Ul;
}
var zl = uv(), Or = function() {
}, ur = D.forwardRef(function(e, t) {
  var r = D.useRef(null), n = D.useState({
    onScrollCapture: Or,
    onWheelCapture: Or,
    onTouchMoveCapture: Or
  }), a = n[0], i = n[1], o = e.forwardProps, s = e.children, c = e.className, u = e.removeScrollBar, f = e.enabled, l = e.shards, h = e.sideCar, d = e.noIsolation, g = e.inert, v = e.allowPinchZoom, m = e.as, b = m === void 0 ? "div" : m, y = Hl(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), S = h, R = ov([r, t]), P = Se(Se({}, y), a);
  return D.createElement(
    D.Fragment,
    null,
    f && D.createElement(S, { sideCar: zl, removeScrollBar: u, shards: l, noIsolation: d, inert: g, setCallbacks: i, allowPinchZoom: !!v, lockRef: r }),
    o ? D.cloneElement(D.Children.only(s), Se(Se({}, P), { ref: R })) : D.createElement(b, Se({}, P, { className: c, ref: R }), s)
  );
});
ur.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
ur.classNames = {
  fullWidth: Yt,
  zeroRight: Kt
};
var fv = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function dv() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = fv();
  return t && e.setAttribute("nonce", t), e;
}
function hv(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function vv(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var pv = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = dv()) && (hv(t, r), vv(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, gv = function() {
  var e = pv();
  return function(t, r) {
    D.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, Wl = function() {
  var e = gv(), t = function(r) {
    var n = r.styles, a = r.dynamic;
    return e(n, a), null;
  };
  return t;
}, mv = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Ar = function(e) {
  return parseInt(e || "", 10) || 0;
}, bv = function(e) {
  var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Ar(r), Ar(n), Ar(a)];
}, yv = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return mv;
  var t = bv(e), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - r + t[2] - t[0])
  };
}, _v = Wl(), xv = function(e, t, r, n) {
  var a = e.left, i = e.top, o = e.right, s = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(rv, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(s, "px ").concat(n, `;
  }
  body {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(n, ";"),
    r === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(o, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(n, `;
    `),
    r === "padding" && "padding-right: ".concat(s, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Kt, ` {
    right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(Yt, ` {
    margin-right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(Kt, " .").concat(Kt, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(Yt, " .").concat(Yt, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body {
    `).concat(nv, ": ").concat(s, `px;
  }
`);
}, wv = function(e) {
  var t = e.noRelative, r = e.noImportant, n = e.gapMode, a = n === void 0 ? "margin" : n, i = D.useMemo(function() {
    return yv(a);
  }, [a]);
  return D.createElement(_v, { styles: xv(i, !t, a, r ? "" : "!important") });
}, Wi = !1;
if (typeof window < "u")
  try {
    var Ht = Object.defineProperty({}, "passive", {
      get: function() {
        return Wi = !0, !0;
      }
    });
    window.addEventListener("test", Ht, Ht), window.removeEventListener("test", Ht, Ht);
  } catch {
    Wi = !1;
  }
var it = Wi ? { passive: !1 } : !1, Rv = function(e) {
  return e.tagName === "TEXTAREA";
}, Gl = function(e, t) {
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !Rv(e) && r[t] === "visible")
  );
}, Cv = function(e) {
  return Gl(e, "overflowY");
}, Sv = function(e) {
  return Gl(e, "overflowX");
}, es = function(e, t) {
  var r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var n = Kl(e, r);
    if (n) {
      var a = Yl(e, r), i = a[1], o = a[2];
      if (i > o)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== document.body);
  return !1;
}, Pv = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    r,
    n
  ];
}, Ev = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    r,
    n
  ];
}, Kl = function(e, t) {
  return e === "v" ? Cv(t) : Sv(t);
}, Yl = function(e, t) {
  return e === "v" ? Pv(t) : Ev(t);
}, Ov = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Av = function(e, t, r, n, a) {
  var i = Ov(e, window.getComputedStyle(t).direction), o = i * n, s = r.target, c = t.contains(s), u = !1, f = o > 0, l = 0, h = 0;
  do {
    var d = Yl(e, s), g = d[0], v = d[1], m = d[2], b = v - m - i * g;
    (g || b) && Kl(e, s) && (l += b, h += g), s = s.parentNode;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (f && l === 0 || !f && h === 0) && (u = !0), u;
}, Ut = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, ts = function(e) {
  return [e.deltaX, e.deltaY];
}, rs = function(e) {
  return e && "current" in e ? e.current : e;
}, Tv = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, $v = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, qv = 0, ot = [];
function jv(e) {
  var t = D.useRef([]), r = D.useRef([0, 0]), n = D.useRef(), a = D.useState(qv++)[0], i = D.useState(function() {
    return Wl();
  })[0], o = D.useRef(e);
  D.useEffect(function() {
    o.current = e;
  }, [e]), D.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var v = tv([e.lockRef.current], (e.shards || []).map(rs), !0).filter(Boolean);
      return v.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), v.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = D.useCallback(function(v, m) {
    if ("touches" in v && v.touches.length === 2)
      return !o.current.allowPinchZoom;
    var b = Ut(v), y = r.current, S = "deltaX" in v ? v.deltaX : y[0] - b[0], R = "deltaY" in v ? v.deltaY : y[1] - b[1], P, O = v.target, T = Math.abs(S) > Math.abs(R) ? "h" : "v";
    if ("touches" in v && T === "h" && O.type === "range")
      return !1;
    var w = es(T, O);
    if (!w)
      return !0;
    if (w ? P = T : (P = T === "v" ? "h" : "v", w = es(T, O)), !w)
      return !1;
    if (!n.current && "changedTouches" in v && (S || R) && (n.current = P), !P)
      return !0;
    var x = n.current || P;
    return Av(x, m, v, x === "h" ? S : R);
  }, []), c = D.useCallback(function(v) {
    var m = v;
    if (!(!ot.length || ot[ot.length - 1] !== i)) {
      var b = "deltaY" in m ? ts(m) : Ut(m), y = t.current.filter(function(P) {
        return P.name === m.type && P.target === m.target && Tv(P.delta, b);
      })[0];
      if (y && y.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!y) {
        var S = (o.current.shards || []).map(rs).filter(Boolean).filter(function(P) {
          return P.contains(m.target);
        }), R = S.length > 0 ? s(m, S[0]) : !o.current.noIsolation;
        R && m.cancelable && m.preventDefault();
      }
    }
  }, []), u = D.useCallback(function(v, m, b, y) {
    var S = { name: v, delta: m, target: b, should: y };
    t.current.push(S), setTimeout(function() {
      t.current = t.current.filter(function(R) {
        return R !== S;
      });
    }, 1);
  }, []), f = D.useCallback(function(v) {
    r.current = Ut(v), n.current = void 0;
  }, []), l = D.useCallback(function(v) {
    u(v.type, ts(v), v.target, s(v, e.lockRef.current));
  }, []), h = D.useCallback(function(v) {
    u(v.type, Ut(v), v.target, s(v, e.lockRef.current));
  }, []);
  D.useEffect(function() {
    return ot.push(i), e.setCallbacks({
      onScrollCapture: l,
      onWheelCapture: l,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", c, it), document.addEventListener("touchmove", c, it), document.addEventListener("touchstart", f, it), function() {
      ot = ot.filter(function(v) {
        return v !== i;
      }), document.removeEventListener("wheel", c, it), document.removeEventListener("touchmove", c, it), document.removeEventListener("touchstart", f, it);
    };
  }, []);
  var d = e.removeScrollBar, g = e.inert;
  return D.createElement(
    D.Fragment,
    null,
    g ? D.createElement(i, { styles: $v(a) }) : null,
    d ? D.createElement(wv, { gapMode: "margin" }) : null
  );
}
const Iv = lv(zl, jv);
var Xl = D.forwardRef(function(e, t) {
  return D.createElement(ur, Se({}, e, { ref: t, sideCar: Iv }));
});
Xl.classNames = ur.classNames;
const Jl = "Popover", [Zl, ny] = Cl(Jl, [
  Fl
]), so = Fl(), [Mv, gt] = Zl(Jl), Dv = (e) => {
  const { __scopePopover: t, children: r, open: n, defaultOpen: a, onOpenChange: i, modal: o = !1 } = e, s = so(t), c = oe(null), [u, f] = ee(!1), [l = !1, h] = Yh({
    prop: n,
    defaultProp: a,
    onChange: i
  });
  return /* @__PURE__ */ z(Hh, s, /* @__PURE__ */ z(Mv, {
    scope: t,
    contentId: Xd(),
    triggerRef: c,
    open: l,
    onOpenChange: h,
    onOpenToggle: J(
      () => h(
        (d) => !d
      ),
      [
        h
      ]
    ),
    hasCustomAnchor: u,
    onCustomAnchorAdd: J(
      () => f(!0),
      []
    ),
    onCustomAnchorRemove: J(
      () => f(!1),
      []
    ),
    modal: o
  }, r));
}, Nv = "PopoverTrigger", Fv = /* @__PURE__ */ ye((e, t) => {
  const { __scopePopover: r, ...n } = e, a = gt(Nv, r), i = so(r), o = Ye(t, a.triggerRef), s = /* @__PURE__ */ z(ht.button, qe({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": a.open,
    "aria-controls": a.contentId,
    "data-state": tf(a.open)
  }, n, {
    ref: o,
    onClick: We(e.onClick, a.onOpenToggle)
  }));
  return a.hasCustomAnchor ? s : /* @__PURE__ */ z(Uh, qe({
    asChild: !0
  }, i), s);
}), Ql = "PopoverPortal", [Lv, kv] = Zl(Ql, {
  forceMount: void 0
}), Bv = (e) => {
  const { __scopePopover: t, forceMount: r, children: n, container: a } = e, i = gt(Ql, t);
  return /* @__PURE__ */ z(Lv, {
    scope: t,
    forceMount: r
  }, /* @__PURE__ */ z(oo, {
    present: r || i.open
  }, /* @__PURE__ */ z(Wh, {
    asChild: !0,
    container: a
  }, n)));
}, Pt = "PopoverContent", Vv = /* @__PURE__ */ ye((e, t) => {
  const r = kv(Pt, e.__scopePopover), { forceMount: n = r.forceMount, ...a } = e, i = gt(Pt, e.__scopePopover);
  return /* @__PURE__ */ z(oo, {
    present: n || i.open
  }, i.modal ? /* @__PURE__ */ z(Hv, qe({}, a, {
    ref: t
  })) : /* @__PURE__ */ z(Uv, qe({}, a, {
    ref: t
  })));
}), Hv = /* @__PURE__ */ ye((e, t) => {
  const r = gt(Pt, e.__scopePopover), n = oe(null), a = Ye(t, n), i = oe(!1);
  return ie(() => {
    const o = n.current;
    if (o) return ev(o);
  }, []), /* @__PURE__ */ z(Xl, {
    as: Qi,
    allowPinchZoom: !0
  }, /* @__PURE__ */ z(ef, qe({}, e, {
    ref: a,
    trapFocus: r.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: We(e.onCloseAutoFocus, (o) => {
      var s;
      o.preventDefault(), i.current || (s = r.triggerRef.current) === null || s === void 0 || s.focus();
    }),
    onPointerDownOutside: We(e.onPointerDownOutside, (o) => {
      const s = o.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0, u = s.button === 2 || c;
      i.current = u;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: We(
      e.onFocusOutside,
      (o) => o.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), Uv = /* @__PURE__ */ ye((e, t) => {
  const r = gt(Pt, e.__scopePopover), n = oe(!1), a = oe(!1);
  return /* @__PURE__ */ z(ef, qe({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (i) => {
      var o;
      if ((o = e.onCloseAutoFocus) === null || o === void 0 || o.call(e, i), !i.defaultPrevented) {
        var s;
        n.current || (s = r.triggerRef.current) === null || s === void 0 || s.focus(), i.preventDefault();
      }
      n.current = !1, a.current = !1;
    },
    onInteractOutside: (i) => {
      var o, s;
      (o = e.onInteractOutside) === null || o === void 0 || o.call(e, i), i.defaultPrevented || (n.current = !0, i.detail.originalEvent.type === "pointerdown" && (a.current = !0));
      const c = i.target;
      ((s = r.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(c)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && a.current && i.preventDefault();
    }
  }));
}), ef = /* @__PURE__ */ ye((e, t) => {
  const { __scopePopover: r, trapFocus: n, onOpenAutoFocus: a, onCloseAutoFocus: i, disableOutsidePointerEvents: o, onEscapeKeyDown: s, onPointerDownOutside: c, onFocusOutside: u, onInteractOutside: f, ...l } = e, h = gt(Pt, r), d = so(r);
  return kd(), /* @__PURE__ */ z(Bd, {
    asChild: !0,
    loop: !0,
    trapped: n,
    onMountAutoFocus: a,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ z(Nd, {
    asChild: !0,
    disableOutsidePointerEvents: o,
    onInteractOutside: f,
    onEscapeKeyDown: s,
    onPointerDownOutside: c,
    onFocusOutside: u,
    onDismiss: () => h.onOpenChange(!1)
  }, /* @__PURE__ */ z(zh, qe({
    "data-state": tf(h.open),
    role: "dialog",
    id: h.contentId
  }, d, l, {
    ref: t,
    style: {
      ...l.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
});
function tf(e) {
  return e ? "open" : "closed";
}
const rf = Dv, nf = Fv, af = Bv, of = Vv, zv = "_tooltip_5svgn_1", Wv = "_popover_5svgn_5", ns = {
  tooltip: zv,
  popover: Wv
}, ay = ({
  actions: e,
  buttonProps: t = {},
  side: r = "bottom",
  align: n = "end"
}) => {
  const [a, i] = ee(!1);
  if (!e.length) return null;
  const o = (s, c) => {
    switch (s.type) {
      case "button":
      case "link": {
        const u = /* @__PURE__ */ _.jsx(
          Rr.Item,
          {
            icon: s.icon,
            onClick: () => {
              var f;
              (f = s.onClick) == null || f.call(s), i(!1);
            },
            isDisabled: s.disabled ?? !1,
            children: /* @__PURE__ */ _.jsxs(
              X,
              {
                as: "span",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "2px",
                children: [
                  /* @__PURE__ */ _.jsx("span", { children: s.label }),
                  s.description && /* @__PURE__ */ _.jsx(G.Paragraph, { as: "span", variant: "4", subdued: !0, children: s.description })
                ]
              }
            )
          }
        );
        return /* @__PURE__ */ _.jsx(
          Ot,
          {
            className: ns.tooltip,
            content: s.tooltip,
            children: s.type === "link" ? or(s.link, {
              children: u
            }) : u
          },
          c
        );
      }
      case "divider":
        return /* @__PURE__ */ _.jsx(Rr.Divider, {}, c);
      default:
        return null;
    }
  };
  return /* @__PURE__ */ _.jsxs(rf, { open: a, onOpenChange: i, children: [
    /* @__PURE__ */ _.jsx(nf, { asChild: !0, children: /* @__PURE__ */ _.jsx("div", { children: /* @__PURE__ */ _.jsx(Ji, { variant: "tertiary", icon: "dots-v", ...t }) }) }),
    /* @__PURE__ */ _.jsx(af, { children: /* @__PURE__ */ _.jsx(
      of,
      {
        className: ns.popover,
        side: r,
        align: n,
        sideOffset: 8,
        onOpenAutoFocus: (s) => s.preventDefault(),
        children: /* @__PURE__ */ _.jsx(Rr, { children: e.map((s, c) => o(s, c)) })
      }
    ) })
  ] });
};
var yt = {}, Gi = function() {
  return (Gi = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) for (var a in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    return e;
  }).apply(this, arguments);
}, Gv = function() {
  function e(t, r, n) {
    var a = this;
    this.endVal = r, this.options = n, this.version = "2.6.0", this.defaults = { startVal: 0, decimalPlaces: 0, duration: 2, useEasing: !0, useGrouping: !0, useIndianSeparators: !1, smartEasingThreshold: 999, smartEasingAmount: 333, separator: ",", decimal: ".", prefix: "", suffix: "", enableScrollSpy: !1, scrollSpyDelay: 200, scrollSpyOnce: !1 }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function(i) {
      a.startTime || (a.startTime = i);
      var o = i - a.startTime;
      a.remaining = a.duration - o, a.useEasing ? a.countDown ? a.frameVal = a.startVal - a.easingFn(o, 0, a.startVal - a.endVal, a.duration) : a.frameVal = a.easingFn(o, a.startVal, a.endVal - a.startVal, a.duration) : a.frameVal = a.startVal + (a.endVal - a.startVal) * (o / a.duration);
      var s = a.countDown ? a.frameVal < a.endVal : a.frameVal > a.endVal;
      a.frameVal = s ? a.endVal : a.frameVal, a.frameVal = Number(a.frameVal.toFixed(a.options.decimalPlaces)), a.printValue(a.frameVal), o < a.duration ? a.rAF = requestAnimationFrame(a.count) : a.finalEndVal !== null ? a.update(a.finalEndVal) : a.options.onCompleteCallback && a.options.onCompleteCallback();
    }, this.formatNumber = function(i) {
      var o, s, c, u, f = i < 0 ? "-" : "";
      o = Math.abs(i).toFixed(a.options.decimalPlaces);
      var l = (o += "").split(".");
      if (s = l[0], c = l.length > 1 ? a.options.decimal + l[1] : "", a.options.useGrouping) {
        u = "";
        for (var h = 3, d = 0, g = 0, v = s.length; g < v; ++g) a.options.useIndianSeparators && g === 4 && (h = 2, d = 1), g !== 0 && d % h == 0 && (u = a.options.separator + u), d++, u = s[v - g - 1] + u;
        s = u;
      }
      return a.options.numerals && a.options.numerals.length && (s = s.replace(/[0-9]/g, function(m) {
        return a.options.numerals[+m];
      }), c = c.replace(/[0-9]/g, function(m) {
        return a.options.numerals[+m];
      })), f + a.options.prefix + s + c + a.options.suffix;
    }, this.easeOutExpo = function(i, o, s, c) {
      return s * (1 - Math.pow(2, -10 * i / c)) * 1024 / 1023 + o;
    }, this.options = Gi(Gi({}, this.defaults), n), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(r), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, this.options.separator === "" && (this.options.useGrouping = !1), this.el = typeof t == "string" ? document.getElementById(t) : t, this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", typeof window < "u" && this.options.enableScrollSpy && (this.error ? console.error(this.error, t) : (window.onScrollFns = window.onScrollFns || [], window.onScrollFns.push(function() {
      return a.handleScroll(a);
    }), window.onscroll = function() {
      window.onScrollFns.forEach(function(i) {
        return i();
      });
    }, this.handleScroll(this)));
  }
  return e.prototype.handleScroll = function(t) {
    if (t && window && !t.once) {
      var r = window.innerHeight + window.scrollY, n = t.el.getBoundingClientRect(), a = n.top + window.pageYOffset, i = n.top + n.height + window.pageYOffset;
      i < r && i > window.scrollY && t.paused ? (t.paused = !1, setTimeout(function() {
        return t.start();
      }, t.options.scrollSpyDelay), t.options.scrollSpyOnce && (t.once = !0)) : (window.scrollY > i || a > r) && !t.paused && t.reset();
    }
  }, e.prototype.determineDirectionAndSmartEasing = function() {
    var t = this.finalEndVal ? this.finalEndVal : this.endVal;
    this.countDown = this.startVal > t;
    var r = t - this.startVal;
    if (Math.abs(r) > this.options.smartEasingThreshold && this.options.useEasing) {
      this.finalEndVal = t;
      var n = this.countDown ? 1 : -1;
      this.endVal = t + n * this.options.smartEasingAmount, this.duration = this.duration / 2;
    } else this.endVal = t, this.finalEndVal = null;
    this.finalEndVal !== null ? this.useEasing = !1 : this.useEasing = this.options.useEasing;
  }, e.prototype.start = function(t) {
    this.error || (t && (this.options.onCompleteCallback = t), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
  }, e.prototype.pauseResume = function() {
    this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
  }, e.prototype.reset = function() {
    cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
  }, e.prototype.update = function(t) {
    cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(t), this.endVal !== this.frameVal && (this.startVal = this.frameVal, this.finalEndVal == null && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
  }, e.prototype.printValue = function(t) {
    var r;
    if (this.el) {
      var n = this.formattingFn(t);
      (r = this.options.plugin) !== null && r !== void 0 && r.render ? this.options.plugin.render(this.el, n) : this.el.tagName === "INPUT" ? this.el.value = n : this.el.tagName === "text" || this.el.tagName === "tspan" ? this.el.textContent = n : this.el.innerHTML = n;
    }
  }, e.prototype.ensureNumber = function(t) {
    return typeof t == "number" && !isNaN(t);
  }, e.prototype.validateValue = function(t) {
    var r = Number(t);
    return this.ensureNumber(r) ? r : (this.error = "[CountUp] invalid start or end value: ".concat(t), null);
  }, e.prototype.resetDuration = function() {
    this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
  }, e;
}();
const Kv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CountUp: Gv
}, Symbol.toStringTag, { value: "Module" })), Yv = /* @__PURE__ */ wd(Kv);
var as;
function Xv() {
  if (as) return yt;
  as = 1, Object.defineProperty(yt, "__esModule", { value: !0 });
  var e = Yi, t = Yv;
  function r(w, x) {
    var E = w == null ? null : typeof Symbol < "u" && w[Symbol.iterator] || w["@@iterator"];
    if (E != null) {
      var C, j, $, I, F = [], M = !0, V = !1;
      try {
        if ($ = (E = E.call(w)).next, x !== 0) for (; !(M = (C = $.call(E)).done) && (F.push(C.value), F.length !== x); M = !0) ;
      } catch (N) {
        V = !0, j = N;
      } finally {
        try {
          if (!M && E.return != null && (I = E.return(), Object(I) !== I)) return;
        } finally {
          if (V) throw j;
        }
      }
      return F;
    }
  }
  function n(w, x) {
    var E = Object.keys(w);
    if (Object.getOwnPropertySymbols) {
      var C = Object.getOwnPropertySymbols(w);
      x && (C = C.filter(function(j) {
        return Object.getOwnPropertyDescriptor(w, j).enumerable;
      })), E.push.apply(E, C);
    }
    return E;
  }
  function a(w) {
    for (var x = 1; x < arguments.length; x++) {
      var E = arguments[x] != null ? arguments[x] : {};
      x % 2 ? n(Object(E), !0).forEach(function(C) {
        i(w, C, E[C]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(w, Object.getOwnPropertyDescriptors(E)) : n(Object(E)).forEach(function(C) {
        Object.defineProperty(w, C, Object.getOwnPropertyDescriptor(E, C));
      });
    }
    return w;
  }
  function i(w, x, E) {
    return x = v(x), x in w ? Object.defineProperty(w, x, {
      value: E,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : w[x] = E, w;
  }
  function o() {
    return o = Object.assign ? Object.assign.bind() : function(w) {
      for (var x = 1; x < arguments.length; x++) {
        var E = arguments[x];
        for (var C in E)
          Object.prototype.hasOwnProperty.call(E, C) && (w[C] = E[C]);
      }
      return w;
    }, o.apply(this, arguments);
  }
  function s(w, x) {
    if (w == null) return {};
    var E = {}, C = Object.keys(w), j, $;
    for ($ = 0; $ < C.length; $++)
      j = C[$], !(x.indexOf(j) >= 0) && (E[j] = w[j]);
    return E;
  }
  function c(w, x) {
    if (w == null) return {};
    var E = s(w, x), C, j;
    if (Object.getOwnPropertySymbols) {
      var $ = Object.getOwnPropertySymbols(w);
      for (j = 0; j < $.length; j++)
        C = $[j], !(x.indexOf(C) >= 0) && Object.prototype.propertyIsEnumerable.call(w, C) && (E[C] = w[C]);
    }
    return E;
  }
  function u(w, x) {
    return f(w) || r(w, x) || l(w, x) || d();
  }
  function f(w) {
    if (Array.isArray(w)) return w;
  }
  function l(w, x) {
    if (w) {
      if (typeof w == "string") return h(w, x);
      var E = Object.prototype.toString.call(w).slice(8, -1);
      if (E === "Object" && w.constructor && (E = w.constructor.name), E === "Map" || E === "Set") return Array.from(w);
      if (E === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(E)) return h(w, x);
    }
  }
  function h(w, x) {
    (x == null || x > w.length) && (x = w.length);
    for (var E = 0, C = new Array(x); E < x; E++) C[E] = w[E];
    return C;
  }
  function d() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function g(w, x) {
    if (typeof w != "object" || w === null) return w;
    var E = w[Symbol.toPrimitive];
    if (E !== void 0) {
      var C = E.call(w, x);
      if (typeof C != "object") return C;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (x === "string" ? String : Number)(w);
  }
  function v(w) {
    var x = g(w, "string");
    return typeof x == "symbol" ? x : String(x);
  }
  var m = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? e.useLayoutEffect : e.useEffect;
  function b(w) {
    var x = e.useRef(w);
    return m(function() {
      x.current = w;
    }), e.useCallback(function() {
      for (var E = arguments.length, C = new Array(E), j = 0; j < E; j++)
        C[j] = arguments[j];
      return x.current.apply(void 0, C);
    }, []);
  }
  var y = function(x, E) {
    var C = E.decimal, j = E.decimals, $ = E.duration, I = E.easingFn, F = E.end, M = E.formattingFn, V = E.numerals, N = E.prefix, H = E.separator, Y = E.start, se = E.suffix, he = E.useEasing, ae = E.useGrouping, ce = E.useIndianSeparators, ue = E.enableScrollSpy, K = E.scrollSpyDelay, le = E.scrollSpyOnce;
    return new t.CountUp(x, F, {
      startVal: Y,
      duration: $,
      decimal: C,
      decimalPlaces: j,
      easingFn: I,
      formattingFn: M,
      numerals: V,
      separator: H,
      prefix: N,
      suffix: se,
      useEasing: he,
      useIndianSeparators: ce,
      useGrouping: ae,
      enableScrollSpy: ue,
      scrollSpyDelay: K,
      scrollSpyOnce: le
    });
  }, S = ["ref", "startOnMount", "enableReinitialize", "delay", "onEnd", "onStart", "onPauseResume", "onReset", "onUpdate"], R = {
    decimal: ".",
    separator: ",",
    delay: null,
    prefix: "",
    suffix: "",
    duration: 2,
    start: 0,
    decimals: 0,
    startOnMount: !0,
    enableReinitialize: !0,
    useEasing: !0,
    useGrouping: !0,
    useIndianSeparators: !1
  }, P = function(x) {
    var E = Object.fromEntries(Object.entries(x).filter(function(pe) {
      var Te = u(pe, 2), fe = Te[1];
      return fe !== void 0;
    })), C = e.useMemo(function() {
      return a(a({}, R), E);
    }, [x]), j = C.ref, $ = C.startOnMount, I = C.enableReinitialize, F = C.delay, M = C.onEnd, V = C.onStart, N = C.onPauseResume, H = C.onReset, Y = C.onUpdate, se = c(C, S), he = e.useRef(), ae = e.useRef(), ce = e.useRef(!1), ue = b(function() {
      return y(typeof j == "string" ? j : j.current, se);
    }), K = b(function(pe) {
      var Te = he.current;
      if (Te && !pe)
        return Te;
      var fe = ue();
      return he.current = fe, fe;
    }), le = b(function() {
      var pe = function() {
        return K(!0).start(function() {
          M == null || M({
            pauseResume: ne,
            reset: te,
            start: Ae,
            update: ve
          });
        });
      };
      F && F > 0 ? ae.current = setTimeout(pe, F * 1e3) : pe(), V == null || V({
        pauseResume: ne,
        reset: te,
        update: ve
      });
    }), ne = b(function() {
      K().pauseResume(), N == null || N({
        reset: te,
        start: Ae,
        update: ve
      });
    }), te = b(function() {
      K().el && (ae.current && clearTimeout(ae.current), K().reset(), H == null || H({
        pauseResume: ne,
        start: Ae,
        update: ve
      }));
    }), ve = b(function(pe) {
      K().update(pe), Y == null || Y({
        pauseResume: ne,
        reset: te,
        start: Ae
      });
    }), Ae = b(function() {
      te(), le();
    }), Ne = b(function(pe) {
      $ && (pe && te(), le());
    });
    return e.useEffect(function() {
      ce.current ? I && Ne(!0) : (ce.current = !0, Ne());
    }, [I, ce, Ne, F, x.start, x.suffix, x.prefix, x.duration, x.separator, x.decimals, x.decimal, x.formattingFn]), e.useEffect(function() {
      return function() {
        te();
      };
    }, [te]), {
      start: Ae,
      pauseResume: ne,
      reset: te,
      update: ve,
      getCountUp: K
    };
  }, O = ["className", "redraw", "containerProps", "children", "style"], T = function(x) {
    var E = x.className, C = x.redraw, j = x.containerProps, $ = x.children, I = x.style, F = c(x, O), M = e.useRef(null), V = e.useRef(!1), N = P(a(a({}, F), {}, {
      ref: M,
      startOnMount: typeof $ != "function" || x.delay === 0,
      // component manually restarts
      enableReinitialize: !1
    })), H = N.start, Y = N.reset, se = N.update, he = N.pauseResume, ae = N.getCountUp, ce = b(function() {
      H();
    }), ue = b(function(ne) {
      x.preserveValue || Y(), se(ne);
    }), K = b(function() {
      if (typeof x.children == "function" && !(M.current instanceof Element)) {
        console.error(`Couldn't find attached element to hook the CountUp instance into! Try to attach "containerRef" from the render prop to a an Element, eg. <span ref={containerRef} />.`);
        return;
      }
      ae();
    });
    e.useEffect(function() {
      K();
    }, [K]), e.useEffect(function() {
      V.current && ue(x.end);
    }, [x.end, ue]);
    var le = C && x;
    return e.useEffect(function() {
      C && V.current && ce();
    }, [ce, C, le]), e.useEffect(function() {
      !C && V.current && ce();
    }, [ce, C, x.start, x.suffix, x.prefix, x.duration, x.separator, x.decimals, x.decimal, x.className, x.formattingFn]), e.useEffect(function() {
      V.current = !0;
    }, []), typeof $ == "function" ? $({
      countUpRef: M,
      start: H,
      reset: Y,
      update: se,
      pauseResume: he,
      getCountUp: ae
    }) : /* @__PURE__ */ e.createElement("span", o({
      className: E,
      ref: M,
      style: I
    }, j), typeof x.start < "u" ? ae().formattingFn(x.start) : "");
  };
  return yt.default = T, yt.useCountUp = P, yt;
}
var Jv = Xv();
const Zv = /* @__PURE__ */ Ee(Jv), Qv = "_bar_1n5dj_1", ep = "_section_1n5dj_5", tp = "_sectionHidden_1n5dj_8", rp = "_sectionInheritRadius_1n5dj_11", np = "_valueOutside_1n5dj_15", st = {
  bar: Qv,
  section: ep,
  sectionHidden: tp,
  sectionInheritRadius: rp,
  valueOutside: np
}, Xt = ({
  value: e,
  label: t,
  labelWidth: r,
  theme: n = ["var(--dixa-color-purple-700)", "var(--dixa-color-neutral-200)"],
  showFullBar: a = !1,
  showDifference: i = !1
}) => {
  const o = Math.min(e, 100), [s, c] = ee([
    null,
    null
  ]), u = wl(s);
  ie(() => {
    c([
      o,
      ...a ? [100 - o] : []
    ]);
  }, [o, a]);
  const f = 1.5, l = Q(
    () => s.map((h, d) => {
      const g = o && d === 0 || i, v = h !== null && h < 20, m = $e(st.section, {
        [st.sectionHidden]: a && h === 0,
        [st.sectionInheritRadius]: !a
      }), b = $e(st.section, {
        [st.valueOutside]: v
      });
      return /* @__PURE__ */ _.jsx(
        X,
        {
          justifyContent: "flex-end",
          alignItems: "center",
          padding: "0 100",
          background: n[d],
          color: "neutral.000",
          className: m,
          style: {
            flexBasis: `${h ?? 0}%`,
            transition: `flex-basis ${f}s ease-out`
          },
          children: g && /* @__PURE__ */ _.jsx(
            G.Paragraph,
            {
              className: b,
              variant: "4",
              color: d === 0 && !v ? "var(--dixa-color-neutral-000)" : "var(--dixa-color-neutral-900)",
              children: /* @__PURE__ */ _.jsx(
                Zv,
                {
                  start: (u == null ? void 0 : u[d]) ?? 0,
                  end: h ?? 0,
                  duration: f,
                  delay: 0,
                  suffix: "%",
                  children: ({ countUpRef: y }) => /* @__PURE__ */ _.jsx("span", { ref: y })
                }
              )
            }
          )
        },
        d
      );
    }),
    [
      o,
      n,
      i,
      a,
      s,
      u
    ]
  );
  return /* @__PURE__ */ _.jsxs(X, { alignItems: "center", gap: "200", children: [
    t && /* @__PURE__ */ _.jsx(Zi, { minWidth: r ? `${r}px` : "auto", children: /* @__PURE__ */ _.jsx(G.Paragraph, { variant: "4", children: t }) }),
    /* @__PURE__ */ _.jsx(X, { flex: "1", className: st.bar, height: "20px", borderRadius: "50", children: l })
  ] });
}, ap = "_container_1t2a7_1", ip = {
  container: ap
}, op = we(
  function({
    granularities: t,
    onChangeGranularity: r
  }) {
    return /* @__PURE__ */ _.jsx(bl, { variant: "secondary", children: t.map(({ value: n, selected: a }) => /* @__PURE__ */ _.jsx(
      yl,
      {
        onClick: a ? void 0 : () => r == null ? void 0 : r(n),
        active: a,
        children: n
      },
      n
    )) });
  }
), sp = "_root_6kwn9_1", cp = "_rootBounded_6kwn9_7", up = "_rootFluid_6kwn9_7", Tr = {
  root: sp,
  rootBounded: cp,
  rootFluid: up
}, Ki = ({
  bounded: e = !1,
  fluid: t = !1,
  children: r
}) => {
  const n = $e(Tr.root, {
    [Tr.rootBounded]: e,
    [Tr.rootFluid]: t
  });
  return /* @__PURE__ */ _.jsx("div", { className: n, children: r });
};
function Ge(e, t = { compact: !1 }) {
  if (e < 1e3)
    return `${(e / 1e3).toFixed(0)}s`;
  const r = Math.floor(e / 1e3 % 60), n = Math.floor(e / (1e3 * 60) % 60), a = Math.floor(e / (1e3 * 60 * 60) % 24), i = Math.floor(e / (1e3 * 60 * 60 * 24)), o = (c, u) => c > 0 ? `${c}${u}` : "";
  return [
    o(i, "d"),
    o(a, "h"),
    o(n, "m") || (t.compact ? "" : "0m"),
    o(r, "s") || (t.compact ? "" : "0s")
  ].filter(Boolean).join(" ");
}
const is = 1e6, os = 1e3;
function sf(e) {
  if (e < os) return `${e}`;
  const t = e >= is;
  return `${parseFloat(
    (e / (t ? is : os)).toFixed(1)
  )}${t ? "M" : "K"}`;
}
function Et(e) {
  return e.toLocaleString(navigator.language);
}
const iy = (e) => ({
  metrics: e.filter(lp),
  chart: e.find(fp),
  heatmap: e.find(dp),
  table: e.find(hp),
  presence: e.find(vp),
  insight: e.find(pp)
}), lp = (e) => e.type === "metric", fp = (e) => e.type === "chart" && e.visualization !== "heatmap", dp = (e) => e.type === "chart" && e.visualization === "heatmap", hp = (e) => e.type === "table", vp = (e) => e.type === "presence", pp = (e) => e.type === "ai_insight", $t = (e, t) => {
  switch (t) {
    case "duration":
      return Ge(e).split(" ").slice(0, 2).join(" ");
    case "count":
      return sf(e);
    case "number":
      return Et(e);
    case "percentage":
      return `${Et(e)}%`;
    case "timer":
      return Ge(e);
    default:
      return "";
  }
}, co = [
  {
    name: "default",
    colors: [
      "var(--dixa-color-purple-700)",
      "var(--dixa-color-blue-300)",
      "var(--dixa-color-red-500)",
      "var(--dixa-color-orange-300)",
      "var(--dixa-color-purple-500)",
      "var(--dixa-color-green-400)",
      "var(--dixa-color-neutral-600)",
      "var(--dixa-color-neutral-300)"
    ]
  },
  {
    name: "rating",
    colors: [
      "var(--dixa-color-red-700)",
      "var(--dixa-color-red-400)",
      "var(--dixa-color-orange-300)",
      "var(--dixa-color-green-500)",
      "var(--dixa-color-green-600)"
    ]
  }
], cf = co[0], gp = (e) => e.startsWith("#"), uf = (e) => {
  var a;
  if (gp(e)) return e;
  const [t, r] = e.split("-"), n = co.find((i) => i.name === t) ?? cf;
  return ((a = n == null ? void 0 : n.colors) == null ? void 0 : a[Number(r) - 1]) ?? e;
}, Jt = (e, t = "default", r) => {
  if (r)
    return uf(r);
  const n = co.find(({ name: a }) => a === t) ?? cf;
  return n.colors[e % n.colors.length];
}, mp = we(
  function({
    data: t
  }) {
    const [r, n] = ee(0);
    return ie(() => {
      n(Date.now() - t);
    }, [t]), ad(() => {
      n(Date.now() - t);
    }, 1e3), /* @__PURE__ */ _.jsx(_.Fragment, { children: $t(r, "timer") });
  }
), bp = "_wrapper_1w7q6_1", yp = "_text_1w7q6_6", ss = {
  wrapper: bp,
  text: yp
}, _p = we(function({
  className: t,
  data: r,
  format: n,
  color: a,
  suffix: i
}) {
  const o = Q(() => {
    if (r === null) return "n.a.";
    switch (n) {
      case "timer":
        return /* @__PURE__ */ _.jsx(mp, { data: r });
      default:
        return $t(r, n);
    }
  }, [r, n]), s = Q(() => {
    if (r !== null)
      switch (n) {
        case "duration":
          return Ge(r);
        case "count":
          return Et(r);
        default:
          return;
      }
  }, [r, n]), u = !(r !== null && s !== o) || ["number", "percentage", "timer"].includes(n);
  return /* @__PURE__ */ _.jsx(
    Ot,
    {
      content: s,
      disabled: u,
      wrap: "div",
      wrapProps: { className: ss.wrapper },
      children: /* @__PURE__ */ _.jsxs(
        G.Heading,
        {
          variant: "heading-1",
          color: a ?? (r === null ? "tertiary" : void 0),
          className: $e(ss.text, t),
          as: "span",
          children: [
            o,
            i
          ]
        }
      )
    }
  );
}), xp = "_colorIndicator_luubh_1", wp = {
  colorIndicator: xp
}, lf = we(function({
  instrument: t,
  theme: r = "light"
}) {
  const { data: n, format: a, title: i, description: o, color: s } = t, c = s ? uf(s) : void 0, u = r === "dark" ? "inherit" : void 0;
  return /* @__PURE__ */ _.jsxs(X, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ _.jsxs(X, { alignItems: "center", gap: "100", title: i, children: [
      s && /* @__PURE__ */ _.jsx(
        Zi,
        {
          as: "span",
          className: wp.colorIndicator,
          background: c
        }
      ),
      /* @__PURE__ */ _.jsx(G.Paragraph, { variant: "4", color: u, subdued: !0, children: i })
    ] }),
    /* @__PURE__ */ _.jsx(_p, { data: n, format: a, color: u }),
    o && /* @__PURE__ */ _.jsx(G.Paragraph, { variant: "4", color: u, subdued: !0, children: o })
  ] });
});
var $r, cs;
function ff() {
  if (cs) return $r;
  cs = 1;
  var e = typeof Nt == "object" && Nt && Nt.Object === Object && Nt;
  return $r = e, $r;
}
var qr, us;
function Oe() {
  if (us) return qr;
  us = 1;
  var e = ff(), t = typeof self == "object" && self && self.Object === Object && self, r = e || t || Function("return this")();
  return qr = r, qr;
}
var jr, ls;
function qt() {
  if (ls) return jr;
  ls = 1;
  var e = Oe(), t = e.Symbol;
  return jr = t, jr;
}
var Ir, fs;
function df() {
  if (fs) return Ir;
  fs = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length, i = Array(a); ++n < a; )
      i[n] = r(t[n], n, t);
    return i;
  }
  return Ir = e, Ir;
}
var Mr, ds;
function Ce() {
  if (ds) return Mr;
  ds = 1;
  var e = Array.isArray;
  return Mr = e, Mr;
}
var Dr, hs;
function Rp() {
  if (hs) return Dr;
  hs = 1;
  var e = qt(), t = Object.prototype, r = t.hasOwnProperty, n = t.toString, a = e ? e.toStringTag : void 0;
  function i(o) {
    var s = r.call(o, a), c = o[a];
    try {
      o[a] = void 0;
      var u = !0;
    } catch {
    }
    var f = n.call(o);
    return u && (s ? o[a] = c : delete o[a]), f;
  }
  return Dr = i, Dr;
}
var Nr, vs;
function Cp() {
  if (vs) return Nr;
  vs = 1;
  var e = Object.prototype, t = e.toString;
  function r(n) {
    return t.call(n);
  }
  return Nr = r, Nr;
}
var Fr, ps;
function Xe() {
  if (ps) return Fr;
  ps = 1;
  var e = qt(), t = Rp(), r = Cp(), n = "[object Null]", a = "[object Undefined]", i = e ? e.toStringTag : void 0;
  function o(s) {
    return s == null ? s === void 0 ? a : n : i && i in Object(s) ? t(s) : r(s);
  }
  return Fr = o, Fr;
}
var Lr, gs;
function Je() {
  if (gs) return Lr;
  gs = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return Lr = e, Lr;
}
var kr, ms;
function jt() {
  if (ms) return kr;
  ms = 1;
  var e = Xe(), t = Je(), r = "[object Symbol]";
  function n(a) {
    return typeof a == "symbol" || t(a) && e(a) == r;
  }
  return kr = n, kr;
}
var Br, bs;
function hf() {
  if (bs) return Br;
  bs = 1;
  var e = qt(), t = df(), r = Ce(), n = jt(), a = e ? e.prototype : void 0, i = a ? a.toString : void 0;
  function o(s) {
    if (typeof s == "string")
      return s;
    if (r(s))
      return t(s, o) + "";
    if (n(s))
      return i ? i.call(s) : "";
    var c = s + "";
    return c == "0" && 1 / s == -1 / 0 ? "-0" : c;
  }
  return Br = o, Br;
}
var Vr, ys;
function Sp() {
  if (ys) return Vr;
  ys = 1;
  function e(t, r, n) {
    var a = -1, i = t.length;
    r < 0 && (r = -r > i ? 0 : i + r), n = n > i ? i : n, n < 0 && (n += i), i = r > n ? 0 : n - r >>> 0, r >>>= 0;
    for (var o = Array(i); ++a < i; )
      o[a] = t[a + r];
    return o;
  }
  return Vr = e, Vr;
}
var Hr, _s;
function Pp() {
  if (_s) return Hr;
  _s = 1;
  var e = Sp();
  function t(r, n, a) {
    var i = r.length;
    return a = a === void 0 ? i : a, !n && a >= i ? r : e(r, n, a);
  }
  return Hr = t, Hr;
}
var Ur, xs;
function uo() {
  if (xs) return Ur;
  xs = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", a = t + r + n, i = "\\ufe0e\\ufe0f", o = "\\u200d", s = RegExp("[" + o + e + a + i + "]");
  function c(u) {
    return s.test(u);
  }
  return Ur = c, Ur;
}
var zr, ws;
function Ze() {
  if (ws) return zr;
  ws = 1;
  function e(t) {
    var r = typeof t;
    return t != null && (r == "object" || r == "function");
  }
  return zr = e, zr;
}
var Wr, Rs;
function Ep() {
  if (Rs) return Wr;
  Rs = 1;
  var e = Xe(), t = Je(), r = "[object RegExp]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return Wr = n, Wr;
}
var Gr, Cs;
function lo() {
  if (Cs) return Gr;
  Cs = 1;
  function e(t) {
    return function(r) {
      return t(r);
    };
  }
  return Gr = e, Gr;
}
var Rt = { exports: {} };
Rt.exports;
var Ss;
function vf() {
  return Ss || (Ss = 1, function(e, t) {
    var r = ff(), n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, i = a && a.exports === n, o = i && r.process, s = function() {
      try {
        var c = a && a.require && a.require("util").types;
        return c || o && o.binding && o.binding("util");
      } catch {
      }
    }();
    e.exports = s;
  }(Rt, Rt.exports)), Rt.exports;
}
var Kr, Ps;
function Op() {
  if (Ps) return Kr;
  Ps = 1;
  var e = Ep(), t = lo(), r = vf(), n = r && r.isRegExp, a = n ? t(n) : e;
  return Kr = a, Kr;
}
var Yr, Es;
function pf() {
  if (Es) return Yr;
  Es = 1;
  function e(t) {
    return function(r) {
      return r == null ? void 0 : r[t];
    };
  }
  return Yr = e, Yr;
}
var Xr, Os;
function Ap() {
  if (Os) return Xr;
  Os = 1;
  var e = pf(), t = e("length");
  return Xr = t, Xr;
}
var Jr, As;
function Tp() {
  if (As) return Jr;
  As = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", a = t + r + n, i = "\\ufe0e\\ufe0f", o = "[" + e + "]", s = "[" + a + "]", c = "\\ud83c[\\udffb-\\udfff]", u = "(?:" + s + "|" + c + ")", f = "[^" + e + "]", l = "(?:\\ud83c[\\udde6-\\uddff]){2}", h = "[\\ud800-\\udbff][\\udc00-\\udfff]", d = "\\u200d", g = u + "?", v = "[" + i + "]?", m = "(?:" + d + "(?:" + [f, l, h].join("|") + ")" + v + g + ")*", b = v + g + m, y = "(?:" + [f + s + "?", s, l, h, o].join("|") + ")", S = RegExp(c + "(?=" + c + ")|" + y + b, "g");
  function R(P) {
    for (var O = S.lastIndex = 0; S.test(P); )
      ++O;
    return O;
  }
  return Jr = R, Jr;
}
var Zr, Ts;
function $p() {
  if (Ts) return Zr;
  Ts = 1;
  var e = Ap(), t = uo(), r = Tp();
  function n(a) {
    return t(a) ? r(a) : e(a);
  }
  return Zr = n, Zr;
}
var Qr, $s;
function qp() {
  if ($s) return Qr;
  $s = 1;
  function e(t) {
    return t.split("");
  }
  return Qr = e, Qr;
}
var en, qs;
function jp() {
  if (qs) return en;
  qs = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", a = t + r + n, i = "\\ufe0e\\ufe0f", o = "[" + e + "]", s = "[" + a + "]", c = "\\ud83c[\\udffb-\\udfff]", u = "(?:" + s + "|" + c + ")", f = "[^" + e + "]", l = "(?:\\ud83c[\\udde6-\\uddff]){2}", h = "[\\ud800-\\udbff][\\udc00-\\udfff]", d = "\\u200d", g = u + "?", v = "[" + i + "]?", m = "(?:" + d + "(?:" + [f, l, h].join("|") + ")" + v + g + ")*", b = v + g + m, y = "(?:" + [f + s + "?", s, l, h, o].join("|") + ")", S = RegExp(c + "(?=" + c + ")|" + y + b, "g");
  function R(P) {
    return P.match(S) || [];
  }
  return en = R, en;
}
var tn, js;
function Ip() {
  if (js) return tn;
  js = 1;
  var e = qp(), t = uo(), r = jp();
  function n(a) {
    return t(a) ? r(a) : e(a);
  }
  return tn = n, tn;
}
var rn, Is;
function Mp() {
  if (Is) return rn;
  Is = 1;
  var e = /\s/;
  function t(r) {
    for (var n = r.length; n-- && e.test(r.charAt(n)); )
      ;
    return n;
  }
  return rn = t, rn;
}
var nn, Ms;
function Dp() {
  if (Ms) return nn;
  Ms = 1;
  var e = Mp(), t = /^\s+/;
  function r(n) {
    return n && n.slice(0, e(n) + 1).replace(t, "");
  }
  return nn = r, nn;
}
var an, Ds;
function gf() {
  if (Ds) return an;
  Ds = 1;
  var e = Dp(), t = Ze(), r = jt(), n = NaN, a = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, o = /^0o[0-7]+$/i, s = parseInt;
  function c(u) {
    if (typeof u == "number")
      return u;
    if (r(u))
      return n;
    if (t(u)) {
      var f = typeof u.valueOf == "function" ? u.valueOf() : u;
      u = t(f) ? f + "" : f;
    }
    if (typeof u != "string")
      return u === 0 ? u : +u;
    u = e(u);
    var l = i.test(u);
    return l || o.test(u) ? s(u.slice(2), l ? 2 : 8) : a.test(u) ? n : +u;
  }
  return an = c, an;
}
var on, Ns;
function Np() {
  if (Ns) return on;
  Ns = 1;
  var e = gf(), t = 1 / 0, r = 17976931348623157e292;
  function n(a) {
    if (!a)
      return a === 0 ? a : 0;
    if (a = e(a), a === t || a === -1 / 0) {
      var i = a < 0 ? -1 : 1;
      return i * r;
    }
    return a === a ? a : 0;
  }
  return on = n, on;
}
var sn, Fs;
function Fp() {
  if (Fs) return sn;
  Fs = 1;
  var e = Np();
  function t(r) {
    var n = e(r), a = n % 1;
    return n === n ? a ? n - a : n : 0;
  }
  return sn = t, sn;
}
var cn, Ls;
function mf() {
  if (Ls) return cn;
  Ls = 1;
  var e = hf();
  function t(r) {
    return r == null ? "" : e(r);
  }
  return cn = t, cn;
}
var un, ks;
function Lp() {
  if (ks) return un;
  ks = 1;
  var e = hf(), t = Pp(), r = uo(), n = Ze(), a = Op(), i = $p(), o = Ip(), s = Fp(), c = mf(), u = 30, f = "...", l = /\w*$/;
  function h(d, g) {
    var v = u, m = f;
    if (n(g)) {
      var b = "separator" in g ? g.separator : b;
      v = "length" in g ? s(g.length) : v, m = "omission" in g ? e(g.omission) : m;
    }
    d = c(d);
    var y = d.length;
    if (r(d)) {
      var S = o(d);
      y = S.length;
    }
    if (v >= y)
      return d;
    var R = v - i(m);
    if (R < 1)
      return m;
    var P = S ? t(S, 0, R).join("") : d.slice(0, R);
    if (b === void 0)
      return P + m;
    if (S && (R += P.length - R), a(b)) {
      if (d.slice(R).search(b)) {
        var O, T = P;
        for (b.global || (b = RegExp(b.source, c(l.exec(b)) + "g")), b.lastIndex = 0; O = b.exec(T); )
          var w = O.index;
        P = P.slice(0, w === void 0 ? R : w);
      }
    } else if (d.indexOf(e(b), R) != R) {
      var x = P.lastIndexOf(b);
      x > -1 && (P = P.slice(0, x));
    }
    return P + m;
  }
  return un = h, un;
}
var kp = Lp();
const Bp = /* @__PURE__ */ Ee(kp), bf = (e, t = "D", {
  long: r = !1,
  timezone: n = ke.tz.guess()
} = {}) => {
  const a = ke.tz(e, n), i = ke.locale() === "en", o = (s) => r ? s.format("ddd, ll") : s.format(i ? "MMM DD" : "DD MMM");
  switch (t) {
    case "H":
      return a.format("LT");
    case "W":
      return r ? `${o(a)} - ${o(
        a.endOf("week")
      )} (W${a.format("W")})` : o(a);
    case "M":
      return a.format(r ? "MMM YYYY" : "MMM");
    case "D":
    default:
      return o(a);
  }
}, yf = (e, t = {}) => t != null && t.length ? Bp(e, t) : e, Vp = "_root_5qjlc_1", Hp = {
  root: Vp
}, Up = we(function({
  instrument: t,
  granularity: r,
  timezone: n,
  tooltipProps: a
}) {
  const { active: i, payload: o, label: s } = a, { categories: c, series: u } = t.data, f = c.find((b) => b.label === s), l = (f == null ? void 0 : f.metrics) ?? [], h = 6 * 4, d = Math.max(0, ((o == null ? void 0 : o.length) ?? 0) - h), g = Q(
    () => o == null ? void 0 : o.slice(
      0,
      // When there are more series than the limit, subtract one to make room for the overflow indicator.
      d > 0 ? h - 1 : h
    ).map((b, y) => {
      var R;
      return {
        type: "metric",
        title: b.name ?? "",
        color: b.color,
        format: ((R = u[y].options) == null ? void 0 : R.format) ?? "number",
        data: b.value ?? 0
      };
    }),
    [o, u, h, d]
  ), v = J(
    (b) => b == null ? void 0 : b.map((y) => /* @__PURE__ */ _.jsx(
      lf,
      {
        instrument: y,
        theme: "dark"
      },
      y.title
    )),
    []
  ), m = Q(
    () => ke(s, ke.ISO_8601).isValid() ? bf(s, r, { timezone: n, long: !0 }) : yf(s),
    [r, s, n]
  );
  return !i || !o ? null : /* @__PURE__ */ _.jsxs("div", { className: Hp.root, children: [
    /* @__PURE__ */ _.jsxs(X, { flexDirection: "column", gap: "100", children: [
      /* @__PURE__ */ _.jsx(G.Paragraph, { as: "div", variant: "1", color: "inherit", children: m }),
      (f == null ? void 0 : f.description) && /* @__PURE__ */ _.jsx(G.Paragraph, { variant: "4", color: "inherit", children: f.description })
    ] }),
    l.length > 0 && /* @__PURE__ */ _.jsx(Ki, { bounded: !0, children: v(l) }),
    /* @__PURE__ */ _.jsxs(Ki, { bounded: !0, children: [
      v(g),
      d > 0 && /* @__PURE__ */ _.jsx(X, { flex: "1", alignItems: "center", children: /* @__PURE__ */ _.jsxs(G.Heading, { variant: "heading-2", color: "inherit", children: [
        "+ ",
        d + 1,
        " more"
      ] }) })
    ] })
  ] });
}), zp = {
  fontFamily: "var(--dixa-typography-family-default)",
  fontSize: "var(--dixa-typography-size-200)",
  fill: "var(--dixa-typography-color-tertiary)"
}, Wp = {
  bar: "chart-bar",
  line: "activity"
}, lt = {
  tickCount: 5,
  tickProps: zp,
  visualizationIcons: Wp
}, Gp = ["bar", "line"], Kp = we(
  function({
    visualization: t,
    onChangeVisualization: r
  }) {
    return /* @__PURE__ */ _.jsx(bl, { variant: "secondary", children: Gp.map((n) => /* @__PURE__ */ _.jsx(
      Ji,
      {
        icon: lt.visualizationIcons[n],
        onClick: () => {
          r(n);
        },
        active: t === n
      },
      n
    )) });
  }
), Yp = ({
  instrument: e,
  granularity: t,
  timezone: r,
  syncOptions: n
}) => {
  const { data: a, layout: i } = e, o = i === "horizontal", s = i === "vertical", c = 192, u = Q(() => {
    if (s) return 0;
    const g = a.categories.length % 2 === 0;
    switch (t) {
      // There are always an even number of categories, so we preserve the first tick in order to
      // ensure that hours are shown in even intervals e.g. 08:00, 10:00, 12:00 ... 22:00.
      case "H":
        return "preserveStart";
      // When the number of days is even, we preserve the last tick in order to ensure that
      // days are shown in equal intervals e.g. Apr 2, Apr 4, Apr 6 ... Apr 30. When uneven, we
      // preserve the first tick, resulting in equal intervals e.g. Mar 1, Mar 4, Mar 7 ... Mar 31.
      case "D":
      case "W":
        return g ? "preserveEnd" : "preserveStart";
      default:
        return "preserveStartEnd";
    }
  }, [a.categories.length, t, s]), f = {
    dataKey: "name",
    width: s ? c : 0,
    tickLine: {
      stroke: "var(--dixa-color-neutral-200)"
    },
    axisLine: {
      stroke: "var(--dixa-color-neutral-200)"
    },
    tickSize: 6,
    tickMargin: 8,
    interval: u,
    tick: lt.tickProps,
    tickFormatter: (g) => ke(g, ke.ISO_8601).isValid() ? bf(g, t, { timezone: r }) : yf(g, { length: c / 10 })
  }, l = {
    domain: [0, "auto"],
    allowDecimals: !1,
    tickLine: !1,
    axisLine: !1,
    tick: lt.tickProps,
    ticks: n == null ? void 0 : n.ticks,
    tickCount: lt.tickCount,
    tickFormatter: (g) => {
      var v;
      return $t(g, ((v = a.series[0].options) == null ? void 0 : v.format) ?? "number");
    }
  }, h = o ? { type: "category", ...f } : { type: "number", ...l }, d = o ? { type: "number", ...l } : { type: "category", ...f };
  return { xAxisProps: h, yAxisProps: d };
};
var ln, Bs;
function Xp() {
  if (Bs) return ln;
  Bs = 1;
  var e = Oe(), t = function() {
    return e.Date.now();
  };
  return ln = t, ln;
}
var fn, Vs;
function Jp() {
  if (Vs) return fn;
  Vs = 1;
  var e = Ze(), t = Xp(), r = gf(), n = "Expected a function", a = Math.max, i = Math.min;
  function o(s, c, u) {
    var f, l, h, d, g, v, m = 0, b = !1, y = !1, S = !0;
    if (typeof s != "function")
      throw new TypeError(n);
    c = r(c) || 0, e(u) && (b = !!u.leading, y = "maxWait" in u, h = y ? a(r(u.maxWait) || 0, c) : h, S = "trailing" in u ? !!u.trailing : S);
    function R($) {
      var I = f, F = l;
      return f = l = void 0, m = $, d = s.apply(F, I), d;
    }
    function P($) {
      return m = $, g = setTimeout(w, c), b ? R($) : d;
    }
    function O($) {
      var I = $ - v, F = $ - m, M = c - I;
      return y ? i(M, h - F) : M;
    }
    function T($) {
      var I = $ - v, F = $ - m;
      return v === void 0 || I >= c || I < 0 || y && F >= h;
    }
    function w() {
      var $ = t();
      if (T($))
        return x($);
      g = setTimeout(w, O($));
    }
    function x($) {
      return g = void 0, S && f ? R($) : (f = l = void 0, d);
    }
    function E() {
      g !== void 0 && clearTimeout(g), m = 0, f = v = l = g = void 0;
    }
    function C() {
      return g === void 0 ? d : x(t());
    }
    function j() {
      var $ = t(), I = T($);
      if (f = arguments, l = this, v = $, I) {
        if (g === void 0)
          return P(v);
        if (y)
          return clearTimeout(g), g = setTimeout(w, c), R(v);
      }
      return g === void 0 && (g = setTimeout(w, c)), d;
    }
    return j.cancel = E, j.flush = C, j;
  }
  return fn = o, fn;
}
var Zp = Jp();
const Qp = /* @__PURE__ */ Ee(Zp), eg = "_legendItem_j1yv3_34", tg = "_legendItemInactive_j1yv3_41", rg = "_legendIcon_j1yv3_45", ng = "_legendIconBar_j1yv3_52", ag = "_legendIconLine_j1yv3_55", _t = {
  legendItem: eg,
  legendItemInactive: tg,
  legendIcon: rg,
  legendIconBar: ng,
  legendIconLine: ag
}, ig = we(function({
  instrument: t,
  legend: r,
  visualization: n,
  onToggleLegendItem: a,
  onMouseEnterLegendItem: i,
  onMouseLeaveLegendItem: o,
  hoveredLegend: s
}) {
  const { series: c, options: u } = t.data, { layout: f } = (u == null ? void 0 : u.legend) ?? {
    layout: "horizontal"
  }, l = f === "horizontal";
  return /* @__PURE__ */ _.jsx(
    X,
    {
      padding: l ? "0" : "0 0 0 400",
      flexDirection: l ? "row" : "column",
      gap: l ? "400" : "200",
      justifyContent: "center",
      children: c.map(({ label: h, options: d }, g) => {
        const v = Jt(
          g,
          void 0,
          d == null ? void 0 : d.color
        ), m = $e(_t.legendItem, {
          [_t.legendItemInactive]: s && s !== h
        }), b = $e(_t.legendIcon, {
          [_t.legendIconBar]: n === "bar",
          [_t.legendIconLine]: n === "line"
        });
        return /* @__PURE__ */ _.jsxs(
          X,
          {
            gap: "200",
            flexDirection: "row",
            alignItems: "center",
            className: m,
            onClick: () => a(h),
            onMouseEnter: () => i == null ? void 0 : i(h),
            onMouseLeave: () => o == null ? void 0 : o(h),
            children: [
              /* @__PURE__ */ _.jsx(
                "span",
                {
                  className: b,
                  style: {
                    borderColor: v,
                    backgroundColor: r.includes(h) ? v : "transparent"
                  }
                }
              ),
              /* @__PURE__ */ _.jsx(G.Paragraph, { variant: "4", subdued: !0, children: h })
            ]
          },
          h
        );
      })
    }
  );
}), og = ({
  instrument: e,
  visualization: t
}) => {
  var m, b;
  const {
    data: { series: r, options: n }
  } = e, a = ((m = n == null ? void 0 : n.legend) == null ? void 0 : m.layout) === "horizontal", [i, o] = id(
    r.filter(({ options: y }) => (y == null ? void 0 : y.visible) ?? !0).map(({ label: y }) => y)
  ), [s, c] = ee(null);
  At(() => {
    u();
  }, [r.length]);
  const u = J(() => {
    o.set(r.map(({ label: y }) => y));
  }, [r, o]), f = J(
    (y) => {
      i.includes(y) && c(y);
    },
    [i]
  ), l = Q(
    () => Qp(f, 300),
    [f]
  ), h = J(() => {
    l.cancel(), c(null);
  }, [l]), d = J(
    (y) => {
      i.length === r.length ? o.filter((S) => S === y) : i.length === 1 && i.includes(y) ? u() : i.includes(y) ? o.removeAt(i.indexOf(y)) : o.push(y);
    },
    [r.length, u, i, o]
  ), g = Q(
    () => r.length < 10 ? {
      onMouseEnterLegendItem: l,
      onMouseLeaveLegendItem: h,
      hoveredLegend: s
    } : {},
    [
      l,
      h,
      s,
      r.length
    ]
  ), v = Q(
    () => {
      var y;
      return {
        layout: (y = n == null ? void 0 : n.legend) == null ? void 0 : y.layout,
        align: a ? "center" : "right",
        verticalAlign: a ? "bottom" : "middle",
        wrapperStyle: {
          overflow: "auto",
          ...a ? {
            bottom: 0
          } : {
            right: 0,
            width: 208,
            maxHeight: "100%"
          }
        },
        // Using the render function form instead of directly passing an element prevents the
        // `ChartInstrumentLegend` component from re-rendering unnecessarily due to Recharts props
        // changing, because Recharts automatically passes props to the `content` element.
        content: () => /* @__PURE__ */ _.jsx(
          ig,
          {
            visualization: t,
            instrument: e,
            legend: i,
            onToggleLegendItem: d,
            ...g
          }
        )
      };
    },
    [
      d,
      e,
      a,
      i,
      g,
      (b = n == null ? void 0 : n.legend) == null ? void 0 : b.layout,
      t
    ]
  );
  return {
    legend: i,
    legendProps: v,
    hoveredLegend: s
  };
};
var dn, Hs;
function sg() {
  if (Hs) return dn;
  Hs = 1;
  function e(t) {
    var r = t == null ? 0 : t.length;
    return r ? t[r - 1] : void 0;
  }
  return dn = e, dn;
}
var cg = sg();
const ug = /* @__PURE__ */ Ee(cg);
var hn, Us;
function fo() {
  if (Us) return hn;
  Us = 1;
  var e = Ce(), t = jt(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, n = /^\w*$/;
  function a(i, o) {
    if (e(i))
      return !1;
    var s = typeof i;
    return s == "number" || s == "symbol" || s == "boolean" || i == null || t(i) ? !0 : n.test(i) || !r.test(i) || o != null && i in Object(o);
  }
  return hn = a, hn;
}
var vn, zs;
function _f() {
  if (zs) return vn;
  zs = 1;
  var e = Xe(), t = Ze(), r = "[object AsyncFunction]", n = "[object Function]", a = "[object GeneratorFunction]", i = "[object Proxy]";
  function o(s) {
    if (!t(s))
      return !1;
    var c = e(s);
    return c == n || c == a || c == r || c == i;
  }
  return vn = o, vn;
}
var pn, Ws;
function lg() {
  if (Ws) return pn;
  Ws = 1;
  var e = Oe(), t = e["__core-js_shared__"];
  return pn = t, pn;
}
var gn, Gs;
function fg() {
  if (Gs) return gn;
  Gs = 1;
  var e = lg(), t = function() {
    var n = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  }();
  function r(n) {
    return !!t && t in n;
  }
  return gn = r, gn;
}
var mn, Ks;
function xf() {
  if (Ks) return mn;
  Ks = 1;
  var e = Function.prototype, t = e.toString;
  function r(n) {
    if (n != null) {
      try {
        return t.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return mn = r, mn;
}
var bn, Ys;
function dg() {
  if (Ys) return bn;
  Ys = 1;
  var e = _f(), t = fg(), r = Ze(), n = xf(), a = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, o = Function.prototype, s = Object.prototype, c = o.toString, u = s.hasOwnProperty, f = RegExp(
    "^" + c.call(u).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function l(h) {
    if (!r(h) || t(h))
      return !1;
    var d = e(h) ? f : i;
    return d.test(n(h));
  }
  return bn = l, bn;
}
var yn, Xs;
function hg() {
  if (Xs) return yn;
  Xs = 1;
  function e(t, r) {
    return t == null ? void 0 : t[r];
  }
  return yn = e, yn;
}
var _n, Js;
function Qe() {
  if (Js) return _n;
  Js = 1;
  var e = dg(), t = hg();
  function r(n, a) {
    var i = t(n, a);
    return e(i) ? i : void 0;
  }
  return _n = r, _n;
}
var xn, Zs;
function lr() {
  if (Zs) return xn;
  Zs = 1;
  var e = Qe(), t = e(Object, "create");
  return xn = t, xn;
}
var wn, Qs;
function vg() {
  if (Qs) return wn;
  Qs = 1;
  var e = lr();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return wn = t, wn;
}
var Rn, ec;
function pg() {
  if (ec) return Rn;
  ec = 1;
  function e(t) {
    var r = this.has(t) && delete this.__data__[t];
    return this.size -= r ? 1 : 0, r;
  }
  return Rn = e, Rn;
}
var Cn, tc;
function gg() {
  if (tc) return Cn;
  tc = 1;
  var e = lr(), t = "__lodash_hash_undefined__", r = Object.prototype, n = r.hasOwnProperty;
  function a(i) {
    var o = this.__data__;
    if (e) {
      var s = o[i];
      return s === t ? void 0 : s;
    }
    return n.call(o, i) ? o[i] : void 0;
  }
  return Cn = a, Cn;
}
var Sn, rc;
function mg() {
  if (rc) return Sn;
  rc = 1;
  var e = lr(), t = Object.prototype, r = t.hasOwnProperty;
  function n(a) {
    var i = this.__data__;
    return e ? i[a] !== void 0 : r.call(i, a);
  }
  return Sn = n, Sn;
}
var Pn, nc;
function bg() {
  if (nc) return Pn;
  nc = 1;
  var e = lr(), t = "__lodash_hash_undefined__";
  function r(n, a) {
    var i = this.__data__;
    return this.size += this.has(n) ? 0 : 1, i[n] = e && a === void 0 ? t : a, this;
  }
  return Pn = r, Pn;
}
var En, ac;
function yg() {
  if (ac) return En;
  ac = 1;
  var e = vg(), t = pg(), r = gg(), n = mg(), a = bg();
  function i(o) {
    var s = -1, c = o == null ? 0 : o.length;
    for (this.clear(); ++s < c; ) {
      var u = o[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = r, i.prototype.has = n, i.prototype.set = a, En = i, En;
}
var On, ic;
function _g() {
  if (ic) return On;
  ic = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return On = e, On;
}
var An, oc;
function ho() {
  if (oc) return An;
  oc = 1;
  function e(t, r) {
    return t === r || t !== t && r !== r;
  }
  return An = e, An;
}
var Tn, sc;
function fr() {
  if (sc) return Tn;
  sc = 1;
  var e = ho();
  function t(r, n) {
    for (var a = r.length; a--; )
      if (e(r[a][0], n))
        return a;
    return -1;
  }
  return Tn = t, Tn;
}
var $n, cc;
function xg() {
  if (cc) return $n;
  cc = 1;
  var e = fr(), t = Array.prototype, r = t.splice;
  function n(a) {
    var i = this.__data__, o = e(i, a);
    if (o < 0)
      return !1;
    var s = i.length - 1;
    return o == s ? i.pop() : r.call(i, o, 1), --this.size, !0;
  }
  return $n = n, $n;
}
var qn, uc;
function wg() {
  if (uc) return qn;
  uc = 1;
  var e = fr();
  function t(r) {
    var n = this.__data__, a = e(n, r);
    return a < 0 ? void 0 : n[a][1];
  }
  return qn = t, qn;
}
var jn, lc;
function Rg() {
  if (lc) return jn;
  lc = 1;
  var e = fr();
  function t(r) {
    return e(this.__data__, r) > -1;
  }
  return jn = t, jn;
}
var In, fc;
function Cg() {
  if (fc) return In;
  fc = 1;
  var e = fr();
  function t(r, n) {
    var a = this.__data__, i = e(a, r);
    return i < 0 ? (++this.size, a.push([r, n])) : a[i][1] = n, this;
  }
  return In = t, In;
}
var Mn, dc;
function dr() {
  if (dc) return Mn;
  dc = 1;
  var e = _g(), t = xg(), r = wg(), n = Rg(), a = Cg();
  function i(o) {
    var s = -1, c = o == null ? 0 : o.length;
    for (this.clear(); ++s < c; ) {
      var u = o[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = r, i.prototype.has = n, i.prototype.set = a, Mn = i, Mn;
}
var Dn, hc;
function vo() {
  if (hc) return Dn;
  hc = 1;
  var e = Qe(), t = Oe(), r = e(t, "Map");
  return Dn = r, Dn;
}
var Nn, vc;
function Sg() {
  if (vc) return Nn;
  vc = 1;
  var e = yg(), t = dr(), r = vo();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || t)(),
      string: new e()
    };
  }
  return Nn = n, Nn;
}
var Fn, pc;
function Pg() {
  if (pc) return Fn;
  pc = 1;
  function e(t) {
    var r = typeof t;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
  }
  return Fn = e, Fn;
}
var Ln, gc;
function hr() {
  if (gc) return Ln;
  gc = 1;
  var e = Pg();
  function t(r, n) {
    var a = r.__data__;
    return e(n) ? a[typeof n == "string" ? "string" : "hash"] : a.map;
  }
  return Ln = t, Ln;
}
var kn, mc;
function Eg() {
  if (mc) return kn;
  mc = 1;
  var e = hr();
  function t(r) {
    var n = e(this, r).delete(r);
    return this.size -= n ? 1 : 0, n;
  }
  return kn = t, kn;
}
var Bn, bc;
function Og() {
  if (bc) return Bn;
  bc = 1;
  var e = hr();
  function t(r) {
    return e(this, r).get(r);
  }
  return Bn = t, Bn;
}
var Vn, yc;
function Ag() {
  if (yc) return Vn;
  yc = 1;
  var e = hr();
  function t(r) {
    return e(this, r).has(r);
  }
  return Vn = t, Vn;
}
var Hn, _c;
function Tg() {
  if (_c) return Hn;
  _c = 1;
  var e = hr();
  function t(r, n) {
    var a = e(this, r), i = a.size;
    return a.set(r, n), this.size += a.size == i ? 0 : 1, this;
  }
  return Hn = t, Hn;
}
var Un, xc;
function po() {
  if (xc) return Un;
  xc = 1;
  var e = Sg(), t = Eg(), r = Og(), n = Ag(), a = Tg();
  function i(o) {
    var s = -1, c = o == null ? 0 : o.length;
    for (this.clear(); ++s < c; ) {
      var u = o[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = r, i.prototype.has = n, i.prototype.set = a, Un = i, Un;
}
var zn, wc;
function $g() {
  if (wc) return zn;
  wc = 1;
  var e = po(), t = "Expected a function";
  function r(n, a) {
    if (typeof n != "function" || a != null && typeof a != "function")
      throw new TypeError(t);
    var i = function() {
      var o = arguments, s = a ? a.apply(this, o) : o[0], c = i.cache;
      if (c.has(s))
        return c.get(s);
      var u = n.apply(this, o);
      return i.cache = c.set(s, u) || c, u;
    };
    return i.cache = new (r.Cache || e)(), i;
  }
  return r.Cache = e, zn = r, zn;
}
var Wn, Rc;
function qg() {
  if (Rc) return Wn;
  Rc = 1;
  var e = $g(), t = 500;
  function r(n) {
    var a = e(n, function(o) {
      return i.size === t && i.clear(), o;
    }), i = a.cache;
    return a;
  }
  return Wn = r, Wn;
}
var Gn, Cc;
function jg() {
  if (Cc) return Gn;
  Cc = 1;
  var e = qg(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, n = e(function(a) {
    var i = [];
    return a.charCodeAt(0) === 46 && i.push(""), a.replace(t, function(o, s, c, u) {
      i.push(c ? u.replace(r, "$1") : s || o);
    }), i;
  });
  return Gn = n, Gn;
}
var Kn, Sc;
function vr() {
  if (Sc) return Kn;
  Sc = 1;
  var e = Ce(), t = fo(), r = jg(), n = mf();
  function a(i, o) {
    return e(i) ? i : t(i, o) ? [i] : r(n(i));
  }
  return Kn = a, Kn;
}
var Yn, Pc;
function It() {
  if (Pc) return Yn;
  Pc = 1;
  var e = jt();
  function t(r) {
    if (typeof r == "string" || e(r))
      return r;
    var n = r + "";
    return n == "0" && 1 / r == -1 / 0 ? "-0" : n;
  }
  return Yn = t, Yn;
}
var Xn, Ec;
function pr() {
  if (Ec) return Xn;
  Ec = 1;
  var e = vr(), t = It();
  function r(n, a) {
    a = e(a, n);
    for (var i = 0, o = a.length; n != null && i < o; )
      n = n[t(a[i++])];
    return i && i == o ? n : void 0;
  }
  return Xn = r, Xn;
}
var Jn, Oc;
function wf() {
  if (Oc) return Jn;
  Oc = 1;
  var e = Qe(), t = function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  }();
  return Jn = t, Jn;
}
var Zn, Ac;
function Ig() {
  if (Ac) return Zn;
  Ac = 1;
  var e = wf();
  function t(r, n, a) {
    n == "__proto__" && e ? e(r, n, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[n] = a;
  }
  return Zn = t, Zn;
}
var Qn, Tc;
function Mg() {
  if (Tc) return Qn;
  Tc = 1;
  var e = Ig(), t = ho(), r = Object.prototype, n = r.hasOwnProperty;
  function a(i, o, s) {
    var c = i[o];
    (!(n.call(i, o) && t(c, s)) || s === void 0 && !(o in i)) && e(i, o, s);
  }
  return Qn = a, Qn;
}
var ea, $c;
function go() {
  if ($c) return ea;
  $c = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function r(n, a) {
    var i = typeof n;
    return a = a ?? e, !!a && (i == "number" || i != "symbol" && t.test(n)) && n > -1 && n % 1 == 0 && n < a;
  }
  return ea = r, ea;
}
var ta, qc;
function Dg() {
  if (qc) return ta;
  qc = 1;
  var e = Mg(), t = vr(), r = go(), n = Ze(), a = It();
  function i(o, s, c, u) {
    if (!n(o))
      return o;
    s = t(s, o);
    for (var f = -1, l = s.length, h = l - 1, d = o; d != null && ++f < l; ) {
      var g = a(s[f]), v = c;
      if (g === "__proto__" || g === "constructor" || g === "prototype")
        return o;
      if (f != h) {
        var m = d[g];
        v = u ? u(m, g, d) : void 0, v === void 0 && (v = n(m) ? m : r(s[f + 1]) ? [] : {});
      }
      e(d, g, v), d = d[g];
    }
    return o;
  }
  return ta = i, ta;
}
var ra, jc;
function Ng() {
  if (jc) return ra;
  jc = 1;
  var e = pr(), t = Dg(), r = vr();
  function n(a, i, o) {
    for (var s = -1, c = i.length, u = {}; ++s < c; ) {
      var f = i[s], l = e(a, f);
      o(l, f) && t(u, r(f, a), l);
    }
    return u;
  }
  return ra = n, ra;
}
var na, Ic;
function Fg() {
  if (Ic) return na;
  Ic = 1;
  function e(t, r) {
    return t != null && r in Object(t);
  }
  return na = e, na;
}
var aa, Mc;
function Lg() {
  if (Mc) return aa;
  Mc = 1;
  var e = Xe(), t = Je(), r = "[object Arguments]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return aa = n, aa;
}
var ia, Dc;
function mo() {
  if (Dc) return ia;
  Dc = 1;
  var e = Lg(), t = Je(), r = Object.prototype, n = r.hasOwnProperty, a = r.propertyIsEnumerable, i = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(o) {
    return t(o) && n.call(o, "callee") && !a.call(o, "callee");
  };
  return ia = i, ia;
}
var oa, Nc;
function bo() {
  if (Nc) return oa;
  Nc = 1;
  var e = 9007199254740991;
  function t(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return oa = t, oa;
}
var sa, Fc;
function kg() {
  if (Fc) return sa;
  Fc = 1;
  var e = vr(), t = mo(), r = Ce(), n = go(), a = bo(), i = It();
  function o(s, c, u) {
    c = e(c, s);
    for (var f = -1, l = c.length, h = !1; ++f < l; ) {
      var d = i(c[f]);
      if (!(h = s != null && u(s, d)))
        break;
      s = s[d];
    }
    return h || ++f != l ? h : (l = s == null ? 0 : s.length, !!l && a(l) && n(d, l) && (r(s) || t(s)));
  }
  return sa = o, sa;
}
var ca, Lc;
function Rf() {
  if (Lc) return ca;
  Lc = 1;
  var e = Fg(), t = kg();
  function r(n, a) {
    return n != null && t(n, a, e);
  }
  return ca = r, ca;
}
var ua, kc;
function Bg() {
  if (kc) return ua;
  kc = 1;
  var e = Ng(), t = Rf();
  function r(n, a) {
    return e(n, a, function(i, o) {
      return t(n, o);
    });
  }
  return ua = r, ua;
}
var la, Bc;
function Cf() {
  if (Bc) return la;
  Bc = 1;
  function e(t, r) {
    for (var n = -1, a = r.length, i = t.length; ++n < a; )
      t[i + n] = r[n];
    return t;
  }
  return la = e, la;
}
var fa, Vc;
function Vg() {
  if (Vc) return fa;
  Vc = 1;
  var e = qt(), t = mo(), r = Ce(), n = e ? e.isConcatSpreadable : void 0;
  function a(i) {
    return r(i) || t(i) || !!(n && i && i[n]);
  }
  return fa = a, fa;
}
var da, Hc;
function Hg() {
  if (Hc) return da;
  Hc = 1;
  var e = Cf(), t = Vg();
  function r(n, a, i, o, s) {
    var c = -1, u = n.length;
    for (i || (i = t), s || (s = []); ++c < u; ) {
      var f = n[c];
      a > 0 && i(f) ? a > 1 ? r(f, a - 1, i, o, s) : e(s, f) : o || (s[s.length] = f);
    }
    return s;
  }
  return da = r, da;
}
var ha, Uc;
function Ug() {
  if (Uc) return ha;
  Uc = 1;
  var e = Hg();
  function t(r) {
    var n = r == null ? 0 : r.length;
    return n ? e(r, 1) : [];
  }
  return ha = t, ha;
}
var va, zc;
function zg() {
  if (zc) return va;
  zc = 1;
  function e(t, r, n) {
    switch (n.length) {
      case 0:
        return t.call(r);
      case 1:
        return t.call(r, n[0]);
      case 2:
        return t.call(r, n[0], n[1]);
      case 3:
        return t.call(r, n[0], n[1], n[2]);
    }
    return t.apply(r, n);
  }
  return va = e, va;
}
var pa, Wc;
function Wg() {
  if (Wc) return pa;
  Wc = 1;
  var e = zg(), t = Math.max;
  function r(n, a, i) {
    return a = t(a === void 0 ? n.length - 1 : a, 0), function() {
      for (var o = arguments, s = -1, c = t(o.length - a, 0), u = Array(c); ++s < c; )
        u[s] = o[a + s];
      s = -1;
      for (var f = Array(a + 1); ++s < a; )
        f[s] = o[s];
      return f[a] = i(u), e(n, this, f);
    };
  }
  return pa = r, pa;
}
var ga, Gc;
function Gg() {
  if (Gc) return ga;
  Gc = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return ga = e, ga;
}
var ma, Kc;
function gr() {
  if (Kc) return ma;
  Kc = 1;
  function e(t) {
    return t;
  }
  return ma = e, ma;
}
var ba, Yc;
function Kg() {
  if (Yc) return ba;
  Yc = 1;
  var e = Gg(), t = wf(), r = gr(), n = t ? function(a, i) {
    return t(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(i),
      writable: !0
    });
  } : r;
  return ba = n, ba;
}
var ya, Xc;
function Yg() {
  if (Xc) return ya;
  Xc = 1;
  var e = 800, t = 16, r = Date.now;
  function n(a) {
    var i = 0, o = 0;
    return function() {
      var s = r(), c = t - (s - o);
      if (o = s, c > 0) {
        if (++i >= e)
          return arguments[0];
      } else
        i = 0;
      return a.apply(void 0, arguments);
    };
  }
  return ya = n, ya;
}
var _a, Jc;
function Xg() {
  if (Jc) return _a;
  Jc = 1;
  var e = Kg(), t = Yg(), r = t(e);
  return _a = r, _a;
}
var xa, Zc;
function Jg() {
  if (Zc) return xa;
  Zc = 1;
  var e = Ug(), t = Wg(), r = Xg();
  function n(a) {
    return r(t(a, void 0, e), a + "");
  }
  return xa = n, xa;
}
var wa, Qc;
function Zg() {
  if (Qc) return wa;
  Qc = 1;
  var e = Bg(), t = Jg(), r = t(function(n, a) {
    return n == null ? {} : e(n, a);
  });
  return wa = r, wa;
}
var Qg = Zg();
const em = /* @__PURE__ */ Ee(Qg);
var Ra, eu;
function tm() {
  if (eu) return Ra;
  eu = 1;
  function e(t, r) {
    for (var n, a = -1, i = t.length; ++a < i; ) {
      var o = r(t[a]);
      o !== void 0 && (n = n === void 0 ? o : n + o);
    }
    return n;
  }
  return Ra = e, Ra;
}
var Ca, tu;
function rm() {
  if (tu) return Ca;
  tu = 1;
  var e = tm(), t = gr();
  function r(n) {
    return n && n.length ? e(n, t) : 0;
  }
  return Ca = r, Ca;
}
var nm = rm();
const am = /* @__PURE__ */ Ee(nm), im = ({
  instrument: e,
  legend: t,
  hoveredLegend: r,
  hoveredCategory: n
}) => {
  const { data: a, layout: i } = e, o = J(() => {
    const { series: u } = a;
    return u.map(({ label: l, options: h }, d) => {
      var b;
      const g = Jt(
        d,
        (b = a.options) == null ? void 0 : b.theme,
        h == null ? void 0 : h.color
      );
      return {
        key: l,
        type: "monotone",
        dot: !1,
        activeDot: { r: 5 },
        dataKey: l,
        stroke: g,
        strokeWidth: 2,
        strokeOpacity: r === null || r === l ? 1 : 0.4,
        connectNulls: !0,
        hide: !t.includes(l),
        animationEasing: "linear"
      };
    });
  }, [a, r, t]), s = J(() => {
    const { categories: u, series: f } = a, l = f.filter(({ label: v }) => t.includes(v)), h = i === "vertical", d = h ? [0, 2, 2, 0] : [2, 2, 0, 0];
    return f.map(
      ({ label: v, options: m, data: b }, y) => {
        var x, E;
        const S = Jt(
          y,
          (x = a.options) == null ? void 0 : x.theme,
          m == null ? void 0 : m.color
        ), R = m == null ? void 0 : m.stack, P = R ? ((E = ug(l)) == null ? void 0 : E.label) === v : !0, O = l.length <= 10 && (R ? P : !0), T = /* @__PURE__ */ _.jsxs(_.Fragment, { children: [
          O && /* @__PURE__ */ _.jsx(
            sd,
            {
              position: h ? "right" : "top",
              valueAccessor: ({ payload: C }) => (
                // In the case of stacked series, the total sum of all
                // visible series values for the current category is
                // displayed. For individual series, their own value is
                // displayed by using their `label` from the Recharts data.
                R ? am(Object.values(em(C, t))) : Number(C[v] ?? 0)
              ),
              formatter: (C) => C ? $t(C, (m == null ? void 0 : m.format) ?? "number") : "",
              ...lt.tickProps,
              offset: 8,
              fontSize: "var(--dixa-typography-size-100)"
            }
          ),
          b.map((C, j) => {
            var M, V, N;
            const $ = f.length > 1 ? S : Jt(
              j,
              (M = a.options) == null ? void 0 : M.theme,
              // If there is only one series, the category color is used if specified, otherwise
              // the colors are determined by the category index, resulting in different colors
              // being used for each category and repeating as necessary.
              ((N = (V = u[j]) == null ? void 0 : V.options) == null ? void 0 : N.color) ?? (m == null ? void 0 : m.color)
            ), I = n === null || n === j, F = r === null || r === v;
            return /* @__PURE__ */ _.jsx(
              cd,
              {
                fill: $,
                fillOpacity: I && F ? 1 : 0.4
              },
              `${v}-${j}`
            );
          })
        ] });
        return {
          key: v,
          dataKey: v,
          stackId: R,
          fill: S,
          radius: P ? d : 0,
          maxBarSize: 80,
          hide: !t.includes(v),
          animationEasing: "linear",
          children: T
        };
      }
    );
  }, [a, n, r, i, t]);
  return { getSeriesProps: J(
    (u) => u === "line" ? o() : u === "bar" ? s() : [],
    [s, o]
  ) };
}, om = (e, t) => e.categories.map((r, n) => {
  const a = e.series.reduce(
    (o, { label: s, data: c }) => {
      const { value: u } = yo(c[n]);
      return (t.omitZero ? !u : u === null) ? o : { ...o, [s]: u };
    },
    {}
  );
  return {
    name: r.label,
    ...a
  };
}), yo = (e) => e === null || typeof e == "number" ? { value: e } : {
  value: (e == null ? void 0 : e.value) ?? null,
  metrics: e == null ? void 0 : e.metrics
}, oy = we(function({
  instrument: t,
  panel: r,
  timezone: n,
  syncOptions: a,
  onChangeGranularity: i,
  onChangeVisualization: o
}) {
  var F, M, V;
  const [s, c] = ee(
    ((F = r.controls) == null ? void 0 : F.settings.visualization) ?? t.visualization
  ), [u, f] = ee(null), { data: l, layout: h, title: d } = t, g = h === "horizontal", v = h === "vertical", m = Q(
    () => om(l, { omitZero: s === "bar" }),
    [l, s]
  ), b = Q(
    () => {
      var N, H;
      return (H = (N = l.granularities) == null ? void 0 : N.find(({ selected: Y }) => Y)) == null ? void 0 : H.value;
    },
    [l.granularities]
  ), { xAxisProps: y, yAxisProps: S } = Yp({
    instrument: t,
    granularity: b,
    timezone: n,
    syncOptions: a
  }), { legend: R, legendProps: P, hoveredLegend: O } = og({
    instrument: t,
    visualization: s
  }), { getSeriesProps: T } = im({
    instrument: t,
    legend: R,
    hoveredLegend: O,
    hoveredCategory: u
  });
  At(() => {
    var N;
    c(
      ((N = r.controls) == null ? void 0 : N.settings.visualization) ?? t.visualization
    );
  }, [(M = r.controls) == null ? void 0 : M.settings.visualization, t.visualization]);
  const w = J(
    (N) => {
      c(N), o == null || o(N);
    },
    [o]
  ), x = (N) => {
    if (!(N != null && N.isTooltipActive)) {
      f(null);
      return;
    }
    const H = N.activeTooltipIndex;
    if (typeof H != "number") return;
    const Y = Object.values(m[H] ?? {}).length > 1;
    f(Y ? H : null);
  }, E = () => {
    f(null);
  }, C = () => s === "line" ? T(s).map(({ key: H, ...Y }) => /* @__PURE__ */ _.jsx(yd, { ...Y }, H)) : s === "bar" ? T(s).map(({ key: H, ...Y }) => /* @__PURE__ */ _.jsx(_d, { ...Y }, H)) : null, j = () => {
    var he, ae, ce, ue, K, le;
    const N = (ae = (he = l.options) == null ? void 0 : he.legend) == null ? void 0 : ae.layout, H = 16, Y = {
      layout: h,
      syncId: a != null && a.tooltip ? r.id : void 0,
      data: m,
      margin: {
        top: g ? H : 0,
        right: v || N === "vertical" ? H : 0,
        bottom: N === "horizontal" ? H / 2 : 0,
        left: 0
      }
    }, se = /* @__PURE__ */ _.jsxs(_.Fragment, { children: [
      /* @__PURE__ */ _.jsx(ld, { ...y }),
      /* @__PURE__ */ _.jsx(fd, { ...S }),
      ((ce = l.options) == null ? void 0 : ce.cartesian) && /* @__PURE__ */ _.jsx(
        dd,
        {
          vertical: v,
          horizontal: g,
          stroke: "var(--dixa-color-neutral-200)"
        }
      ),
      (ue = l.references) == null ? void 0 : ue.map(({ value: ne, label: te }, ve) => /* @__PURE__ */ _.jsx(
        hd,
        {
          ...g ? { y: ne } : { x: ne },
          stroke: "var(--dixa-color-neutral-500)",
          strokeDasharray: "5 5",
          isFront: !0,
          children: /* @__PURE__ */ _.jsx(
            vd,
            {
              value: te,
              offset: 8,
              fontSize: "var(--dixa-typography-size-200)",
              position: g ? "insideBottomLeft" : "insideTopLeft"
            }
          )
        },
        ve
      )),
      ((K = l.options) == null ? void 0 : K.legend) && /* @__PURE__ */ _.jsx(pd, { ...P }),
      ((le = l.options) == null ? void 0 : le.tooltip) && /* @__PURE__ */ _.jsx(
        gd,
        {
          content: (ne) => /* @__PURE__ */ _.jsx(
            Up,
            {
              instrument: t,
              granularity: b,
              timezone: n,
              tooltipProps: ne
            }
          ),
          cursor: { fill: "transparent" }
        }
      ),
      C()
    ] });
    switch (s) {
      case "bar":
        return /* @__PURE__ */ _.jsx(
          bd,
          {
            ...Y,
            barGap: "1",
            onMouseMove: x,
            onMouseLeave: E,
            children: se
          }
        );
      case "line":
        return /* @__PURE__ */ _.jsx(md, { ...Y, children: se });
    }
  };
  if (!l.categories.length || !l.series.length)
    return /* @__PURE__ */ _.jsx(
      X,
      {
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        children: /* @__PURE__ */ _.jsx(
          _l,
          {
            title: "No data available",
            description: "There is no data available for the selected period and filters.",
            icon: lt.visualizationIcons[s]
          }
        )
      }
    );
  const $ = [
    l.granularities && l.granularities.length > 1 ? /* @__PURE__ */ _.jsx(
      op,
      {
        granularities: l.granularities,
        onChangeGranularity: i
      }
    ) : null,
    (V = l.options) != null && V.visualizations ? /* @__PURE__ */ _.jsx(
      Kp,
      {
        visualization: s,
        onChangeVisualization: w
      }
    ) : null
  ], I = $.some(Boolean);
  return /* @__PURE__ */ _.jsxs(_.Fragment, { children: [
    d && /* @__PURE__ */ _.jsx("div", { children: /* @__PURE__ */ _.jsx(G.Heading, { variant: "heading-4", children: d }) }),
    I && /* @__PURE__ */ _.jsx(X, { alignSelf: "flex-end", gap: "300", children: $.map((N, H) => /* @__PURE__ */ _.jsx(ml, { children: N }, H)) }),
    /* @__PURE__ */ _.jsx(
      ud,
      {
        className: ip.container,
        width: "100%",
        height: "100%",
        debounce: 100,
        children: j()
      }
    )
  ] });
});
var Sa, ru;
function sm() {
  if (ru) return Sa;
  ru = 1;
  var e = dr();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return Sa = t, Sa;
}
var Pa, nu;
function cm() {
  if (nu) return Pa;
  nu = 1;
  function e(t) {
    var r = this.__data__, n = r.delete(t);
    return this.size = r.size, n;
  }
  return Pa = e, Pa;
}
var Ea, au;
function um() {
  if (au) return Ea;
  au = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return Ea = e, Ea;
}
var Oa, iu;
function lm() {
  if (iu) return Oa;
  iu = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Oa = e, Oa;
}
var Aa, ou;
function fm() {
  if (ou) return Aa;
  ou = 1;
  var e = dr(), t = vo(), r = po(), n = 200;
  function a(i, o) {
    var s = this.__data__;
    if (s instanceof e) {
      var c = s.__data__;
      if (!t || c.length < n - 1)
        return c.push([i, o]), this.size = ++s.size, this;
      s = this.__data__ = new r(c);
    }
    return s.set(i, o), this.size = s.size, this;
  }
  return Aa = a, Aa;
}
var Ta, su;
function Sf() {
  if (su) return Ta;
  su = 1;
  var e = dr(), t = sm(), r = cm(), n = um(), a = lm(), i = fm();
  function o(s) {
    var c = this.__data__ = new e(s);
    this.size = c.size;
  }
  return o.prototype.clear = t, o.prototype.delete = r, o.prototype.get = n, o.prototype.has = a, o.prototype.set = i, Ta = o, Ta;
}
var $a, cu;
function dm() {
  if (cu) return $a;
  cu = 1;
  var e = "__lodash_hash_undefined__";
  function t(r) {
    return this.__data__.set(r, e), this;
  }
  return $a = t, $a;
}
var qa, uu;
function hm() {
  if (uu) return qa;
  uu = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return qa = e, qa;
}
var ja, lu;
function vm() {
  if (lu) return ja;
  lu = 1;
  var e = po(), t = dm(), r = hm();
  function n(a) {
    var i = -1, o = a == null ? 0 : a.length;
    for (this.__data__ = new e(); ++i < o; )
      this.add(a[i]);
  }
  return n.prototype.add = n.prototype.push = t, n.prototype.has = r, ja = n, ja;
}
var Ia, fu;
function pm() {
  if (fu) return Ia;
  fu = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length; ++n < a; )
      if (r(t[n], n, t))
        return !0;
    return !1;
  }
  return Ia = e, Ia;
}
var Ma, du;
function gm() {
  if (du) return Ma;
  du = 1;
  function e(t, r) {
    return t.has(r);
  }
  return Ma = e, Ma;
}
var Da, hu;
function Pf() {
  if (hu) return Da;
  hu = 1;
  var e = vm(), t = pm(), r = gm(), n = 1, a = 2;
  function i(o, s, c, u, f, l) {
    var h = c & n, d = o.length, g = s.length;
    if (d != g && !(h && g > d))
      return !1;
    var v = l.get(o), m = l.get(s);
    if (v && m)
      return v == s && m == o;
    var b = -1, y = !0, S = c & a ? new e() : void 0;
    for (l.set(o, s), l.set(s, o); ++b < d; ) {
      var R = o[b], P = s[b];
      if (u)
        var O = h ? u(P, R, b, s, o, l) : u(R, P, b, o, s, l);
      if (O !== void 0) {
        if (O)
          continue;
        y = !1;
        break;
      }
      if (S) {
        if (!t(s, function(T, w) {
          if (!r(S, w) && (R === T || f(R, T, c, u, l)))
            return S.push(w);
        })) {
          y = !1;
          break;
        }
      } else if (!(R === P || f(R, P, c, u, l))) {
        y = !1;
        break;
      }
    }
    return l.delete(o), l.delete(s), y;
  }
  return Da = i, Da;
}
var Na, vu;
function mm() {
  if (vu) return Na;
  vu = 1;
  var e = Oe(), t = e.Uint8Array;
  return Na = t, Na;
}
var Fa, pu;
function bm() {
  if (pu) return Fa;
  pu = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(a, i) {
      n[++r] = [i, a];
    }), n;
  }
  return Fa = e, Fa;
}
var La, gu;
function ym() {
  if (gu) return La;
  gu = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(a) {
      n[++r] = a;
    }), n;
  }
  return La = e, La;
}
var ka, mu;
function _m() {
  if (mu) return ka;
  mu = 1;
  var e = qt(), t = mm(), r = ho(), n = Pf(), a = bm(), i = ym(), o = 1, s = 2, c = "[object Boolean]", u = "[object Date]", f = "[object Error]", l = "[object Map]", h = "[object Number]", d = "[object RegExp]", g = "[object Set]", v = "[object String]", m = "[object Symbol]", b = "[object ArrayBuffer]", y = "[object DataView]", S = e ? e.prototype : void 0, R = S ? S.valueOf : void 0;
  function P(O, T, w, x, E, C, j) {
    switch (w) {
      case y:
        if (O.byteLength != T.byteLength || O.byteOffset != T.byteOffset)
          return !1;
        O = O.buffer, T = T.buffer;
      case b:
        return !(O.byteLength != T.byteLength || !C(new t(O), new t(T)));
      case c:
      case u:
      case h:
        return r(+O, +T);
      case f:
        return O.name == T.name && O.message == T.message;
      case d:
      case v:
        return O == T + "";
      case l:
        var $ = a;
      case g:
        var I = x & o;
        if ($ || ($ = i), O.size != T.size && !I)
          return !1;
        var F = j.get(O);
        if (F)
          return F == T;
        x |= s, j.set(O, T);
        var M = n($(O), $(T), x, E, C, j);
        return j.delete(O), M;
      case m:
        if (R)
          return R.call(O) == R.call(T);
    }
    return !1;
  }
  return ka = P, ka;
}
var Ba, bu;
function xm() {
  if (bu) return Ba;
  bu = 1;
  var e = Cf(), t = Ce();
  function r(n, a, i) {
    var o = a(n);
    return t(n) ? o : e(o, i(n));
  }
  return Ba = r, Ba;
}
var Va, yu;
function wm() {
  if (yu) return Va;
  yu = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length, i = 0, o = []; ++n < a; ) {
      var s = t[n];
      r(s, n, t) && (o[i++] = s);
    }
    return o;
  }
  return Va = e, Va;
}
var Ha, _u;
function Rm() {
  if (_u) return Ha;
  _u = 1;
  function e() {
    return [];
  }
  return Ha = e, Ha;
}
var Ua, xu;
function Cm() {
  if (xu) return Ua;
  xu = 1;
  var e = wm(), t = Rm(), r = Object.prototype, n = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, i = a ? function(o) {
    return o == null ? [] : (o = Object(o), e(a(o), function(s) {
      return n.call(o, s);
    }));
  } : t;
  return Ua = i, Ua;
}
var za, wu;
function Sm() {
  if (wu) return za;
  wu = 1;
  function e(t, r) {
    for (var n = -1, a = Array(t); ++n < t; )
      a[n] = r(n);
    return a;
  }
  return za = e, za;
}
var Ct = { exports: {} }, Wa, Ru;
function Pm() {
  if (Ru) return Wa;
  Ru = 1;
  function e() {
    return !1;
  }
  return Wa = e, Wa;
}
Ct.exports;
var Cu;
function Ef() {
  return Cu || (Cu = 1, function(e, t) {
    var r = Oe(), n = Pm(), a = t && !t.nodeType && t, i = a && !0 && e && !e.nodeType && e, o = i && i.exports === a, s = o ? r.Buffer : void 0, c = s ? s.isBuffer : void 0, u = c || n;
    e.exports = u;
  }(Ct, Ct.exports)), Ct.exports;
}
var Ga, Su;
function Em() {
  if (Su) return Ga;
  Su = 1;
  var e = Xe(), t = bo(), r = Je(), n = "[object Arguments]", a = "[object Array]", i = "[object Boolean]", o = "[object Date]", s = "[object Error]", c = "[object Function]", u = "[object Map]", f = "[object Number]", l = "[object Object]", h = "[object RegExp]", d = "[object Set]", g = "[object String]", v = "[object WeakMap]", m = "[object ArrayBuffer]", b = "[object DataView]", y = "[object Float32Array]", S = "[object Float64Array]", R = "[object Int8Array]", P = "[object Int16Array]", O = "[object Int32Array]", T = "[object Uint8Array]", w = "[object Uint8ClampedArray]", x = "[object Uint16Array]", E = "[object Uint32Array]", C = {};
  C[y] = C[S] = C[R] = C[P] = C[O] = C[T] = C[w] = C[x] = C[E] = !0, C[n] = C[a] = C[m] = C[i] = C[b] = C[o] = C[s] = C[c] = C[u] = C[f] = C[l] = C[h] = C[d] = C[g] = C[v] = !1;
  function j($) {
    return r($) && t($.length) && !!C[e($)];
  }
  return Ga = j, Ga;
}
var Ka, Pu;
function Of() {
  if (Pu) return Ka;
  Pu = 1;
  var e = Em(), t = lo(), r = vf(), n = r && r.isTypedArray, a = n ? t(n) : e;
  return Ka = a, Ka;
}
var Ya, Eu;
function Om() {
  if (Eu) return Ya;
  Eu = 1;
  var e = Sm(), t = mo(), r = Ce(), n = Ef(), a = go(), i = Of(), o = Object.prototype, s = o.hasOwnProperty;
  function c(u, f) {
    var l = r(u), h = !l && t(u), d = !l && !h && n(u), g = !l && !h && !d && i(u), v = l || h || d || g, m = v ? e(u.length, String) : [], b = m.length;
    for (var y in u)
      (f || s.call(u, y)) && !(v && // Safari 9 has enumerable `arguments.length` in strict mode.
      (y == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      d && (y == "offset" || y == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      g && (y == "buffer" || y == "byteLength" || y == "byteOffset") || // Skip index properties.
      a(y, b))) && m.push(y);
    return m;
  }
  return Ya = c, Ya;
}
var Xa, Ou;
function Am() {
  if (Ou) return Xa;
  Ou = 1;
  var e = Object.prototype;
  function t(r) {
    var n = r && r.constructor, a = typeof n == "function" && n.prototype || e;
    return r === a;
  }
  return Xa = t, Xa;
}
var Ja, Au;
function Tm() {
  if (Au) return Ja;
  Au = 1;
  function e(t, r) {
    return function(n) {
      return t(r(n));
    };
  }
  return Ja = e, Ja;
}
var Za, Tu;
function $m() {
  if (Tu) return Za;
  Tu = 1;
  var e = Tm(), t = e(Object.keys, Object);
  return Za = t, Za;
}
var Qa, $u;
function qm() {
  if ($u) return Qa;
  $u = 1;
  var e = Am(), t = $m(), r = Object.prototype, n = r.hasOwnProperty;
  function a(i) {
    if (!e(i))
      return t(i);
    var o = [];
    for (var s in Object(i))
      n.call(i, s) && s != "constructor" && o.push(s);
    return o;
  }
  return Qa = a, Qa;
}
var ei, qu;
function _o() {
  if (qu) return ei;
  qu = 1;
  var e = _f(), t = bo();
  function r(n) {
    return n != null && t(n.length) && !e(n);
  }
  return ei = r, ei;
}
var ti, ju;
function xo() {
  if (ju) return ti;
  ju = 1;
  var e = Om(), t = qm(), r = _o();
  function n(a) {
    return r(a) ? e(a) : t(a);
  }
  return ti = n, ti;
}
var ri, Iu;
function jm() {
  if (Iu) return ri;
  Iu = 1;
  var e = xm(), t = Cm(), r = xo();
  function n(a) {
    return e(a, r, t);
  }
  return ri = n, ri;
}
var ni, Mu;
function Im() {
  if (Mu) return ni;
  Mu = 1;
  var e = jm(), t = 1, r = Object.prototype, n = r.hasOwnProperty;
  function a(i, o, s, c, u, f) {
    var l = s & t, h = e(i), d = h.length, g = e(o), v = g.length;
    if (d != v && !l)
      return !1;
    for (var m = d; m--; ) {
      var b = h[m];
      if (!(l ? b in o : n.call(o, b)))
        return !1;
    }
    var y = f.get(i), S = f.get(o);
    if (y && S)
      return y == o && S == i;
    var R = !0;
    f.set(i, o), f.set(o, i);
    for (var P = l; ++m < d; ) {
      b = h[m];
      var O = i[b], T = o[b];
      if (c)
        var w = l ? c(T, O, b, o, i, f) : c(O, T, b, i, o, f);
      if (!(w === void 0 ? O === T || u(O, T, s, c, f) : w)) {
        R = !1;
        break;
      }
      P || (P = b == "constructor");
    }
    if (R && !P) {
      var x = i.constructor, E = o.constructor;
      x != E && "constructor" in i && "constructor" in o && !(typeof x == "function" && x instanceof x && typeof E == "function" && E instanceof E) && (R = !1);
    }
    return f.delete(i), f.delete(o), R;
  }
  return ni = a, ni;
}
var ai, Du;
function Mm() {
  if (Du) return ai;
  Du = 1;
  var e = Qe(), t = Oe(), r = e(t, "DataView");
  return ai = r, ai;
}
var ii, Nu;
function Dm() {
  if (Nu) return ii;
  Nu = 1;
  var e = Qe(), t = Oe(), r = e(t, "Promise");
  return ii = r, ii;
}
var oi, Fu;
function Nm() {
  if (Fu) return oi;
  Fu = 1;
  var e = Qe(), t = Oe(), r = e(t, "Set");
  return oi = r, oi;
}
var si, Lu;
function Fm() {
  if (Lu) return si;
  Lu = 1;
  var e = Qe(), t = Oe(), r = e(t, "WeakMap");
  return si = r, si;
}
var ci, ku;
function Lm() {
  if (ku) return ci;
  ku = 1;
  var e = Mm(), t = vo(), r = Dm(), n = Nm(), a = Fm(), i = Xe(), o = xf(), s = "[object Map]", c = "[object Object]", u = "[object Promise]", f = "[object Set]", l = "[object WeakMap]", h = "[object DataView]", d = o(e), g = o(t), v = o(r), m = o(n), b = o(a), y = i;
  return (e && y(new e(new ArrayBuffer(1))) != h || t && y(new t()) != s || r && y(r.resolve()) != u || n && y(new n()) != f || a && y(new a()) != l) && (y = function(S) {
    var R = i(S), P = R == c ? S.constructor : void 0, O = P ? o(P) : "";
    if (O)
      switch (O) {
        case d:
          return h;
        case g:
          return s;
        case v:
          return u;
        case m:
          return f;
        case b:
          return l;
      }
    return R;
  }), ci = y, ci;
}
var ui, Bu;
function km() {
  if (Bu) return ui;
  Bu = 1;
  var e = Sf(), t = Pf(), r = _m(), n = Im(), a = Lm(), i = Ce(), o = Ef(), s = Of(), c = 1, u = "[object Arguments]", f = "[object Array]", l = "[object Object]", h = Object.prototype, d = h.hasOwnProperty;
  function g(v, m, b, y, S, R) {
    var P = i(v), O = i(m), T = P ? f : a(v), w = O ? f : a(m);
    T = T == u ? l : T, w = w == u ? l : w;
    var x = T == l, E = w == l, C = T == w;
    if (C && o(v)) {
      if (!o(m))
        return !1;
      P = !0, x = !1;
    }
    if (C && !x)
      return R || (R = new e()), P || s(v) ? t(v, m, b, y, S, R) : r(v, m, T, b, y, S, R);
    if (!(b & c)) {
      var j = x && d.call(v, "__wrapped__"), $ = E && d.call(m, "__wrapped__");
      if (j || $) {
        var I = j ? v.value() : v, F = $ ? m.value() : m;
        return R || (R = new e()), S(I, F, b, y, R);
      }
    }
    return C ? (R || (R = new e()), n(v, m, b, y, S, R)) : !1;
  }
  return ui = g, ui;
}
var li, Vu;
function wo() {
  if (Vu) return li;
  Vu = 1;
  var e = km(), t = Je();
  function r(n, a, i, o, s) {
    return n === a ? !0 : n == null || a == null || !t(n) && !t(a) ? n !== n && a !== a : e(n, a, i, o, r, s);
  }
  return li = r, li;
}
var fi, Hu;
function Bm() {
  if (Hu) return fi;
  Hu = 1;
  var e = wo();
  function t(r, n) {
    return e(r, n);
  }
  return fi = t, fi;
}
var Vm = Bm();
const Hm = /* @__PURE__ */ Ee(Vm);
var di, Uu;
function Um() {
  if (Uu) return di;
  Uu = 1;
  var e = Xe(), t = Je(), r = "[object Number]";
  function n(a) {
    return typeof a == "number" || t(a) && e(a) == r;
  }
  return di = n, di;
}
var zm = Um();
const Af = /* @__PURE__ */ Ee(zm), Wm = "_trigger_1mrk9_1", Gm = {
  trigger: Wm
}, Km = we(function({
  title: t,
  metrics: r,
  children: n
}) {
  const a = /* @__PURE__ */ _.jsxs(X, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ _.jsx(G.Paragraph, { variant: "1", color: "inherit", children: t }),
    r.length > 0 && /* @__PURE__ */ _.jsx(Ki, { bounded: !0, children: r.map((i, o) => /* @__PURE__ */ _.jsx(lf, { instrument: i, theme: "dark" }, o)) })
  ] });
  return /* @__PURE__ */ _.jsx(
    Ot,
    {
      content: a,
      wrap: "div",
      wrapProps: { className: Gm.trigger },
      children: n
    }
  );
}), Ym = "_cell_hfkay_1", Xm = "_cellText_hfkay_11", Jm = "_cellDimmed_hfkay_14", Zm = "_cellContent_hfkay_18", xt = {
  cell: Ym,
  cellText: Xm,
  cellDimmed: Jm,
  cellContent: Zm
}, zt = we(function({
  cell: t,
  dimmed: r = !1,
  background: n = "transparent",
  tooltipProps: a,
  textProps: i = {},
  onMouseEnter: o
}) {
  const [s, c] = ee(!1), u = wl(t == null ? void 0 : t.value);
  At(() => {
    if ((t == null ? void 0 : t.value) !== u) {
      c(!0);
      const h = setTimeout(() => {
        c(!1);
      }, 200);
      return () => {
        clearTimeout(h);
      };
    }
  }, [t == null ? void 0 : t.value]);
  const f = Q(() => {
    if (!t) return null;
    const { value: h, format: d } = t;
    return typeof h == "string" ? h : typeof h == "number" && d ? $t(h, d) : "—";
  }, [t]);
  if (!t)
    return /* @__PURE__ */ _.jsx(
      "div",
      {
        className: xt.cell,
        onMouseEnter: o,
        "data-testid": "heatmap-instrument-cell"
      }
    );
  const l = /* @__PURE__ */ _.jsx("div", { className: xt.cellContent, children: /* @__PURE__ */ _.jsx(
    G.Paragraph,
    {
      className: $e({
        [xt.cellText]: typeof t.value == "string"
      }),
      variant: "3",
      subdued: !Af(t.value),
      ...i,
      children: f
    }
  ) });
  return /* @__PURE__ */ _.jsx(
    "div",
    {
      className: $e(xt.cell, {
        [xt.cellDimmed]: r || s
      }),
      onMouseEnter: o,
      style: { backgroundColor: n },
      "data-animating": s,
      "data-testid": "heatmap-instrument-cell",
      children: a != null && a.enabled ? /* @__PURE__ */ _.jsx(Km, { ...a, children: l }) : l
    }
  );
}), Qm = "_grid_1qk2p_1", eb = "_row_1qk2p_7", hi = {
  grid: Qm,
  row: eb
};
var zu = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function tb(e, t) {
  return !!(e === t || zu(e) && zu(t));
}
function rb(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (!tb(e[r], t[r]))
      return !1;
  return !0;
}
function nb(e, t) {
  t === void 0 && (t = rb);
  var r = null;
  function n() {
    for (var a = [], i = 0; i < arguments.length; i++)
      a[i] = arguments[i];
    if (r && r.lastThis === this && t(a, r.lastArgs))
      return r.lastResult;
    var o = e.apply(this, a);
    return r = {
      lastResult: o,
      lastArgs: a,
      lastThis: this
    }, o;
  }
  return n.clear = function() {
    r = null;
  }, n;
}
const vi = [
  "100",
  "200",
  "400",
  "500",
  "700"
].map((e) => `var(--dixa-color-purple-${e})`), ab = nb(
  (e) => {
    if (e === null)
      return {
        backgroundColor: "var(--dixa-color-neutral-000)",
        color: "tertiary"
      };
    const t = Math.min(
      4,
      Math.floor(Math.min(e, 100) * (5 / 100))
    );
    return {
      backgroundColor: (vi == null ? void 0 : vi[t]) ?? "var(--dixa-color-neutral-000)",
      color: t >= 3 ? "white" : "primary"
    };
  }
);
function ib(e) {
  return typeof e == "number" && !Number.isNaN(e) && e >= 0;
}
const ob = (e) => {
  const t = e.flatMap(({ data: a }) => a.map((i) => yo(i).value)).filter(ib), r = Math.min(...t), n = Math.max(...t);
  return { min: r, max: n };
}, sb = (e, { min: t, max: r }) => t === r ? 100 : Math.round(100 * (e - t) / (r - t)), sy = ({
  instrument: e
}) => {
  const {
    data: { categories: t, series: r }
  } = e, n = oe(null), [a, i] = od({
    cell: null,
    column: null,
    row: null
  }), o = Q(
    () => Object.values(a).some((d) => d !== null),
    [a]
  ), s = Q(() => ob(r), [r]);
  Xi(() => {
    const d = (g) => {
      n.current && !n.current.contains(g.target) && o && i.reset();
    };
    return window.addEventListener("mousemove", d, !0), () => {
      window.removeEventListener("mousemove", d, !0);
    };
  }, [o, i]);
  const c = J(
    (d) => {
      if (!o)
        return !1;
      const [g, v] = d;
      return a.cell ? !Hm(a.cell.id, d) : a.column !== null ? a.column !== v : a.row !== null ? a.row !== g : !1;
    },
    [o, a.cell, a.column, a.row]
  ), u = J(
    (d) => i.setAll({
      cell: null,
      column: d,
      row: null
    }),
    [i]
  ), f = J(
    (d) => i.setAll({
      cell: null,
      column: null,
      row: d
    }),
    [i]
  ), l = J(
    (d) => {
      (o || d !== null) && i.setAll({
        cell: d,
        column: null,
        row: null
      });
    },
    [o, i]
  ), h = J(() => {
    o && i.reset();
  }, [o, i]);
  return /* @__PURE__ */ _.jsxs(
    "div",
    {
      ref: n,
      className: hi.grid,
      onMouseLeave: () => i.reset(),
      "data-testid": "heatmap-instrument",
      children: [
        /* @__PURE__ */ _.jsxs("div", { className: hi.row, children: [
          /* @__PURE__ */ _.jsx(zt, { onMouseEnter: h }),
          r.map((d, g) => {
            const v = r[g].metrics ?? [];
            return /* @__PURE__ */ _.jsx(
              zt,
              {
                cell: { id: [0, g], value: d.label },
                tooltipProps: {
                  enabled: v.length > 0,
                  title: d.label,
                  metrics: v
                },
                onMouseEnter: () => u(g)
              },
              d.label
            );
          })
        ] }),
        t.map((d, g) => {
          const v = t[g].metrics ?? [];
          return /* @__PURE__ */ _.jsxs("div", { className: hi.row, children: [
            /* @__PURE__ */ _.jsx(
              zt,
              {
                cell: { id: [g, 0], value: d.label },
                tooltipProps: {
                  enabled: v.length > 0,
                  title: d.label,
                  metrics: v
                },
                onMouseEnter: () => f(g)
              }
            ),
            r.map((m, b) => {
              var x;
              const y = [g, b], { value: S, metrics: R } = yo(
                m.data[g]
              ), P = ((x = m.options) == null ? void 0 : x.format) ?? "number", O = Af(S), { backgroundColor: T, color: w } = ab(
                O ? sb(S, s) : null
              );
              return /* @__PURE__ */ _.jsx(
                zt,
                {
                  cell: { id: y, value: S, format: P },
                  dimmed: c(y),
                  background: T,
                  tooltipProps: {
                    enabled: O,
                    title: `${d.label}, ${m.label}`,
                    metrics: R != null && R.length ? R : [
                      {
                        type: "metric",
                        title: "Total",
                        data: S,
                        format: P === "count" ? "number" : P
                      }
                    ]
                  },
                  textProps: { color: w },
                  onMouseEnter: () => l(O ? { id: y, value: S } : null)
                },
                y.join(",")
              );
            })
          ] }, d.label);
        })
      ]
    }
  );
}, cb = "_legend_1myv8_34", ub = "_trigger_1myv8_38", lb = "_popover_1myv8_44", fb = "_breakdown_1myv8_63", Wt = {
  legend: cb,
  trigger: ub,
  popover: lb,
  breakdown: fb
}, cy = we(function({
  instrument: t
}) {
  const {
    data: { availability: r, media_type: n, away: a }
  } = t, i = [
    "var(--dixa-color-purple-700)",
    "var(--dixa-color-neutral-200)"
  ], o = "No data available", s = {
    // Primitive way to ensure the labels are the same width, by deriving it from the longest
    // The number 7 is roughly the average width of a lowercase character
    labelWidth: Math.max(...n.map((l) => l.label.length)) * 7,
    theme: i
  }, c = () => /* @__PURE__ */ _.jsx(
    Xt,
    {
      ...s,
      value: 0,
      label: "n.a.",
      theme: ["var(--dixa-color-neutral-200)", "var(--dixa-color-neutral-200)"],
      showFullBar: !0
    }
  ), u = () => {
    if (!a || !a.length) return null;
    const [l, h, ...d] = a;
    return /* @__PURE__ */ _.jsxs(rf, { children: [
      /* @__PURE__ */ _.jsx(nf, { asChild: !0, children: /* @__PURE__ */ _.jsx("div", { className: Wt.trigger, children: /* @__PURE__ */ _.jsx(Ji, { variant: "tertiary", icon: "dots-h" }) }) }),
      /* @__PURE__ */ _.jsx(af, { children: /* @__PURE__ */ _.jsx(of, { side: "right", className: Wt.popover, children: /* @__PURE__ */ _.jsxs("ul", { className: Wt.breakdown, children: [
        /* @__PURE__ */ _.jsxs("li", { children: [
          /* @__PURE__ */ _.jsx(G.Paragraph, { variant: "1", children: l.label }),
          /* @__PURE__ */ _.jsx(G.Paragraph, { variant: "1", children: Ge(l.value) })
        ] }),
        /* @__PURE__ */ _.jsxs("li", { children: [
          /* @__PURE__ */ _.jsx(G.Paragraph, { variant: "2", subdued: !0, children: h.label }),
          /* @__PURE__ */ _.jsx(G.Paragraph, { variant: "2", subdued: !0, children: Ge(h.value) })
        ] }),
        /* @__PURE__ */ _.jsx(Qf, {}),
        d.map((g, v) => /* @__PURE__ */ _.jsxs("li", { children: [
          /* @__PURE__ */ _.jsx(G.Paragraph, { variant: "2", children: g.label }),
          /* @__PURE__ */ _.jsx(G.Paragraph, { variant: "1", children: Ge(g.value) })
        ] }, v))
      ] }) }) })
    ] });
  }, f = () => /* @__PURE__ */ _.jsxs(X, { gap: "300", className: Wt.legend, children: [
    r.map((l, h) => /* @__PURE__ */ _.jsxs(X, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ _.jsx(
        Zi,
        {
          width: "6px",
          height: "6px",
          background: i[h],
          borderRadius: "50%"
        }
      ),
      /* @__PURE__ */ _.jsx(G.Paragraph, { variant: "4", children: l.label })
    ] }, h)),
    u()
  ] });
  return /* @__PURE__ */ _.jsxs(X, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ _.jsxs(X, { flexDirection: "column", gap: "300", children: [
      /* @__PURE__ */ _.jsx(G.Paragraph, { variant: "4", subdued: !0, children: r.length ? "Availability" : o }),
      r.length ? /* @__PURE__ */ _.jsxs(_.Fragment, { children: [
        f(),
        /* @__PURE__ */ _.jsx(
          Xt,
          {
            ...s,
            value: r[0].value,
            label: "Total",
            showFullBar: !0,
            showDifference: !0
          }
        )
      ] }) : c()
    ] }),
    /* @__PURE__ */ _.jsxs(X, { flexDirection: "column", gap: "300", children: [
      /* @__PURE__ */ _.jsx(G.Paragraph, { variant: "4", subdued: !0, children: n.length ? "Availability per channel" : o }),
      n.length > 0 ? /* @__PURE__ */ _.jsx(X, { flexDirection: "column", gap: "200", children: n.map((l, h) => /* @__PURE__ */ z(
        Xt,
        {
          ...s,
          key: h,
          value: l.value,
          label: l.label
        }
      )) }) : c()
    ] })
  ] });
}), db = "_tooltip_h4i5v_1", hb = "_trigger_h4i5v_5", Wu = {
  tooltip: db,
  trigger: hb
}, vb = ({
  text: e
}) => /* @__PURE__ */ _.jsxs(_.Fragment, { children: [
  /* @__PURE__ */ _.jsx("span", { children: e }),
  /* @__PURE__ */ _.jsx(
    Ot,
    {
      className: Wu.tooltip,
      content: e,
      wrap: "div",
      wrapProps: { className: Wu.trigger }
    }
  )
] }), pb = we(
  function({
    value: t
  }) {
    const [r, ...n] = t;
    return /* @__PURE__ */ _.jsxs(X, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ _.jsx(G.Paragraph, { variant: "2", as: "span", children: r }),
      n.length > 0 && /* @__PURE__ */ _.jsx(Ot, { content: n.join(", "), children: /* @__PURE__ */ _.jsxs(G.ExternalLink, { as: "span", children: [
        "+ ",
        n.length,
        " more"
      ] }) })
    ] });
  }
), gb = ({
  cell: e,
  format: t,
  timezone: r,
  customFormats: n
}) => {
  const a = Q(() => {
    var o;
    if (!e || mb(e.value))
      return /* @__PURE__ */ _.jsx(G.Paragraph, { variant: "2", color: "neutral.500", children: "n.a." });
    const { value: i } = e;
    if (n != null && n[t])
      return (o = n[t]) == null ? void 0 : o.call(n, { value: i });
    switch (t) {
      case "boolean":
        return i ? "Y" : "N";
      case "date":
        return ke.tz(i, r).format("L, LT");
      case "count":
        return sf(i);
      case "number":
        return Et(i);
      case "percentage":
        return `${Et(i)}%`;
      case "duration":
        return Ge(i);
      case "csid":
        return `#${i}`;
      case "rating":
        return `${i}`;
      case "presence":
        return /* @__PURE__ */ _.jsx(Xt, { value: i, showFullBar: !0 });
      case "tags":
        return /* @__PURE__ */ _.jsx(xd, { tags: i, limit: 1 });
      case "text":
        return /* @__PURE__ */ _.jsx(vb, { text: i });
      case "list":
        return /* @__PURE__ */ _.jsx(pb, { value: i });
      case "string":
      default:
        return `${i}`;
    }
  }, [e, n, t, r]);
  return /* @__PURE__ */ _.jsx(_.Fragment, { children: a });
};
function mb(e) {
  const t = e === null, r = typeof e == "string" && e.trim() === "", n = Array.isArray(e) && !e.length;
  return t || r || n;
}
const bb = "_tableWrapper_1xmkm_1", yb = "_tableWrapperEmpty_1xmkm_4", _b = "_thCell_1xmkm_8", xb = "_tdCell_1xmkm_12", wb = "_tooltip_1xmkm_20", wt = {
  tableWrapper: bb,
  tableWrapperEmpty: yb,
  thCell: _b,
  tdCell: xb,
  tooltip: wb
};
var pi, Gu;
function Rb() {
  if (Gu) return pi;
  Gu = 1;
  function e(t) {
    return t == null;
  }
  return pi = e, pi;
}
var Cb = Rb();
const Sb = /* @__PURE__ */ Ee(Cb);
var gi, Ku;
function Pb() {
  if (Ku) return gi;
  Ku = 1;
  var e = Sf(), t = wo(), r = 1, n = 2;
  function a(i, o, s, c) {
    var u = s.length, f = u, l = !c;
    if (i == null)
      return !f;
    for (i = Object(i); u--; ) {
      var h = s[u];
      if (l && h[2] ? h[1] !== i[h[0]] : !(h[0] in i))
        return !1;
    }
    for (; ++u < f; ) {
      h = s[u];
      var d = h[0], g = i[d], v = h[1];
      if (l && h[2]) {
        if (g === void 0 && !(d in i))
          return !1;
      } else {
        var m = new e();
        if (c)
          var b = c(g, v, d, i, o, m);
        if (!(b === void 0 ? t(v, g, r | n, c, m) : b))
          return !1;
      }
    }
    return !0;
  }
  return gi = a, gi;
}
var mi, Yu;
function Tf() {
  if (Yu) return mi;
  Yu = 1;
  var e = Ze();
  function t(r) {
    return r === r && !e(r);
  }
  return mi = t, mi;
}
var bi, Xu;
function Eb() {
  if (Xu) return bi;
  Xu = 1;
  var e = Tf(), t = xo();
  function r(n) {
    for (var a = t(n), i = a.length; i--; ) {
      var o = a[i], s = n[o];
      a[i] = [o, s, e(s)];
    }
    return a;
  }
  return bi = r, bi;
}
var yi, Ju;
function $f() {
  if (Ju) return yi;
  Ju = 1;
  function e(t, r) {
    return function(n) {
      return n == null ? !1 : n[t] === r && (r !== void 0 || t in Object(n));
    };
  }
  return yi = e, yi;
}
var _i, Zu;
function Ob() {
  if (Zu) return _i;
  Zu = 1;
  var e = Pb(), t = Eb(), r = $f();
  function n(a) {
    var i = t(a);
    return i.length == 1 && i[0][2] ? r(i[0][0], i[0][1]) : function(o) {
      return o === a || e(o, a, i);
    };
  }
  return _i = n, _i;
}
var xi, Qu;
function Ab() {
  if (Qu) return xi;
  Qu = 1;
  var e = pr();
  function t(r, n, a) {
    var i = r == null ? void 0 : e(r, n);
    return i === void 0 ? a : i;
  }
  return xi = t, xi;
}
var wi, el;
function Tb() {
  if (el) return wi;
  el = 1;
  var e = wo(), t = Ab(), r = Rf(), n = fo(), a = Tf(), i = $f(), o = It(), s = 1, c = 2;
  function u(f, l) {
    return n(f) && a(l) ? i(o(f), l) : function(h) {
      var d = t(h, f);
      return d === void 0 && d === l ? r(h, f) : e(l, d, s | c);
    };
  }
  return wi = u, wi;
}
var Ri, tl;
function $b() {
  if (tl) return Ri;
  tl = 1;
  var e = pr();
  function t(r) {
    return function(n) {
      return e(n, r);
    };
  }
  return Ri = t, Ri;
}
var Ci, rl;
function qb() {
  if (rl) return Ci;
  rl = 1;
  var e = pf(), t = $b(), r = fo(), n = It();
  function a(i) {
    return r(i) ? e(n(i)) : t(i);
  }
  return Ci = a, Ci;
}
var Si, nl;
function jb() {
  if (nl) return Si;
  nl = 1;
  var e = Ob(), t = Tb(), r = gr(), n = Ce(), a = qb();
  function i(o) {
    return typeof o == "function" ? o : o == null ? r : typeof o == "object" ? n(o) ? t(o[0], o[1]) : e(o) : a(o);
  }
  return Si = i, Si;
}
var Pi, al;
function Ib() {
  if (al) return Pi;
  al = 1;
  function e(t) {
    return function(r, n, a) {
      for (var i = -1, o = Object(r), s = a(r), c = s.length; c--; ) {
        var u = s[t ? c : ++i];
        if (n(o[u], u, o) === !1)
          break;
      }
      return r;
    };
  }
  return Pi = e, Pi;
}
var Ei, il;
function Mb() {
  if (il) return Ei;
  il = 1;
  var e = Ib(), t = e();
  return Ei = t, Ei;
}
var Oi, ol;
function Db() {
  if (ol) return Oi;
  ol = 1;
  var e = Mb(), t = xo();
  function r(n, a) {
    return n && e(n, a, t);
  }
  return Oi = r, Oi;
}
var Ai, sl;
function Nb() {
  if (sl) return Ai;
  sl = 1;
  var e = _o();
  function t(r, n) {
    return function(a, i) {
      if (a == null)
        return a;
      if (!e(a))
        return r(a, i);
      for (var o = a.length, s = n ? o : -1, c = Object(a); (n ? s-- : ++s < o) && i(c[s], s, c) !== !1; )
        ;
      return a;
    };
  }
  return Ai = t, Ai;
}
var Ti, cl;
function Fb() {
  if (cl) return Ti;
  cl = 1;
  var e = Db(), t = Nb(), r = t(e);
  return Ti = r, Ti;
}
var $i, ul;
function Lb() {
  if (ul) return $i;
  ul = 1;
  var e = Fb(), t = _o();
  function r(n, a) {
    var i = -1, o = t(n) ? Array(n.length) : [];
    return e(n, function(s, c, u) {
      o[++i] = a(s, c, u);
    }), o;
  }
  return $i = r, $i;
}
var qi, ll;
function kb() {
  if (ll) return qi;
  ll = 1;
  function e(t, r) {
    var n = t.length;
    for (t.sort(r); n--; )
      t[n] = t[n].value;
    return t;
  }
  return qi = e, qi;
}
var ji, fl;
function Bb() {
  if (fl) return ji;
  fl = 1;
  var e = jt();
  function t(r, n) {
    if (r !== n) {
      var a = r !== void 0, i = r === null, o = r === r, s = e(r), c = n !== void 0, u = n === null, f = n === n, l = e(n);
      if (!u && !l && !s && r > n || s && c && f && !u && !l || i && c && f || !a && f || !o)
        return 1;
      if (!i && !s && !l && r < n || l && a && o && !i && !s || u && a && o || !c && o || !f)
        return -1;
    }
    return 0;
  }
  return ji = t, ji;
}
var Ii, dl;
function Vb() {
  if (dl) return Ii;
  dl = 1;
  var e = Bb();
  function t(r, n, a) {
    for (var i = -1, o = r.criteria, s = n.criteria, c = o.length, u = a.length; ++i < c; ) {
      var f = e(o[i], s[i]);
      if (f) {
        if (i >= u)
          return f;
        var l = a[i];
        return f * (l == "desc" ? -1 : 1);
      }
    }
    return r.index - n.index;
  }
  return Ii = t, Ii;
}
var Mi, hl;
function Hb() {
  if (hl) return Mi;
  hl = 1;
  var e = df(), t = pr(), r = jb(), n = Lb(), a = kb(), i = lo(), o = Vb(), s = gr(), c = Ce();
  function u(f, l, h) {
    l.length ? l = e(l, function(v) {
      return c(v) ? function(m) {
        return t(m, v.length === 1 ? v[0] : v);
      } : v;
    }) : l = [s];
    var d = -1;
    l = e(l, i(r));
    var g = n(f, function(v, m, b) {
      var y = e(l, function(S) {
        return S(v);
      });
      return { criteria: y, index: ++d, value: v };
    });
    return a(g, function(v, m) {
      return o(v, m, h);
    });
  }
  return Mi = u, Mi;
}
var Di, vl;
function Ub() {
  if (vl) return Di;
  vl = 1;
  var e = Hb(), t = Ce();
  function r(n, a, i, o) {
    return n == null ? [] : (t(a) || (a = a == null ? [] : [a]), i = o ? void 0 : i, t(i) || (i = i == null ? [] : [i]), e(n, a, i));
  }
  return Di = r, Di;
}
var zb = Ub();
const Wb = /* @__PURE__ */ Ee(zb), pl = (e, t) => {
  var r;
  return (r = e.cells.find((n) => n.column === t.key)) == null ? void 0 : r.value;
}, Gb = ({
  data: { columns: e, rows: t },
  limit: r = 50,
  sortStatus: n
}) => {
  const i = Math.ceil(t.length / r), [o, s] = ee(1);
  At(() => {
    o !== 1 && s(1);
  }, [n, i]);
  const c = Q(() => {
    if (!n) return t;
    const f = e.find(({ key: l }) => l === n.sortBy);
    return f ? Wb(
      t,
      [
        (l) => !Sb(pl(l, f)),
        (l) => pl(l, f)
      ],
      ["desc", n.direction]
    ) : t;
  }, [e, t, n]);
  return {
    rows: Q(
      () => c.slice((o - 1) * r, o * r),
      [o, r, c]
    ),
    currentPage: o,
    totalPages: i,
    setPage: s
  };
}, uy = ({
  instrument: e,
  timezone: t,
  onReadInstruments: r,
  onLoadAll: n,
  onSortChange: a,
  customFormats: i
}) => {
  const {
    title: o,
    data: s,
    data: { columns: c, options: u }
  } = e, [f, l] = ee(null), h = oe(null), d = (u == null ? void 0 : u.limit) ?? 50, { rows: g, currentPage: v, totalPages: m, setPage: b } = Gb({
    data: s,
    limit: d,
    sortStatus: f
  }), y = s.rows.length === 0, S = !!(u != null && u.next_page), R = !S && m > 1;
  At(() => {
    h.current && (h.current.scrollTop = 0);
  }, [v]);
  const P = J(() => (n == null || n(), r({
    meta: {
      pagination: {
        limit: null
      }
    }
  })), [n, r]), O = J(
    async (T) => {
      S && await P(), l(T), a == null || a(T);
    },
    [P, a, S]
  );
  return /* @__PURE__ */ _.jsxs(_.Fragment, { children: [
    o && /* @__PURE__ */ _.jsx("div", { children: /* @__PURE__ */ _.jsx(G.Heading, { variant: "heading-4", children: o }) }),
    /* @__PURE__ */ _.jsxs(
      Re,
      {
        stickyHeader: !0,
        sortingProps: {
          sortStatus: f,
          onSortChange: O
        },
        wrapperProps: {
          className: $e(wt.tableWrapper, {
            [wt.tableWrapperEmpty]: y
          })
        },
        wrapperRef: h,
        hoverable: !y,
        children: [
          /* @__PURE__ */ _.jsx(Re.Thead, { children: /* @__PURE__ */ _.jsx(Re.Tr, { children: c.map(({ key: T, label: w, sortable: x }) => /* @__PURE__ */ _.jsx(
            Re.Th,
            {
              className: wt.thCell,
              columnId: x ? T : null,
              children: w
            },
            w
          )) }) }),
          /* @__PURE__ */ _.jsxs(Re.Tbody, { children: [
            y && /* @__PURE__ */ _.jsx(Re.Tr, { children: /* @__PURE__ */ _.jsx(Re.Td, { colSpan: c.length, children: /* @__PURE__ */ _.jsx(
              _l,
              {
                title: "No data available",
                description: "There is no data available for the selected period and filters.",
                icon: "th"
              }
            ) }) }),
            g.map((T, w) => {
              const x = `row-${w}`;
              return /* @__PURE__ */ _.jsx(Re.Tr, { children: c.map(({ key: E, format: C }, j) => {
                const $ = T.cells.find((I) => I.column === E);
                return /* @__PURE__ */ _.jsx(
                  Re.Td,
                  {
                    className: wt.tdCell,
                    children: /* @__PURE__ */ _.jsx(
                      gb,
                      {
                        cell: $,
                        format: C,
                        timezone: t,
                        customFormats: i
                      }
                    )
                  },
                  `${x}-cell-${j}`
                );
              }) }, x);
            })
          ] }),
          S && /* @__PURE__ */ _.jsx(Re.Footer, { children: /* @__PURE__ */ _.jsxs(X, { alignItems: "center", justifyContent: "center", gap: "300", children: [
            /* @__PURE__ */ _.jsxs(X, { gap: "100", alignItems: "center", children: [
              /* @__PURE__ */ _.jsx(
                ed,
                {
                  tooltipClassName: wt.tooltip,
                  text: `By default we only load the first ${d} results. If you need to see all available results, click on the button, but beware that this may take a bit of time to load depending on the number of results.`
                }
              ),
              /* @__PURE__ */ _.jsxs(G.Paragraph, { variant: "2", children: [
                "Showing only the ",
                /* @__PURE__ */ _.jsxs("b", { children: [
                  "first ",
                  d,
                  " results"
                ] })
              ] })
            ] }),
            /* @__PURE__ */ _.jsx(yl, { variant: "secondary", onClick: P, children: "Load all results" })
          ] }) }),
          R && /* @__PURE__ */ _.jsx(Re.Footer, { children: /* @__PURE__ */ _.jsx(X, { alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ _.jsx(
            td,
            {
              pageCount: m,
              currentPage: v,
              pageRangeDisplayed: 6,
              onPageChange: b
            }
          ) }) })
        ]
      }
    )
  ] });
};
export {
  ay as AnalyticsMenu,
  oy as ChartInstrument,
  sy as HeatmapInstrument,
  lf as MetricInstrument,
  _p as MetricInstrumentData,
  Ki as MetricInstrumentsGrid,
  Xt as PercentageBar,
  cy as PresenceInstrument,
  uy as TableInstrument,
  iy as categorizeInstruments,
  lt as chartAppearance,
  sf as formatAbbreviateNumber,
  $t as formatInstrumentNumber,
  Et as formatLocalizedNumber,
  Ge as formatMillisecondsToDuration,
  yo as getChartSeriesValue,
  pp as isAIInsightInstrument,
  fp as isChartInstrument,
  dp as isHeatmapInstrument,
  lp as isMetricInstrument,
  vp as isPresenceInstrument,
  hp as isTableInstrument,
  Jt as resolveChartElementColor,
  uf as resolveInstrumentColor
};
//# sourceMappingURL=index.js.map
